var Lo = Object.defineProperty;
var Io = (e, t, n) => t in e ? Lo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ct = (e, t, n) => Io(e, typeof t != "symbol" ? t + "" : t, n);
function $() {
}
function Wt(e, t) {
  for (const n in t) e[n] = t[n];
  return (
    /** @type {T & S} */
    e
  );
}
function to(e) {
  return e();
}
function rn() {
  return /* @__PURE__ */ Object.create(null);
}
function Se(e) {
  e.forEach(to);
}
function se(e) {
  return typeof e == "function";
}
function ae(e, t) {
  return e != e ? t == t : e !== t || e && typeof e == "object" || typeof e == "function";
}
function Co(e) {
  return Object.keys(e).length === 0;
}
function no(e, ...t) {
  if (e == null) {
    for (const o of t)
      o(void 0);
    return $;
  }
  const n = e.subscribe(...t);
  return n.unsubscribe ? () => n.unsubscribe() : n;
}
function Ot(e, t, n) {
  e.$$.on_destroy.push(no(t, n));
}
function Oo(e, t, n, o) {
  if (e) {
    const s = oo(e, t, n, o);
    return e[0](s);
  }
}
function oo(e, t, n, o) {
  return e[1] && o ? Wt(n.ctx.slice(), e[1](o(t))) : n.ctx;
}
function Do(e, t, n, o) {
  if (e[2] && o) {
    const s = e[2](o(n));
    if (t.dirty === void 0)
      return s;
    if (typeof s == "object") {
      const i = [], l = Math.max(t.dirty.length, s.length);
      for (let r = 0; r < l; r += 1)
        i[r] = t.dirty[r] | s[r];
      return i;
    }
    return t.dirty | s;
  }
  return t.dirty;
}
function No(e, t, n, o, s, i) {
  if (s) {
    const l = oo(t, n, o, i);
    e.p(l, s);
  }
}
function Bo(e) {
  if (e.ctx.length > 32) {
    const t = [], n = e.ctx.length / 32;
    for (let o = 0; o < n; o++)
      t[o] = -1;
    return t;
  }
  return -1;
}
function ln(e) {
  const t = {};
  for (const n in e) n[0] !== "$" && (t[n] = e[n]);
  return t;
}
function We(e) {
  return e ?? "";
}
function G(e, t) {
  e.appendChild(t);
}
function R(e, t, n) {
  e.insertBefore(t, n || null);
}
function B(e) {
  e.parentNode && e.parentNode.removeChild(e);
}
function He(e, t) {
  for (let n = 0; n < e.length; n += 1)
    e[n] && e[n].d(t);
}
function I(e) {
  return document.createElementNS("http://www.w3.org/2000/svg", e);
}
function so(e) {
  return document.createTextNode(e);
}
function we() {
  return so(" ");
}
function ke() {
  return so("");
}
function J(e, t, n, o) {
  return e.addEventListener(t, n, o), () => e.removeEventListener(t, n, o);
}
function c(e, t, n) {
  n == null ? e.removeAttribute(t) : e.getAttribute(t) !== n && e.setAttribute(t, n);
}
function Ro(e) {
  return Array.from(e.childNodes);
}
function Te(e, t, n) {
  e.classList.toggle(t, !!n);
}
function Yo(e, t, { bubbles: n = !1, cancelable: o = !1 } = {}) {
  return new CustomEvent(e, { detail: t, bubbles: n, cancelable: o });
}
let tt;
function et(e) {
  tt = e;
}
function io() {
  if (!tt) throw new Error("Function called outside component initialization");
  return tt;
}
function Re(e) {
  io().$$.on_mount.push(e);
}
function Ye() {
  const e = io();
  return (t, n, { cancelable: o = !1 } = {}) => {
    const s = e.$$.callbacks[t];
    if (s) {
      const i = Yo(
        /** @type {string} */
        t,
        n,
        { cancelable: o }
      );
      return s.slice().forEach((l) => {
        l.call(e, i);
      }), !i.defaultPrevented;
    }
    return !0;
  };
}
function de(e, t) {
  const n = e.$$.callbacks[t.type];
  n && n.slice().forEach((o) => o.call(this, t));
}
const qe = [], Et = [];
let Ze = [];
const an = [], ro = /* @__PURE__ */ Promise.resolve();
let Zt = !1;
function lo() {
  Zt || (Zt = !0, ro.then(co));
}
function ao() {
  return lo(), ro;
}
function Jt(e) {
  Ze.push(e);
}
const Dt = /* @__PURE__ */ new Set();
let je = 0;
function co() {
  if (je !== 0)
    return;
  const e = tt;
  do {
    try {
      for (; je < qe.length; ) {
        const t = qe[je];
        je++, et(t), Uo(t.$$);
      }
    } catch (t) {
      throw qe.length = 0, je = 0, t;
    }
    for (et(null), qe.length = 0, je = 0; Et.length; ) Et.pop()();
    for (let t = 0; t < Ze.length; t += 1) {
      const n = Ze[t];
      Dt.has(n) || (Dt.add(n), n());
    }
    Ze.length = 0;
  } while (qe.length);
  for (; an.length; )
    an.pop()();
  Zt = !1, Dt.clear(), et(e);
}
function Uo(e) {
  if (e.fragment !== null) {
    e.update(), Se(e.before_update);
    const t = e.dirty;
    e.dirty = [-1], e.fragment && e.fragment.p(e.ctx, t), e.after_update.forEach(Jt);
  }
}
function Vo(e) {
  const t = [], n = [];
  Ze.forEach((o) => e.indexOf(o) === -1 ? t.push(o) : n.push(o)), n.forEach((o) => o()), Ze = t;
}
const _t = /* @__PURE__ */ new Set();
let Xe;
function be() {
  Xe = {
    r: 0,
    c: [],
    p: Xe
    // parent group
  };
}
function Ee() {
  Xe.r || Se(Xe.c), Xe = Xe.p;
}
function U(e, t) {
  e && e.i && (_t.delete(e), e.i(t));
}
function H(e, t, n, o) {
  if (e && e.o) {
    if (_t.has(e)) return;
    _t.add(e), Xe.c.push(() => {
      _t.delete(e), o && (n && e.d(1), o());
    }), e.o(t);
  } else o && o();
}
function ve(e) {
  return (e == null ? void 0 : e.length) !== void 0 ? e : Array.from(e);
}
function ce(e) {
  e && e.c();
}
function re(e, t, n) {
  const { fragment: o, after_update: s } = e.$$;
  o && o.m(t, n), Jt(() => {
    const i = e.$$.on_mount.map(to).filter(se);
    e.$$.on_destroy ? e.$$.on_destroy.push(...i) : Se(i), e.$$.on_mount = [];
  }), s.forEach(Jt);
}
function le(e, t) {
  const n = e.$$;
  n.fragment !== null && (Vo(n.after_update), Se(n.on_destroy), n.fragment && n.fragment.d(t), n.on_destroy = n.fragment = null, n.ctx = []);
}
function Xo(e, t) {
  e.$$.dirty[0] === -1 && (qe.push(e), lo(), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31;
}
function _e(e, t, n, o, s, i, l = null, r = [-1]) {
  const a = tt;
  et(e);
  const u = e.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: i,
    update: $,
    not_equal: s,
    bound: rn(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(t.context || (a ? a.$$.context : [])),
    // everything else
    callbacks: rn(),
    dirty: r,
    skip_bound: !1,
    root: t.target || a.$$.root
  };
  l && l(u.root);
  let d = !1;
  if (u.ctx = n ? n(e, t.props || {}, (f, g, ...h) => {
    const p = h.length ? h[0] : g;
    return u.ctx && s(u.ctx[f], u.ctx[f] = p) && (!u.skip_bound && u.bound[f] && u.bound[f](p), d && Xo(e, f)), g;
  }) : [], u.update(), d = !0, Se(u.before_update), u.fragment = o ? o(u.ctx) : !1, t.target) {
    if (t.hydrate) {
      const f = Ro(t.target);
      u.fragment && u.fragment.l(f), f.forEach(B);
    } else
      u.fragment && u.fragment.c();
    t.intro && U(e.$$.fragment), re(e, t.target, t.anchor), co();
  }
  et(a);
}
class ye {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    Ct(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    Ct(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    le(this, 1), this.$destroy = $;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(t, n) {
    if (!se(n))
      return $;
    const o = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
    return o.push(n), () => {
      const s = o.indexOf(n);
      s !== -1 && o.splice(s, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(t) {
    this.$$set && !Co(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
  }
}
const Ho = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(Ho);
var Q = /* @__PURE__ */ ((e) => (e.ELLIPSE = "ELLIPSE", e.MULTIPOLYGON = "MULTIPOLYGON", e.POLYGON = "POLYGON", e.POLYLINE = "POLYLINE", e.RECTANGLE = "RECTANGLE", e.LINE = "LINE", e))(Q || {});
function Go(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var uo = { exports: {} };
(function(e) {
  (function() {
    function t(r, a) {
      var u = r.x - a.x, d = r.y - a.y;
      return u * u + d * d;
    }
    function n(r, a, u) {
      var d = a.x, f = a.y, g = u.x - d, h = u.y - f;
      if (g !== 0 || h !== 0) {
        var p = ((r.x - d) * g + (r.y - f) * h) / (g * g + h * h);
        p > 1 ? (d = u.x, f = u.y) : p > 0 && (d += g * p, f += h * p);
      }
      return g = r.x - d, h = r.y - f, g * g + h * h;
    }
    function o(r, a) {
      for (var u = r[0], d = [u], f, g = 1, h = r.length; g < h; g++)
        f = r[g], t(f, u) > a && (d.push(f), u = f);
      return u !== f && d.push(f), d;
    }
    function s(r, a, u, d, f) {
      for (var g = d, h, p = a + 1; p < u; p++) {
        var y = n(r[p], r[a], r[u]);
        y > g && (h = p, g = y);
      }
      g > d && (h - a > 1 && s(r, a, h, d, f), f.push(r[h]), u - h > 1 && s(r, h, u, d, f));
    }
    function i(r, a) {
      var u = r.length - 1, d = [r[0]];
      return s(r, 0, u, a, d), d.push(r[u]), d;
    }
    function l(r, a, u) {
      if (r.length <= 2) return r;
      var d = a !== void 0 ? a * a : 1;
      return r = u ? r : o(r, d), r = i(r, d), r;
    }
    e.exports = l, e.exports.default = l;
  })();
})(uo);
var jo = uo.exports;
const Fo = /* @__PURE__ */ Go(jo), en = {}, Je = (e, t) => en[e] = t, Qt = (e) => en[e.type].area(e), zo = (e, t, n, o) => en[e.type].intersects(e, t, n, o), fe = (e) => {
  let t = 1 / 0, n = 1 / 0, o = -1 / 0, s = -1 / 0;
  return e.forEach(([i, l]) => {
    t = Math.min(t, i), n = Math.min(n, l), o = Math.max(o, i), s = Math.max(s, l);
  }), { minX: t, minY: n, maxX: o, maxY: s };
}, vt = (e) => {
  let t = 0, n = e.length - 1;
  for (let o = 0; o < e.length; o++)
    t += (e[n][0] + e[o][0]) * (e[n][1] - e[o][1]), n = o;
  return Math.abs(0.5 * t);
}, At = (e, t, n) => {
  let o = !1;
  for (let s = 0, i = e.length - 1; s < e.length; i = s++) {
    const l = e[s][0], r = e[s][1], a = e[i][0], u = e[i][1];
    r > n != u > n && t < (a - l) * (n - r) / (u - r) + l && (o = !o);
  }
  return o;
}, qo = (e, t = !0) => {
  let n = "M ";
  return e.forEach(([o, s], i) => {
    i === 0 ? n += `${o},${s}` : n += ` L ${o},${s}`;
  }), t && (n += " Z"), n;
}, fo = (e, t = 1) => {
  const n = e.map(([o, s]) => ({ x: o, y: s }));
  return Fo(n, t, !0).map((o) => [o.x, o.y]);
}, yt = (e, t) => {
  const n = Math.abs(t[0] - e[0]), o = Math.abs(t[1] - e[1]);
  return Math.sqrt(Math.pow(n, 2) + Math.pow(o, 2));
}, Ko = {
  area: (e) => Math.PI * e.geometry.rx * e.geometry.ry,
  intersects: (e, t, n) => {
    const { cx: o, cy: s, rx: i, ry: l } = e.geometry, r = 0, a = Math.cos(r), u = Math.sin(r), d = t - o, f = n - s, g = a * d + u * f, h = u * d - a * f;
    return g * g / (i * i) + h * h / (l * l) <= 1;
  }
};
Je(Q.ELLIPSE, Ko);
const Wo = {
  area: (e) => 0,
  intersects: (e, t, n, o = 2) => {
    const [[s, i], [l, r]] = e.geometry.points, a = Math.abs((r - i) * t - (l - s) * n + l * i - r * s), u = yt([s, i], [l, r]);
    return a / u <= o;
  }
};
Je(Q.LINE, Wo);
const Zo = {
  area: (e) => {
    const { polygons: t } = e.geometry;
    return t.reduce((n, o) => {
      const [s, ...i] = o.rings, l = vt(s.points), r = i.reduce((a, u) => a + vt(u.points), 0);
      return n + l - r;
    }, 0);
  },
  intersects: (e, t, n) => {
    const { polygons: o } = e.geometry;
    for (const s of o) {
      const [i, ...l] = s.rings;
      if (At(i.points, t, n)) {
        let r = !1;
        for (const a of l)
          if (At(a.points, t, n)) {
            r = !0;
            break;
          }
        if (!r) return !0;
      }
    }
    return !1;
  }
}, wt = (e) => {
  const t = e.reduce((n, o) => [...n, ...o.rings[0].points], []);
  return fe(t);
}, Pe = (e) => e.rings.map((n) => qo(n.points)).join(" "), Jo = (e) => e.polygons.reduce((t, n) => [
  ...t,
  ...n.rings.reduce((o, s) => [...o, ...s.points], [])
], []), xr = (e, t = 1) => {
  const n = e.geometry.polygons.map((s) => {
    const i = s.rings.map((r) => {
      const a = fo(r.points, t);
      return {
        ...r,
        points: a
      };
    }), l = fe(i[0].points);
    return {
      ...s,
      rings: i,
      bounds: l
    };
  }), o = wt(n);
  return {
    ...e,
    geometry: {
      ...e.geometry,
      polygons: n,
      bounds: o
    }
  };
};
Je(Q.MULTIPOLYGON, Zo);
const Qo = {
  area: (e) => {
    const t = e.geometry.points;
    return vt(t);
  },
  intersects: (e, t, n) => {
    const o = e.geometry.points;
    return At(o, t, n);
  }
}, $r = (e, t = 1) => {
  const n = fo(e.geometry.points, t), o = fe(n);
  return {
    ...e,
    geometry: {
      ...e.geometry,
      bounds: o,
      points: n
    }
  };
};
Je(Q.POLYGON, Qo);
const xo = {
  area: (e) => {
    const t = e.geometry;
    if (!t.closed || t.points.length < 3)
      return 0;
    const n = xt(t.points, t.closed);
    return vt(n);
  },
  intersects: (e, t, n, o = 2) => {
    const s = e.geometry;
    if (s.closed) {
      const i = xt(s.points, s.closed);
      return At(i, t, n);
    } else
      return $o(s, [t, n], o);
  }
}, xt = (e, t = !1) => {
  const n = [];
  for (let o = 0; o < e.length; o++) {
    const s = e[o], i = e[(o + 1) % e.length];
    if (n.push(s.point), (o < e.length - 1 || t) && (s.type === "CURVE" || i.type == "CURVE")) {
      const r = go(
        s.point,
        s.type === "CURVE" && s.outHandle || s.point,
        i.type === "CURVE" && i.inHandle || i.point,
        i.point,
        10
        // number of approximation segments
      );
      n.push(...r.slice(1));
    }
  }
  return n;
}, go = (e, t, n, o, s = 10) => {
  const i = [];
  for (let l = 0; l <= s; l++) {
    const r = l / s, a = Math.pow(1 - r, 3) * e[0] + 3 * Math.pow(1 - r, 2) * r * t[0] + 3 * (1 - r) * Math.pow(r, 2) * n[0] + Math.pow(r, 3) * o[0], u = Math.pow(1 - r, 3) * e[1] + 3 * Math.pow(1 - r, 2) * r * t[1] + 3 * (1 - r) * Math.pow(r, 2) * n[1] + Math.pow(r, 3) * o[1];
    i.push([a, u]);
  }
  return i;
}, $o = (e, t, n) => {
  for (let o = 0; o < e.points.length - 1; o++) {
    const s = e.points[o], i = e.points[o + 1];
    if (s.type === "CURVE" || i.type === "CURVE") {
      const r = go(
        s.point,
        s.type === "CURVE" && s.outHandle || s.point,
        i.type === "CURVE" && i.inHandle || i.point,
        i.point,
        20
        // TODO make configurable? Based on scale factor? Length?
      );
      for (let a = 0; a < r.length - 1; a++)
        if (cn(t, r[a], r[a + 1]) <= n) return !0;
    } else if (cn(t, s.point, i.point) <= n) return !0;
  }
  return !1;
}, cn = (e, t, n) => {
  const [o, s] = e, [i, l] = t, [r, a] = n, u = r - i, d = a - l, f = Math.sqrt(u * u + d * d);
  if (f === 0)
    return Math.sqrt((o - i) * (o - i) + (s - l) * (s - l));
  const g = ((o - i) * u + (s - l) * d) / (f * f);
  return g <= 0 ? Math.sqrt((o - i) * (o - i) + (s - l) * (s - l)) : g >= 1 ? Math.sqrt((o - r) * (o - r) + (s - a) * (s - a)) : Math.abs((a - l) * o - (r - i) * s + r * l - a * i) / f;
}, ho = (e) => {
  if (!e.points || e.points.length === 0)
    return "";
  const t = [], n = e.points[0];
  t.push(`M ${n.point[0]} ${n.point[1]}`);
  for (let o = 1; o < e.points.length; o++) {
    const s = e.points[o], i = e.points[o - 1];
    if (s.type === "CURVE" || i.type === "CURVE") {
      const l = i.type === "CURVE" && i.outHandle || i.point, r = s.type === "CURVE" && s.inHandle || s.point, a = s.point;
      t.push(`C ${l[0]} ${l[1]} ${r[0]} ${r[1]} ${a[0]} ${a[1]}`);
    } else
      t.push(`L ${s.point[0]} ${s.point[1]}`);
  }
  if (e.closed) {
    const o = e.points[e.points.length - 1], s = e.points[0];
    if (o.type === "CURVE" || s.type === "CURVE") {
      const l = o.outHandle || o.point, r = s.inHandle || s.point, a = s.point;
      t.push(`C ${l[0]} ${l[1]} ${r[0]} ${r[1]} ${a[0]} ${a[1]}`);
    }
    t.push("Z");
  }
  return t.join(" ");
};
Je(Q.POLYLINE, xo);
const es = {
  area: (e) => e.geometry.w * e.geometry.h,
  intersects: (e, t, n) => {
    const o = e.geometry;
    if (o.rot) {
      const s = o.x + o.w / 2, i = o.y + o.h / 2, l = t - s, r = n - i, a = Math.cos(o.rot), u = Math.sin(o.rot), d = l * a + r * u, f = -l * u + r * a;
      return d >= -o.w / 2 && d <= o.w / 2 && f >= -o.h / 2 && f <= o.h / 2;
    } else
      return t >= o.x && t <= o.x + o.w && n >= o.y && n <= o.y + o.h;
  }
};
Je(Q.RECTANGLE, es);
const St = (e) => bt(e.target), bt = (e) => {
  var t, n;
  return (e == null ? void 0 : e.annotation) !== void 0 && ((n = (t = e == null ? void 0 : e.selector) == null ? void 0 : t.geometry) == null ? void 0 : n.bounds) !== void 0;
}, ts = (e) => (e == null ? void 0 : e.type) === "FragmentSelector" ? !0 : typeof e == "string" ? e.indexOf("#") < 0 ? !1 : /#xywh(?:=(?:pixel:|percent:)?)(.+?),(.+?),(.+?),(.+)$/i.test(e) : !1, ns = (e, t = !1) => {
  const n = typeof e == "string" ? e : e.value, o = /(xywh)=(?:(pixel|percent):)?:?(.+?),(.+?),(.+?),(.+)*/g, s = [...n.matchAll(o)][0];
  if (!s) throw new Error("Not a MediaFragment: " + n);
  const [i, l, r, a, u, d, f] = s;
  if (l !== "xywh") throw new Error("Unsupported MediaFragment: " + n);
  if (r && r !== "pixel") throw new Error(`Unsupported MediaFragment unit: ${r}`);
  const [g, h, p, y] = [a, u, d, f].map(parseFloat);
  return {
    type: Q.RECTANGLE,
    geometry: {
      x: g,
      y: h,
      w: p,
      h: y,
      rot: 0,
      bounds: {
        minX: g,
        minY: t ? h - y : h,
        maxX: g + p,
        maxY: t ? h : h + y
      }
    }
  };
}, os = (e) => {
  const { x: t, y: n, w: o, h: s } = e;
  return {
    type: "FragmentSelector",
    conformsTo: "http://www.w3.org/TR/media-frags/",
    value: `xywh=pixel:${t},${n},${o},${s}`
  };
}, mo = "http://www.w3.org/2000/svg", un = (e) => {
  const t = (o) => {
    Array.from(o.attributes).forEach((s) => {
      s.name.startsWith("on") && o.removeAttribute(s.name);
    });
  }, n = e.getElementsByTagName("script");
  return Array.from(n).reverse().forEach((o) => o.parentNode.removeChild(o)), Array.from(e.querySelectorAll("*")).forEach(t), e;
}, ss = (e) => {
  const o = new XMLSerializer().serializeToString(e.documentElement).replace("<svg>", `<svg xmlns="${mo}">`);
  return new DOMParser().parseFromString(o, "image/svg+xml").documentElement;
}, st = (e) => {
  const n = new DOMParser().parseFromString(e, "image/svg+xml"), o = n.lookupPrefix(mo), s = n.lookupNamespaceURI(null);
  return o || s ? un(n).firstChild : un(ss(n)).firstChild;
}, is = (e) => {
  const t = po(e), n = [];
  let o = [], s = [0, 0];
  for (const i of t)
    switch (i.type.toUpperCase()) {
      case "M":
        o.length > 0 && (n.push({ points: o }), o = []), s = [i.args[0], i.args[1]], o.push([...s]);
        break;
      case "L":
        s = [i.args[0], i.args[1]], o.push([...s]);
        break;
      case "H":
        s = [i.args[0], s[1]], o.push([...s]);
        break;
      case "V":
        s = [s[0], i.args[0]], o.push([...s]);
        break;
      case "C":
        s = [i.args[4], i.args[5]], o.push([...s]);
        break;
      case "Z":
        break;
      default:
        console.warn(`Unsupported SVG path command: ${i.type}`);
        break;
    }
  if (o.length > 2 && n.push({ points: o }), n.length > 0) {
    const i = fe(n[0].points);
    return { rings: n, bounds: i };
  }
}, rs = (e) => {
  const { point: t, inHandle: n, outHandle: o } = e;
  if (!n || !o) return !1;
  const s = n[0] - t[0], i = n[1] - t[1], l = o[0] - t[0], r = o[1] - t[1], a = s * r - i * l;
  return Math.abs(a) < 0.01;
}, ls = (e) => {
  const t = po(e);
  let n = [], o = [0, 0], s = !1;
  for (let l = 0; l < t.length; l++) {
    const r = t[l];
    switch (r.type.toUpperCase()) {
      case "M":
        o = [r.args[0], r.args[1]], n.push({
          type: "CORNER",
          point: [...o]
        });
        break;
      case "L":
        o = [r.args[0], r.args[1]], n.push({
          type: "CORNER",
          point: [...o]
        });
        break;
      case "C":
        const a = [r.args[0], r.args[1]], u = [r.args[2], r.args[3]], d = [r.args[4], r.args[5]];
        if (n.length > 0) {
          const g = n[n.length - 1];
          (a[0] !== g.point[0] || a[1] !== g.point[1]) && (g.type = "CURVE", g.outHandle = a);
        }
        const f = {
          type: u[0] !== d[0] || u[1] !== d[1] ? "CURVE" : "CORNER",
          point: d
        };
        f.type === "CURVE" && (f.inHandle = u), n.push(f), o = d;
        break;
      case "Z":
        s = !0;
        break;
      default:
        console.warn(`Unsupported SVG path command: ${r.type}`);
        break;
    }
  }
  n = n.map((l) => rs(l) ? { ...l, locked: !0 } : l);
  const i = fe(xt(n, s));
  return {
    points: n,
    closed: s,
    bounds: i
  };
}, po = (e) => {
  const t = [], n = e.replace(/,/g, " ").trim(), o = /([MmLlHhVvCcZz])\s*([^MmLlHhVvCcZz]*)/g;
  let s;
  for (; (s = o.exec(n)) !== null; ) {
    const [, i, l] = s, r = l.trim() === "" ? [] : l.trim().split(/\s+/).map(Number).filter((a) => !isNaN(a));
    t.push({
      type: i,
      args: r
    });
  }
  return t;
}, as = (e) => {
  const [t, n, o] = e.match(/(<polygon points=["|'])([^("|')]*)/) || [], s = o.split(" ").map((i) => i.split(",").map(parseFloat));
  return {
    type: Q.POLYGON,
    geometry: {
      points: s,
      bounds: fe(s)
    }
  };
}, cs = (e) => {
  const t = st(e), n = parseFloat(t.getAttribute("cx")), o = parseFloat(t.getAttribute("cy")), s = parseFloat(t.getAttribute("rx")), i = parseFloat(t.getAttribute("ry")), l = {
    minX: n - s,
    minY: o - i,
    maxX: n + s,
    maxY: o + i
  };
  return {
    type: Q.ELLIPSE,
    geometry: {
      cx: n,
      cy: o,
      rx: s,
      ry: i,
      bounds: l
    }
  };
}, us = (e) => {
  const t = st(e), n = parseFloat(t.getAttribute("x1")), o = parseFloat(t.getAttribute("x2")), s = parseFloat(t.getAttribute("y1")), i = parseFloat(t.getAttribute("y2")), l = {
    minX: Math.min(n, o),
    minY: Math.min(s, i),
    maxX: Math.max(n, o),
    maxY: Math.max(s, i)
  };
  return {
    type: Q.LINE,
    geometry: {
      points: [[n, s], [o, i]],
      bounds: l
    }
  };
}, fs = (e) => {
  const t = st(e), n = t.nodeName === "path" ? t : Array.from(t.querySelectorAll("path"))[0], o = n == null ? void 0 : n.getAttribute("d");
  if (!o)
    throw new Error("Could not parse SVG path");
  const s = ls(o);
  if (!s)
    throw new Error("Could not parse SVG path");
  return {
    type: Q.POLYLINE,
    geometry: s
  };
}, ds = (e) => {
  const t = st(e), n = t.nodeName === "rect" ? t : Array.from(t.querySelectorAll("rect"))[0];
  if (!n) throw new Error("Could not parse SVG rect");
  const o = parseFloat(n.getAttribute("x")), s = parseFloat(n.getAttribute("y")), i = parseFloat(n.getAttribute("width")), l = parseFloat(n.getAttribute("height")), r = n.getAttribute("transform");
  let a = 0;
  if (r && r.startsWith("rotate(")) {
    const p = r.match(/rotate\(([^)]+)\)/);
    p && (a = p[1].split(/\s+/).map(parseFloat)[0] * Math.PI / 180);
  }
  const u = o + i / 2, d = s + l / 2, g = [
    [o, s],
    [o + i, s],
    [o + i, s + l],
    [o, s + l]
  ].map(([p, y]) => {
    const S = p - u, w = y - d, A = Math.cos(a), _ = Math.sin(a);
    return [
      u + S * A - w * _,
      d + S * _ + w * A
    ];
  }), h = fe(g);
  return {
    type: Q.RECTANGLE,
    geometry: {
      x: o,
      y: s,
      w: i,
      h: l,
      rot: a,
      bounds: h
    }
  };
}, gs = (e) => {
  const t = st(e), s = (t.nodeName === "path" ? [t] : Array.from(t.querySelectorAll("path"))).map((a) => a.getAttribute("d") || "").map((a) => is(a)).filter(Boolean), i = s.reduce((a, u) => [...a, ...u.rings[0].points], []), l = fe(i);
  return s.length === 1 && s[0].rings.length === 1 ? {
    type: Q.POLYGON,
    geometry: {
      points: i,
      bounds: l
    }
  } : {
    type: Q.MULTIPOLYGON,
    geometry: {
      polygons: s,
      bounds: l
    }
  };
}, hs = (e) => {
  const t = typeof e == "string" ? e : e.value;
  if (t.includes("<polygon points="))
    return as(t);
  if (t.includes("<path ") && (t.includes(" C ") || !t.includes("Z")))
    return fs(t);
  if (t.includes("<path "))
    return gs(t);
  if (t.includes("<ellipse "))
    return cs(t);
  if (t.includes("<line "))
    return us(t);
  if (t.includes("<rect "))
    return ds(t);
  throw "Unsupported SVG shape: " + t;
}, ms = (e) => `<g>${e.polygons.map((n) => `<path fill-rule="evenodd" d="${Pe(n)}" />`).join("")}</g>`, ps = (e) => {
  let t;
  switch (e.type) {
    case Q.RECTANGLE: {
      const n = e.geometry, { x: o, y: s, w: i, h: l, rot: r } = n;
      if (!r)
        t = `<svg><rect x="${o}" y="${s}" width="${i}" height="${l}" /></svg>`;
      else {
        const a = o + i / 2, u = s + l / 2, d = (r ?? 0) * 180 / Math.PI;
        t = `<svg><rect x="${o}" y="${s}" width="${i}" height="${l}" transform="rotate(${d} ${a} ${u})" /></svg>`;
      }
      break;
    }
    case Q.POLYGON: {
      const n = e.geometry, { points: o } = n;
      t = `<svg><polygon points="${o.map((s) => s.join(",")).join(" ")}" /></svg>`;
      break;
    }
    case Q.ELLIPSE: {
      const n = e.geometry;
      t = `<svg><ellipse cx="${n.cx}" cy="${n.cy}" rx="${n.rx}" ry="${n.ry}" /></svg>`;
      break;
    }
    case Q.MULTIPOLYGON: {
      const n = e.geometry;
      t = `<svg>${ms(n)}</svg>`;
      break;
    }
    case Q.LINE: {
      const n = e.geometry, [[o, s], [i, l]] = n.points;
      t = `<svg><line x1="${o}" y1="${s}" x2="${i}" y2="${l}" /></svg>`;
      break;
    }
    case Q.POLYLINE:
      t = `<svg><path d="${ho(e.geometry)}" /></svg>`;
  }
  if (t)
    return { type: "SvgSelector", value: t };
  throw `Unsupported shape type: ${e.type}`;
}, me = [];
for (let e = 0; e < 256; ++e)
  me.push((e + 256).toString(16).slice(1));
function _s(e, t = 0) {
  return (me[e[t + 0]] + me[e[t + 1]] + me[e[t + 2]] + me[e[t + 3]] + "-" + me[e[t + 4]] + me[e[t + 5]] + "-" + me[e[t + 6]] + me[e[t + 7]] + "-" + me[e[t + 8]] + me[e[t + 9]] + "-" + me[e[t + 10]] + me[e[t + 11]] + me[e[t + 12]] + me[e[t + 13]] + me[e[t + 14]] + me[e[t + 15]]).toLowerCase();
}
let Nt;
const ys = new Uint8Array(16);
function ws() {
  if (!Nt) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Nt = crypto.getRandomValues.bind(crypto);
  }
  return Nt(ys);
}
const bs = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), fn = { randomUUID: bs };
function Es(e, t, n) {
  var s;
  e = e || {};
  const o = e.random ?? ((s = e.rng) == null ? void 0 : s.call(e)) ?? ws();
  if (o.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, _s(o);
}
function _o(e, t, n) {
  return fn.randomUUID && !e ? fn.randomUUID() : Es(e);
}
var dn = Object.prototype.hasOwnProperty;
function Be(e, t) {
  var n, o;
  if (e === t) return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date) return e.getTime() === t.getTime();
    if (n === RegExp) return e.toString() === t.toString();
    if (n === Array) {
      if ((o = e.length) === t.length)
        for (; o-- && Be(e[o], t[o]); ) ;
      return o === -1;
    }
    if (!n || typeof e == "object") {
      o = 0;
      for (n in e)
        if (dn.call(e, n) && ++o && !dn.call(t, n) || !(n in t) || !Be(e[n], t[n])) return !1;
      return Object.keys(t).length === o;
    }
  }
  return e !== e && t !== t;
}
let vs = Symbol("clean"), Me = [], Ne = 0;
const gt = 4, tn = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  let t = [], n = {
    get() {
      return n.lc || n.listen(() => {
      })(), n.value;
    },
    init: e,
    lc: 0,
    listen(o) {
      return n.lc = t.push(o), () => {
        for (let i = Ne + gt; i < Me.length; )
          Me[i] === o ? Me.splice(i, gt) : i += gt;
        let s = t.indexOf(o);
        ~s && (t.splice(s, 1), --n.lc || n.off());
      };
    },
    notify(o, s) {
      let i = !Me.length;
      for (let l of t)
        Me.push(l, n.value, o, s);
      if (i) {
        for (Ne = 0; Ne < Me.length; Ne += gt)
          Me[Ne](
            Me[Ne + 1],
            Me[Ne + 2],
            Me[Ne + 3]
          );
        Me.length = 0;
      }
    },
    /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */
    off() {
    },
    set(o) {
      let s = n.value;
      s !== o && (n.value = o, n.notify(s));
    },
    subscribe(o) {
      let s = n.listen(o);
      return o(n.value), s;
    },
    value: e
  };
  return process.env.NODE_ENV !== "production" && (n[vs] = () => {
    t = [], n.lc = 0, n.off();
  }), n;
}, As = (e) => {
  const t = /* @__PURE__ */ tn(null);
  return e.observe(({ changes: n }) => {
    const o = t.get();
    if (o) {
      (n.deleted || []).some((i) => i.id === o) && t.set(null);
      const s = (n.updated || []).find(({ oldValue: i }) => i.id === o);
      s && t.set(s.newValue.id);
    }
  }), {
    get current() {
      return t.get();
    },
    subscribe: t.subscribe.bind(t),
    set: t.set.bind(t)
  };
};
var yo = /* @__PURE__ */ ((e) => (e.EDIT = "EDIT", e.SELECT = "SELECT", e.NONE = "NONE", e))(yo || {});
const Bt = { selected: [] }, Ss = (e, t, n) => {
  const o = /* @__PURE__ */ tn(Bt);
  let s = t;
  const i = () => {
    Be(o.get(), Bt) || o.set(Bt);
  }, l = () => {
    var h;
    return ((h = o.get().selected) == null ? void 0 : h.length) === 0;
  }, r = (h) => {
    if (l())
      return !1;
    const p = typeof h == "string" ? h : h.id;
    return o.get().selected.some((y) => y.id === p);
  }, a = (h, p) => {
    let y;
    if (Array.isArray(h)) {
      if (y = h.map((w) => e.getAnnotation(w)).filter(Boolean), y.length < h.length) {
        console.warn("Invalid selection: " + h.filter((w) => !y.some((A) => A.id === w)));
        return;
      }
    } else {
      const w = e.getAnnotation(h);
      if (!w) {
        console.warn("Invalid selection: " + h);
        return;
      }
      y = [w];
    }
    const S = y.reduce((w, A) => {
      const _ = g(A);
      return _ === "EDIT" ? [...w, { id: A.id, editable: !0 }] : _ === "SELECT" ? [...w, { id: A.id }] : w;
    }, []);
    o.set({ selected: S, event: p });
  }, u = (h, p) => {
    const y = Array.isArray(h) ? h : [h], S = y.map((w) => e.getAnnotation(w)).filter((w) => !!w);
    o.set({
      selected: S.map((w) => {
        const A = p === void 0 ? g(w) === "EDIT" : p;
        return { id: w.id, editable: A };
      })
    }), S.length !== y.length && console.warn("Invalid selection", h);
  }, d = (h) => {
    if (l())
      return !1;
    const { selected: p } = o.get();
    p.some(({ id: y }) => h.includes(y)) && o.set({ selected: p.filter(({ id: y }) => !h.includes(y)) });
  }, f = (h) => {
    s = h, u(o.get().selected.map(({ id: p }) => p));
  }, g = (h) => ks(h, s, n);
  return e.observe(
    ({ changes: h }) => d((h.deleted || []).map((p) => p.id))
  ), {
    get event() {
      const h = o.get();
      return h ? h.event : null;
    },
    get selected() {
      const h = o.get();
      return h ? [...h.selected] : null;
    },
    get userSelectAction() {
      return s;
    },
    clear: i,
    evalSelectAction: g,
    isEmpty: l,
    isSelected: r,
    setSelected: u,
    setUserSelectAction: f,
    subscribe: o.subscribe.bind(o),
    userSelect: a
  };
}, ks = (e, t, n) => {
  const o = n ? n.serialize(e) : e;
  return typeof t == "function" ? t(o) : t || "EDIT";
}, pe = [];
for (let e = 0; e < 256; ++e)
  pe.push((e + 256).toString(16).slice(1));
function Ms(e, t = 0) {
  return (pe[e[t + 0]] + pe[e[t + 1]] + pe[e[t + 2]] + pe[e[t + 3]] + "-" + pe[e[t + 4]] + pe[e[t + 5]] + "-" + pe[e[t + 6]] + pe[e[t + 7]] + "-" + pe[e[t + 8]] + pe[e[t + 9]] + "-" + pe[e[t + 10]] + pe[e[t + 11]] + pe[e[t + 12]] + pe[e[t + 13]] + pe[e[t + 14]] + pe[e[t + 15]]).toLowerCase();
}
let Rt;
const Ts = new Uint8Array(16);
function Ps() {
  if (!Rt) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Rt = crypto.getRandomValues.bind(crypto);
  }
  return Rt(Ts);
}
const Ls = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), gn = { randomUUID: Ls };
function Is(e, t, n) {
  var o;
  e = e || {};
  const s = e.random ?? ((o = e.rng) == null ? void 0 : o.call(e)) ?? Ps();
  if (s.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, Ms(s);
}
function wo(e, t, n) {
  return gn.randomUUID && !e ? gn.randomUUID() : Is(e);
}
const Yt = (e) => {
  const t = (n) => {
    const o = { ...n };
    return n.created && typeof n.created == "string" && (o.created = new Date(n.created)), n.updated && typeof n.updated == "string" && (o.updated = new Date(n.updated)), o;
  };
  return {
    ...e,
    bodies: (e.bodies || []).map(t),
    target: t(e.target)
  };
}, el = (e, t, n, o) => ({
  id: wo(),
  annotation: typeof e == "string" ? e : e.id,
  created: n || /* @__PURE__ */ new Date(),
  creator: o,
  ...t
}), Cs = (e, t) => {
  const n = new Set(e.bodies.map((o) => o.id));
  return t.bodies.filter((o) => !n.has(o.id));
}, Os = (e, t) => {
  const n = new Set(t.bodies.map((o) => o.id));
  return e.bodies.filter((o) => !n.has(o.id));
}, Ds = (e, t) => t.bodies.map((n) => {
  const o = e.bodies.find((s) => s.id === n.id);
  return { newBody: n, oldBody: o && !Be(o, n) ? o : void 0 };
}).filter(({ oldBody: n }) => n).map(({ oldBody: n, newBody: o }) => ({ oldBody: n, newBody: o })), Ns = (e, t) => !Be(e.target, t.target), bo = (e, t) => {
  const n = Cs(e, t), o = Os(e, t), s = Ds(e, t);
  return {
    oldValue: e,
    newValue: t,
    bodiesCreated: n.length > 0 ? n : void 0,
    bodiesDeleted: o.length > 0 ? o : void 0,
    bodiesUpdated: s.length > 0 ? s : void 0,
    targetUpdated: Ns(e, t) ? { oldTarget: e.target, newTarget: t.target } : void 0
  };
};
var oe = /* @__PURE__ */ ((e) => (e.LOCAL = "LOCAL", e.REMOTE = "REMOTE", e.SILENT = "SILENT", e))(oe || {});
const Bs = (e, t) => {
  var n, o;
  const { changes: s, origin: i } = t;
  if (!(e.options.origin ? e.options.origin === i : i !== "SILENT"))
    return !1;
  if (e.options.ignore) {
    const { ignore: l } = e.options, r = (a) => a && a.length > 0;
    if (!(r(s.created) || r(s.deleted))) {
      const a = (n = s.updated) == null ? void 0 : n.some((d) => r(d.bodiesCreated) || r(d.bodiesDeleted) || r(d.bodiesUpdated)), u = (o = s.updated) == null ? void 0 : o.some((d) => d.targetUpdated);
      if (l === "BODY_ONLY" && a && !u || l === "TARGET_ONLY" && u && !a)
        return !1;
    }
  }
  if (e.options.annotations) {
    const l = /* @__PURE__ */ new Set([
      ...(s.created || []).map((r) => r.id),
      ...(s.deleted || []).map((r) => r.id),
      ...(s.updated || []).map(({ oldValue: r }) => r.id)
    ]);
    return !!(Array.isArray(e.options.annotations) ? e.options.annotations : [e.options.annotations]).find((r) => l.has(r));
  } else
    return !0;
}, Rs = (e, t) => {
  const n = new Set((e.created || []).map((f) => f.id)), o = new Set((e.updated || []).map(({ newValue: f }) => f.id)), s = new Set((t.created || []).map((f) => f.id)), i = new Set((t.deleted || []).map((f) => f.id)), l = new Set((t.updated || []).map(({ oldValue: f }) => f.id)), r = new Set((t.updated || []).filter(({ oldValue: f }) => n.has(f.id) || o.has(f.id)).map(({ oldValue: f }) => f.id)), a = [
    ...(e.created || []).filter((f) => !i.has(f.id)).map((f) => l.has(f.id) ? t.updated.find(({ oldValue: g }) => g.id === f.id).newValue : f),
    ...t.created || []
  ], u = [
    ...(e.deleted || []).filter((f) => !s.has(f.id)),
    ...(t.deleted || []).filter((f) => !n.has(f.id))
  ], d = [
    ...(e.updated || []).filter(({ newValue: f }) => !i.has(f.id)).map((f) => {
      const { oldValue: g, newValue: h } = f;
      if (l.has(h.id)) {
        const p = t.updated.find((y) => y.oldValue.id === h.id).newValue;
        return bo(g, p);
      } else
        return f;
    }),
    ...(t.updated || []).filter(({ oldValue: f }) => !r.has(f.id))
  ];
  return { created: a, deleted: u, updated: d };
}, ht = (e) => {
  const t = e.id === void 0 ? wo() : e.id;
  return {
    ...e,
    id: t,
    bodies: e.bodies === void 0 ? [] : e.bodies.map((n) => ({
      ...n,
      annotation: t
    })),
    target: {
      ...e.target,
      annotation: t
    }
  };
}, Ys = (e) => e.id !== void 0, Us = () => {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = [], o = (v, E = {}) => {
    n.push({ onChange: v, options: E });
  }, s = (v) => {
    const E = n.findIndex((m) => m.onChange == v);
    E > -1 && n.splice(E, 1);
  }, i = (v, E) => {
    const m = {
      origin: v,
      changes: {
        created: E.created || [],
        updated: E.updated || [],
        deleted: E.deleted || []
      },
      state: [...e.values()]
    };
    n.forEach((b) => {
      Bs(b, m) && b.onChange(m);
    });
  }, l = (v, E = oe.LOCAL) => {
    if (v.id && e.get(v.id))
      throw Error(`Cannot add annotation ${v.id} - exists already`);
    {
      const m = ht(v);
      e.set(m.id, m), m.bodies.forEach((b) => t.set(b.id, m.id)), i(E, { created: [m] });
    }
  }, r = (v, E) => {
    const m = ht(typeof v == "string" ? E : v), b = typeof v == "string" ? v : v.id, L = b && e.get(b);
    if (L) {
      const M = bo(L, m);
      return b === m.id ? e.set(b, m) : (e.delete(b), e.set(m.id, m)), L.bodies.forEach((O) => t.delete(O.id)), m.bodies.forEach((O) => t.set(O.id, m.id)), M;
    } else
      console.warn(`Cannot update annotation ${b} - does not exist`);
  }, a = (v, E = oe.LOCAL, m = oe.LOCAL) => {
    const b = Ys(E) ? m : E, L = r(v, E);
    L && i(b, { updated: [L] });
  }, u = (v, E = oe.LOCAL) => {
    e.get(v.id) ? a(v, E) : l(v, E);
  }, d = (v, E = oe.LOCAL) => {
    const m = v.reduce((b, L) => {
      const M = r(L);
      return M ? [...b, M] : b;
    }, []);
    m.length > 0 && i(E, { updated: m });
  }, f = (v, E = oe.LOCAL) => {
    const m = v.map(ht), { toAdd: b, toUpdate: L } = m.reduce((O, F) => e.get(F.id) ? { ...O, toUpdate: [...O.toUpdate, F] } : { ...O, toAdd: [...O.toAdd, F] }, { toAdd: [], toUpdate: [] }), M = L.map((O) => r(O, E)).filter(Boolean);
    b.forEach((O) => {
      e.set(O.id, O), O.bodies.forEach((F) => t.set(F.id, O.id));
    }), i(E, { created: b, updated: M });
  }, g = (v, E = oe.LOCAL) => {
    const m = e.get(v.annotation);
    if (m) {
      const b = {
        ...m,
        bodies: [...m.bodies, v]
      };
      e.set(m.id, b), t.set(v.id, b.id), i(E, { updated: [{
        oldValue: m,
        newValue: b,
        bodiesCreated: [v]
      }] });
    } else
      console.warn(`Attempt to add body to missing annotation: ${v.annotation}`);
  }, h = () => [...e.values()], p = (v = oe.LOCAL) => {
    const E = [...e.values()];
    e.clear(), t.clear(), i(v, { deleted: E });
  }, y = (v, E = !0, m = oe.LOCAL) => {
    const b = v.map(ht);
    if (E) {
      const L = [...e.values()];
      e.clear(), t.clear(), b.forEach((M) => {
        e.set(M.id, M), M.bodies.forEach((O) => t.set(O.id, M.id));
      }), i(m, { created: b, deleted: L });
    } else {
      const L = v.reduce((M, O) => {
        const F = O.id && e.get(O.id);
        return F ? [...M, F] : M;
      }, []);
      if (L.length > 0)
        throw Error(`Bulk insert would overwrite the following annotations: ${L.map((M) => M.id).join(", ")}`);
      b.forEach((M) => {
        e.set(M.id, M), M.bodies.forEach((O) => t.set(O.id, M.id));
      }), i(m, { created: b });
    }
  }, S = (v) => {
    const E = typeof v == "string" ? v : v.id, m = e.get(E);
    if (m)
      return e.delete(E), m.bodies.forEach((b) => t.delete(b.id)), m;
    console.warn(`Attempt to delete missing annotation: ${E}`);
  }, w = (v, E = oe.LOCAL) => {
    const m = S(v);
    m && i(E, { deleted: [m] });
  }, A = (v, E = oe.LOCAL) => {
    const m = v.reduce((b, L) => {
      const M = S(L);
      return M ? [...b, M] : b;
    }, []);
    m.length > 0 && i(E, { deleted: m });
  }, _ = (v) => {
    const E = e.get(v.annotation);
    if (E) {
      const m = E.bodies.find((b) => b.id === v.id);
      if (m) {
        t.delete(m.id);
        const b = {
          ...E,
          bodies: E.bodies.filter((L) => L.id !== v.id)
        };
        return e.set(E.id, b), {
          oldValue: E,
          newValue: b,
          bodiesDeleted: [m]
        };
      } else
        console.warn(`Attempt to delete missing body ${v.id} from annotation ${v.annotation}`);
    } else
      console.warn(`Attempt to delete body from missing annotation ${v.annotation}`);
  }, k = (v, E = oe.LOCAL) => {
    const m = _(v);
    m && i(E, { updated: [m] });
  }, P = (v, E = oe.LOCAL) => {
    const m = v.map((b) => _(b)).filter(Boolean);
    m.length > 0 && i(E, { updated: m });
  }, C = (v) => {
    const E = e.get(v);
    return E ? { ...E } : void 0;
  }, T = (v) => {
    const E = t.get(v);
    if (E) {
      const m = C(E).bodies.find((b) => b.id === v);
      if (m)
        return m;
      console.error(`Store integrity error: body ${v} in index, but not in annotation`);
    } else
      console.warn(`Attempt to retrieve missing body: ${v}`);
  }, Y = (v, E) => {
    if (v.annotation !== E.annotation)
      throw "Annotation integrity violation: annotation ID must be the same when updating bodies";
    const m = e.get(v.annotation);
    if (m) {
      const b = m.bodies.find((M) => M.id === v.id), L = {
        ...m,
        bodies: m.bodies.map((M) => M.id === b.id ? E : M)
      };
      return e.set(m.id, L), b.id !== E.id && (t.delete(b.id), t.set(E.id, L.id)), {
        oldValue: m,
        newValue: L,
        bodiesUpdated: [{ oldBody: b, newBody: E }]
      };
    } else
      console.warn(`Attempt to add body to missing annotation ${v.annotation}`);
  }, D = (v, E, m = oe.LOCAL) => {
    const b = Y(v, E);
    b && i(m, { updated: [b] });
  }, x = (v, E = oe.LOCAL) => {
    const m = v.map((b) => Y({ id: b.id, annotation: b.annotation }, b)).filter(Boolean);
    i(E, { updated: m });
  }, j = (v) => {
    const E = e.get(v.annotation);
    if (E) {
      const m = {
        ...E,
        target: {
          ...E.target,
          ...v
        }
      };
      return e.set(E.id, m), {
        oldValue: E,
        newValue: m,
        targetUpdated: {
          oldTarget: E.target,
          newTarget: v
        }
      };
    } else
      console.warn(`Attempt to update target on missing annotation: ${v.annotation}`);
  };
  return {
    addAnnotation: l,
    addBody: g,
    all: h,
    bulkAddAnnotations: y,
    bulkDeleteAnnotations: A,
    bulkDeleteBodies: P,
    bulkUpdateAnnotations: d,
    bulkUpdateBodies: x,
    bulkUpdateTargets: (v, E = oe.LOCAL) => {
      const m = v.map((b) => j(b)).filter(Boolean);
      m.length > 0 && i(E, { updated: m });
    },
    bulkUpsertAnnotations: f,
    clear: p,
    deleteAnnotation: w,
    deleteBody: k,
    getAnnotation: C,
    getBody: T,
    observe: o,
    unobserve: s,
    updateAnnotation: a,
    updateBody: D,
    updateTarget: (v, E = oe.LOCAL) => {
      const m = j(v);
      m && i(E, { updated: [m] });
    },
    upsertAnnotation: u
  };
};
let Vs = () => ({
  emit(e, ...t) {
    for (let n = this.events[e] || [], o = 0, s = n.length; o < s; o++)
      n[o](...t);
  },
  events: {},
  on(e, t) {
    var n;
    return ((n = this.events)[e] || (n[e] = [])).push(t), () => {
      var o;
      this.events[e] = (o = this.events[e]) == null ? void 0 : o.filter((s) => t !== s);
    };
  }
});
const Xs = 250, Hs = (e, t) => {
  const n = Vs(), o = (t == null ? void 0 : t.changes) || [];
  let s = t ? t.pointer : -1, i = !1, l = 0;
  const r = (p) => {
    if (!i) {
      const { changes: y } = p, S = performance.now();
      if (S - l > Xs)
        o.splice(s + 1), o.push(y), s = o.length - 1;
      else {
        const w = o.length - 1;
        o[w] = Rs(o[w], y);
      }
      l = S;
    }
    i = !1;
  };
  e.observe(r, { origin: oe.LOCAL });
  const a = (p) => p && p.length > 0 && e.bulkDeleteAnnotations(p), u = (p) => p && p.length > 0 && e.bulkAddAnnotations(p, !1), d = (p) => p && p.length > 0 && e.bulkUpdateAnnotations(p.map(({ oldValue: y }) => y)), f = (p) => p && p.length > 0 && e.bulkUpdateAnnotations(p.map(({ newValue: y }) => y)), g = (p) => p && p.length > 0 && e.bulkAddAnnotations(p, !1), h = (p) => p && p.length > 0 && e.bulkDeleteAnnotations(p);
  return {
    canRedo: () => o.length - 1 > s,
    canUndo: () => s > -1,
    destroy: () => e.unobserve(r),
    getHistory: () => ({ changes: [...o], pointer: s }),
    on: (p, y) => n.on(p, y),
    redo: () => {
      if (o.length - 1 > s) {
        i = !0;
        const { created: p, updated: y, deleted: S } = o[s + 1];
        u(p), f(y), h(S), n.emit("redo", o[s + 1]), s += 1;
      }
    },
    undo: () => {
      if (s > -1) {
        i = !0;
        const { created: p, updated: y, deleted: S } = o[s];
        a(p), d(y), g(S), n.emit("undo", o[s]), s -= 1;
      }
    }
  };
}, Gs = () => {
  const e = /* @__PURE__ */ tn([]);
  return {
    subscribe: e.subscribe.bind(e),
    set: e.set.bind(e)
  };
}, js = (e, t, n, o) => {
  const { hover: s, selection: i, store: l, viewport: r } = e, a = /* @__PURE__ */ new Map();
  let u = [], d, f;
  const g = (w, A) => {
    a.has(w) ? a.get(w).push(A) : a.set(w, [A]);
  }, h = (w, A) => {
    const _ = a.get(w);
    if (_) {
      const k = _.indexOf(A);
      k !== -1 && _.splice(k, 1);
    }
  }, p = (w, A, _) => {
    a.has(w) && setTimeout(() => {
      a.get(w).forEach((k) => {
        if (n) {
          const P = Array.isArray(A) ? A.map((T) => n.serialize(T)) : n.serialize(A), C = _ ? _ instanceof PointerEvent ? _ : n.serialize(_) : void 0;
          k(P, C);
        } else
          k(A, _);
      });
    }, 1);
  }, y = () => {
    const { selected: w } = i, A = (w || []).map(({ id: _ }) => l.getAnnotation(_));
    A.forEach((_) => {
      const k = u.find((P) => P.id === _.id);
      (!k || !Be(k, _)) && p("updateAnnotation", _, k);
    }), u = u.map((_) => A.find(({ id: P }) => P === _.id) || _);
  };
  i.subscribe(({ selected: w }) => {
    if (!(u.length === 0 && w.length === 0)) {
      if (u.length === 0 && w.length > 0)
        u = w.map(({ id: A }) => l.getAnnotation(A));
      else if (u.length > 0 && w.length === 0)
        u.forEach((A) => {
          const _ = l.getAnnotation(A.id);
          _ && !Be(_, A) && p("updateAnnotation", _, A);
        }), u = [];
      else {
        const A = new Set(u.map((k) => k.id)), _ = new Set(w.map(({ id: k }) => k));
        u.filter((k) => !_.has(k.id)).forEach((k) => {
          const P = l.getAnnotation(k.id);
          P && !Be(P, k) && p("updateAnnotation", P, k);
        }), u = [
          // Remove annotations that were deselected
          ...u.filter((k) => _.has(k.id)),
          // Add editable annotations that were selected
          ...w.filter(({ id: k }) => !A.has(k)).map(({ id: k }) => l.getAnnotation(k))
        ];
      }
      p("selectionChanged", u);
    }
  }), s.subscribe((w) => {
    !d && w ? p("mouseEnterAnnotation", l.getAnnotation(w)) : d && !w ? p("mouseLeaveAnnotation", l.getAnnotation(d)) : d && w && (p("mouseLeaveAnnotation", l.getAnnotation(d)), p("mouseEnterAnnotation", l.getAnnotation(w))), d = w;
  }), r == null || r.subscribe((w) => p("viewportIntersect", w.map((A) => l.getAnnotation(A)))), l.observe((w) => {
    o && (f && clearTimeout(f), f = setTimeout(y, 1e3));
    const { created: A, deleted: _ } = w.changes;
    (A || []).forEach((k) => p("createAnnotation", k)), (_ || []).forEach((k) => p("deleteAnnotation", k)), (w.changes.updated || []).filter((k) => [
      ...k.bodiesCreated || [],
      ...k.bodiesDeleted || [],
      ...k.bodiesUpdated || []
    ].length > 0).forEach(({ oldValue: k, newValue: P }) => {
      const C = u.find((T) => T.id === k.id) || k;
      u = u.map((T) => T.id === k.id ? P : T), p("updateAnnotation", P, C);
    });
  }, { origin: oe.LOCAL }), l.observe((w) => {
    if (u) {
      const A = new Set(u.map((k) => k.id)), _ = (w.changes.updated || []).filter(({ newValue: k }) => A.has(k.id)).map(({ newValue: k }) => k);
      _.length > 0 && (u = u.map((k) => _.find((C) => C.id === k.id) || k));
    }
  }, { origin: oe.REMOTE });
  const S = (w) => (A) => {
    const { updated: _ } = A;
    w ? (_ || []).forEach((k) => p("updateAnnotation", k.oldValue, k.newValue)) : (_ || []).forEach((k) => p("updateAnnotation", k.newValue, k.oldValue));
  };
  return t.on("undo", S(!0)), t.on("redo", S(!1)), { on: g, off: h, emit: p };
}, Fs = (e) => (t) => t.reduce((n, o) => {
  const { parsed: s, error: i } = e.parse(o);
  return i ? {
    parsed: n.parsed,
    failed: [...n.failed, o]
  } : s ? {
    parsed: [...n.parsed, s],
    failed: n.failed
  } : {
    ...n
  };
}, { parsed: [], failed: [] }), zs = (e, t, n) => {
  const { store: o, selection: s } = e, i = (w) => {
    if (n) {
      const { parsed: A, error: _ } = n.parse(w);
      A ? o.addAnnotation(A, oe.REMOTE) : console.error(_);
    } else
      o.addAnnotation(Yt(w), oe.REMOTE);
  }, l = () => s.clear(), r = () => o.clear(), a = (w) => {
    const A = o.getAnnotation(w);
    return n && A ? n.serialize(A) : A;
  }, u = () => n ? o.all().map(n.serialize) : o.all(), d = () => {
    var w;
    const A = (((w = s.selected) == null ? void 0 : w.map((_) => _.id)) || []).map((_) => o.getAnnotation(_)).filter(Boolean);
    return n ? A.map(n.serialize) : A;
  }, f = (w, A = !0) => fetch(w).then((_) => _.json()).then((_) => (h(_, A), _)), g = (w) => {
    if (typeof w == "string") {
      const A = o.getAnnotation(w);
      if (o.deleteAnnotation(w), A)
        return n ? n.serialize(A) : A;
    } else {
      const A = n ? n.parse(w).parsed : w;
      if (A)
        return o.deleteAnnotation(A), w;
    }
  }, h = (w, A = !0) => {
    if (n) {
      const _ = n.parseAll || Fs(n), { parsed: k, failed: P } = _(w);
      P.length > 0 && console.warn(`Discarded ${P.length} invalid annotations`, P), o.bulkAddAnnotations(k, A, oe.REMOTE);
    } else
      o.bulkAddAnnotations(w.map(Yt), A, oe.REMOTE);
  }, p = (w, A) => {
    w ? s.setSelected(w, A) : s.clear();
  }, y = (w) => {
    s.setUserSelectAction(w);
  }, S = (w) => {
    if (n) {
      const A = n.parse(w).parsed, _ = n.serialize(o.getAnnotation(A.id));
      return o.updateAnnotation(A), _;
    } else {
      const A = o.getAnnotation(w.id);
      return o.updateAnnotation(Yt(w)), A;
    }
  };
  return {
    addAnnotation: i,
    cancelSelected: l,
    canRedo: t.canRedo,
    canUndo: t.canUndo,
    clearAnnotations: r,
    getAnnotationById: a,
    getAnnotations: u,
    getHistory: t.getHistory,
    getSelected: d,
    loadAnnotations: f,
    redo: t.redo,
    removeAnnotation: g,
    setAnnotations: h,
    setSelected: p,
    setUserSelectAction: y,
    undo: t.undo,
    updateAnnotation: S
  };
}, tl = (e, t, n) => typeof t == "function" ? t(e, n) : t, nl = (e, t) => typeof e != "function" && typeof t != "function" ? {
  ...e || {},
  ...t || {}
} : (n, o) => {
  const s = typeof e == "function" ? e(n, o) : e, i = typeof t == "function" ? t(n, o) : t;
  return {
    ...s || {},
    ...i || {}
  };
};
let qs = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", Ks = (e) => crypto.getRandomValues(new Uint8Array(e)), Ws = (e, t, n) => {
  let o = (2 << Math.log2(e.length - 1)) - 1, s = -~(1.6 * o * t / e.length);
  return (i = t) => {
    let l = "";
    for (; ; ) {
      let r = n(s), a = s | 0;
      for (; a--; )
        if (l += e[r[a] & o] || "", l.length >= i) return l;
    }
  };
}, Zs = (e, t = 21) => Ws(e, t | 0, Ks), Js = (e = 21) => {
  let t = "", n = crypto.getRandomValues(new Uint8Array(e |= 0));
  for (; e--; )
    t += qs[n[e] & 63];
  return t;
};
const Qs = () => ({ isGuest: !0, id: Zs("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_", 20)() }), xs = (e) => {
  const t = JSON.stringify(e);
  let n = 0;
  for (let o = 0, s = t.length; o < s; o++) {
    let i = t.charCodeAt(o);
    n = (n << 5) - n + i, n |= 0;
  }
  return `${n}`;
}, Eo = (e) => e ? typeof e == "object" ? { ...e } : e : void 0, $s = (e, t) => (Array.isArray(e) ? e : [e]).map((n) => {
  const { id: o, type: s, purpose: i, value: l, created: r, modified: a, creator: u, ...d } = n;
  return {
    id: o || `temp-${xs(n)}`,
    annotation: t,
    type: s,
    purpose: i,
    value: l,
    creator: Eo(u),
    created: r ? new Date(r) : void 0,
    updated: a ? new Date(a) : void 0,
    ...d
  };
}), ei = (e) => e.map((t) => {
  var n;
  const { annotation: o, created: s, updated: i, ...l } = t, r = {
    ...l,
    created: s == null ? void 0 : s.toISOString(),
    modified: i == null ? void 0 : i.toISOString()
  };
  return (n = r.id) != null && n.startsWith("temp-") && delete r.id, r;
}), ti = [
  "#ff7c00",
  // orange
  "#1ac938",
  // green
  "#e8000b",
  // red
  "#8b2be2",
  // purple
  "#9f4800",
  // brown
  "#f14cc1",
  // pink
  "#ffc400",
  // khaki
  "#00d7ff",
  // cyan
  "#023eff"
  // blue
], ol = () => {
  const e = [...ti];
  return { assignRandomColor: () => {
    const t = Math.floor(Math.random() * e.length), n = e[t];
    return e.splice(t, 1), n;
  }, releaseColor: (t) => e.push(t) };
};
Js();
const sl = (e, t = { strict: !0, invertY: !1 }) => ({ parse: (s) => ni(s, t), serialize: (s) => oi(s, e, t) }), ni = (e, t = { strict: !0, invertY: !1 }) => {
  const n = e.id || _o(), {
    creator: o,
    created: s,
    modified: i,
    body: l,
    ...r
  } = e, a = $s(l || [], n), u = Array.isArray(e.target) ? e.target[0] : e.target, d = typeof u == "string" ? u : Array.isArray(u.selector) ? u.selector[0] : u.selector, f = ts(d) ? ns(d, t.invertY) : (d == null ? void 0 : d.type) === "SvgSelector" ? hs(d) : void 0, g = Array.isArray(r.target) ? r.target[0] : r.targret;
  return f || !t.strict ? {
    parsed: {
      ...r,
      id: n,
      bodies: a,
      target: {
        created: s ? new Date(s) : void 0,
        creator: Eo(o),
        updated: i ? new Date(i) : void 0,
        // Note the target can be a string and we don't want to spread the characters...
        ...typeof g == "string" ? {} : g,
        annotation: n,
        selector: f || d
      }
    }
  } : {
    error: Error(`Invalid selector: ${JSON.stringify(d)}`)
  };
}, oi = (e, t, n = { strict: !0, invertY: !1 }) => {
  const {
    selector: o,
    creator: s,
    created: i,
    updated: l,
    updatedBy: r,
    // Excluded from serialization
    ...a
  } = e.target;
  let u;
  try {
    o.type === Q.RECTANGLE && !o.geometry.rot ? u = os(o.geometry) : u = ps(o);
  } catch (f) {
    if (n.strict)
      throw f;
    u = o;
  }
  const d = {
    ...e,
    "@context": "http://www.w3.org/ns/anno.jsonld",
    id: e.id,
    type: "Annotation",
    body: ei(e.bodies),
    created: i == null ? void 0 : i.toISOString(),
    creator: s,
    modified: l == null ? void 0 : l.toISOString(),
    target: {
      ...a,
      source: t,
      type: "SpecificResource",
      selector: u
    }
  };
  return delete d.bodies, typeof d.target != "string" && "annotation" in d.target && delete d.target.annotation, d;
}, Fe = [];
function si(e, t = $) {
  let n;
  const o = /* @__PURE__ */ new Set();
  function s(r) {
    if (ae(e, r) && (e = r, n)) {
      const a = !Fe.length;
      for (const u of o)
        u[1](), Fe.push(u, e);
      if (a) {
        for (let u = 0; u < Fe.length; u += 2)
          Fe[u][0](Fe[u + 1]);
        Fe.length = 0;
      }
    }
  }
  function i(r) {
    s(r(e));
  }
  function l(r, a = $) {
    const u = [r, a];
    return o.add(u), o.size === 1 && (n = t(s, i) || $), r(e), () => {
      o.delete(u), o.size === 0 && n && (n(), n = null);
    };
  }
  return { set: s, update: i, subscribe: l };
}
const ii = (e, t) => {
  const { naturalWidth: n, naturalHeight: o } = e;
  if (!n && !o) {
    const { width: s, height: i } = e;
    t.setAttribute("viewBox", `0 0 ${s} ${i}`), e.addEventListener("load", (l) => {
      const r = l.target;
      t.setAttribute("viewBox", `0 0 ${r.naturalWidth} ${r.naturalHeight}`);
    });
  } else
    t.setAttribute("viewBox", `0 0 ${n} ${o}`);
}, ri = (e, t) => {
  ii(e, t);
  const { subscribe: n, set: o } = si(1);
  let s;
  return window.ResizeObserver && (s = new ResizeObserver(() => {
    const l = t.getBoundingClientRect(), { width: r, height: a } = t.viewBox.baseVal, u = Math.max(
      l.width / r,
      l.height / a
    );
    o(u);
  }), s.observe(t.parentElement)), { destroy: () => {
    s && s.disconnect();
  }, subscribe: n };
}, Ge = (e, t, n) => {
  const o = typeof t == "function" ? t(e, n) : t;
  if (o) {
    const { fill: s, fillOpacity: i, stroke: l, strokeWidth: r, strokeOpacity: a } = o;
    let u = "";
    return s && (u += `fill:${s};`), i || i === 0 ? u += `fill-opacity:${i};` : s && (u += "fill-opacity:0.25;"), l && (u += `stroke:${l};`, u += `stroke-width:${r || "1"};`, u += `stroke-opacity:${a || "1"};`), u;
  }
}, kt = (e, t = 0) => {
  const { minX: n, minY: o, maxX: s, maxY: i } = e;
  return {
    x: n - t,
    y: o - t,
    w: s - n + 2 * t,
    h: i - o + 2 * t
  };
}, Le = typeof window > "u" || typeof navigator > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0 || // @ts-ignore
navigator.msMaxTouchPoints > 0, li = (e) => ({}), hn = (e) => ({ grab: (
  /*onGrab*/
  e[0]
) });
function ai(e) {
  let t, n, o, s;
  const i = (
    /*#slots*/
    e[8].default
  ), l = Oo(
    i,
    e,
    /*$$scope*/
    e[7],
    hn
  );
  return {
    c() {
      t = I("g"), l && l.c(), c(t, "class", "a9s-annotation selected");
    },
    m(r, a) {
      R(r, t, a), l && l.m(t, null), n = !0, o || (s = [
        J(
          t,
          "pointerup",
          /*onRelease*/
          e[2]
        ),
        J(
          t,
          "pointermove",
          /*onPointerMove*/
          e[1]
        )
      ], o = !0);
    },
    p(r, [a]) {
      l && l.p && (!n || a & /*$$scope*/
      128) && No(
        l,
        i,
        r,
        /*$$scope*/
        r[7],
        n ? Do(
          i,
          /*$$scope*/
          r[7],
          a,
          li
        ) : Bo(
          /*$$scope*/
          r[7]
        ),
        hn
      );
    },
    i(r) {
      n || (U(l, r), n = !0);
    },
    o(r) {
      H(l, r), n = !1;
    },
    d(r) {
      r && B(t), l && l.d(r), o = !1, Se(s);
    }
  };
}
function ci(e, t, n) {
  let { $$slots: o = {}, $$scope: s } = t;
  const i = Ye();
  let { shape: l } = t, { editor: r } = t, { transform: a } = t, { svgEl: u } = t, d, f, g;
  const h = (S) => (w) => {
    if (d = S, u) {
      const { left: _, top: k } = u.getBoundingClientRect(), P = w.clientX - _, C = w.clientY - k;
      f = a.elementToImage(P, C);
    } else {
      const { offsetX: _, offsetY: k } = w;
      f = a.elementToImage(_, k);
    }
    g = l, w.target.setPointerCapture(w.pointerId), i("grab", w);
  }, p = (S) => {
    if (d) {
      const [w, A] = a.elementToImage(S.offsetX, S.offsetY), _ = [w - f[0], A - f[1]];
      n(3, l = r(g, d, _)), i("change", l);
    }
  }, y = (S) => {
    S.target.releasePointerCapture(S.pointerId), d = void 0, g = l, i("release", S);
  };
  return e.$$set = (S) => {
    "shape" in S && n(3, l = S.shape), "editor" in S && n(4, r = S.editor), "transform" in S && n(5, a = S.transform), "svgEl" in S && n(6, u = S.svgEl), "$$scope" in S && n(7, s = S.$$scope);
  }, [
    h,
    p,
    y,
    l,
    r,
    a,
    u,
    s,
    o
  ];
}
class nn extends ye {
  constructor(t) {
    super(), _e(this, t, ci, ai, ae, {
      shape: 3,
      editor: 4,
      transform: 5,
      svgEl: 6
    });
  }
}
function ui(e) {
  let t, n, o, s, i, l, r, a, u = (
    /*selected*/
    e[3] && mn(e)
  );
  return {
    c() {
      t = I("g"), n = I("circle"), u && u.c(), s = I("circle"), c(n, "class", "a9s-handle-buffer svelte-qtyc7s"), c(
        n,
        "cx",
        /*x*/
        e[0]
      ), c(
        n,
        "cy",
        /*y*/
        e[1]
      ), c(n, "r", o = /*handleRadius*/
      e[5] + 6 / /*scale*/
      e[2]), c(n, "role", "button"), c(n, "tabindex", "0"), c(s, "class", i = We(`a9s-handle-dot${/*selected*/
      e[3] ? " selected" : ""}`) + " svelte-qtyc7s"), c(
        s,
        "cx",
        /*x*/
        e[0]
      ), c(
        s,
        "cy",
        /*y*/
        e[1]
      ), c(
        s,
        "r",
        /*handleRadius*/
        e[5]
      ), c(t, "class", l = `a9s-handle ${/*$$props*/
      e[8].class || ""}`.trim());
    },
    m(d, f) {
      R(d, t, f), G(t, n), u && u.m(t, null), G(t, s), r || (a = [
        J(
          n,
          "dblclick",
          /*dblclick_handler_1*/
          e[12]
        ),
        J(
          n,
          "pointerenter",
          /*pointerenter_handler*/
          e[13]
        ),
        J(
          n,
          "pointerleave",
          /*pointerleave_handler*/
          e[14]
        ),
        J(
          n,
          "pointerdown",
          /*pointerdown_handler_1*/
          e[15]
        ),
        J(
          n,
          "pointerdown",
          /*onPointerDown*/
          e[6]
        ),
        J(
          n,
          "pointerup",
          /*pointerup_handler_1*/
          e[16]
        ),
        J(
          n,
          "pointerup",
          /*onPointerUp*/
          e[7]
        )
      ], r = !0);
    },
    p(d, f) {
      f & /*x*/
      1 && c(
        n,
        "cx",
        /*x*/
        d[0]
      ), f & /*y*/
      2 && c(
        n,
        "cy",
        /*y*/
        d[1]
      ), f & /*handleRadius, scale*/
      36 && o !== (o = /*handleRadius*/
      d[5] + 6 / /*scale*/
      d[2]) && c(n, "r", o), /*selected*/
      d[3] ? u ? u.p(d, f) : (u = mn(d), u.c(), u.m(t, s)) : u && (u.d(1), u = null), f & /*selected*/
      8 && i !== (i = We(`a9s-handle-dot${/*selected*/
      d[3] ? " selected" : ""}`) + " svelte-qtyc7s") && c(s, "class", i), f & /*x*/
      1 && c(
        s,
        "cx",
        /*x*/
        d[0]
      ), f & /*y*/
      2 && c(
        s,
        "cy",
        /*y*/
        d[1]
      ), f & /*handleRadius*/
      32 && c(
        s,
        "r",
        /*handleRadius*/
        d[5]
      ), f & /*$$props*/
      256 && l !== (l = `a9s-handle ${/*$$props*/
      d[8].class || ""}`.trim()) && c(t, "class", l);
    },
    d(d) {
      d && B(t), u && u.d(), r = !1, Se(a);
    }
  };
}
function fi(e) {
  let t, n, o, s, i, l, r, a, u;
  return {
    c() {
      t = I("g"), n = I("circle"), s = I("circle"), l = I("circle"), c(
        n,
        "cx",
        /*x*/
        e[0]
      ), c(
        n,
        "cy",
        /*y*/
        e[1]
      ), c(n, "r", o = /*handleRadius*/
      e[5] * 10), c(n, "class", "a9s-touch-halo"), Te(
        n,
        "touched",
        /*touched*/
        e[4]
      ), c(
        s,
        "cx",
        /*x*/
        e[0]
      ), c(
        s,
        "cy",
        /*y*/
        e[1]
      ), c(s, "r", i = /*handleRadius*/
      e[5] + 10 / /*scale*/
      e[2]), c(s, "class", "a9s-handle-buffer svelte-qtyc7s"), c(s, "role", "button"), c(s, "tabindex", "0"), c(l, "class", "a9s-handle-dot"), c(
        l,
        "cx",
        /*x*/
        e[0]
      ), c(
        l,
        "cy",
        /*y*/
        e[1]
      ), c(l, "r", r = /*handleRadius*/
      e[5] + 2 / /*scale*/
      e[2]), c(t, "class", "a9s-touch-handle");
    },
    m(d, f) {
      R(d, t, f), G(t, n), G(t, s), G(t, l), a || (u = [
        J(
          s,
          "dblclick",
          /*dblclick_handler*/
          e[9]
        ),
        J(
          s,
          "pointerdown",
          /*pointerdown_handler*/
          e[10]
        ),
        J(
          s,
          "pointerdown",
          /*onPointerDown*/
          e[6]
        ),
        J(
          s,
          "pointerup",
          /*pointerup_handler*/
          e[11]
        ),
        J(
          s,
          "pointerup",
          /*onPointerUp*/
          e[7]
        )
      ], a = !0);
    },
    p(d, f) {
      f & /*x*/
      1 && c(
        n,
        "cx",
        /*x*/
        d[0]
      ), f & /*y*/
      2 && c(
        n,
        "cy",
        /*y*/
        d[1]
      ), f & /*handleRadius*/
      32 && o !== (o = /*handleRadius*/
      d[5] * 10) && c(n, "r", o), f & /*touched*/
      16 && Te(
        n,
        "touched",
        /*touched*/
        d[4]
      ), f & /*x*/
      1 && c(
        s,
        "cx",
        /*x*/
        d[0]
      ), f & /*y*/
      2 && c(
        s,
        "cy",
        /*y*/
        d[1]
      ), f & /*handleRadius, scale*/
      36 && i !== (i = /*handleRadius*/
      d[5] + 10 / /*scale*/
      d[2]) && c(s, "r", i), f & /*x*/
      1 && c(
        l,
        "cx",
        /*x*/
        d[0]
      ), f & /*y*/
      2 && c(
        l,
        "cy",
        /*y*/
        d[1]
      ), f & /*handleRadius, scale*/
      36 && r !== (r = /*handleRadius*/
      d[5] + 2 / /*scale*/
      d[2]) && c(l, "r", r);
    },
    d(d) {
      d && B(t), a = !1, Se(u);
    }
  };
}
function mn(e) {
  let t, n;
  return {
    c() {
      t = I("circle"), c(t, "class", "a9s-handle-selected"), c(
        t,
        "cx",
        /*x*/
        e[0]
      ), c(
        t,
        "cy",
        /*y*/
        e[1]
      ), c(t, "r", n = /*handleRadius*/
      e[5] + 8 / /*scale*/
      e[2]);
    },
    m(o, s) {
      R(o, t, s);
    },
    p(o, s) {
      s & /*x*/
      1 && c(
        t,
        "cx",
        /*x*/
        o[0]
      ), s & /*y*/
      2 && c(
        t,
        "cy",
        /*y*/
        o[1]
      ), s & /*handleRadius, scale*/
      36 && n !== (n = /*handleRadius*/
      o[5] + 8 / /*scale*/
      o[2]) && c(t, "r", n);
    },
    d(o) {
      o && B(t);
    }
  };
}
function di(e) {
  let t;
  function n(i, l) {
    return Le ? fi : ui;
  }
  let s = n()(e);
  return {
    c() {
      s.c(), t = ke();
    },
    m(i, l) {
      s.m(i, l), R(i, t, l);
    },
    p(i, [l]) {
      s.p(i, l);
    },
    i: $,
    o: $,
    d(i) {
      i && B(t), s.d(i);
    }
  };
}
function gi(e, t, n) {
  let o, { x: s } = t, { y: i } = t, { scale: l } = t, { selected: r = void 0 } = t, a = !1;
  const u = (_) => {
    _.pointerType === "touch" && n(4, a = !0);
  }, d = () => n(4, a = !1);
  function f(_) {
    de.call(this, e, _);
  }
  function g(_) {
    de.call(this, e, _);
  }
  function h(_) {
    de.call(this, e, _);
  }
  function p(_) {
    de.call(this, e, _);
  }
  function y(_) {
    de.call(this, e, _);
  }
  function S(_) {
    de.call(this, e, _);
  }
  function w(_) {
    de.call(this, e, _);
  }
  function A(_) {
    de.call(this, e, _);
  }
  return e.$$set = (_) => {
    n(8, t = Wt(Wt({}, t), ln(_))), "x" in _ && n(0, s = _.x), "y" in _ && n(1, i = _.y), "scale" in _ && n(2, l = _.scale), "selected" in _ && n(3, r = _.selected);
  }, e.$$.update = () => {
    e.$$.dirty & /*scale*/
    4 && n(5, o = 4 / l);
  }, t = ln(t), [
    s,
    i,
    l,
    r,
    a,
    o,
    u,
    d,
    t,
    f,
    g,
    h,
    p,
    y,
    S,
    w,
    A
  ];
}
class Ve extends ye {
  constructor(t) {
    super(), _e(this, t, gi, di, ae, { x: 0, y: 1, scale: 2, selected: 3 });
  }
}
function hi(e) {
  let t, n, o, s, i, l, r;
  return {
    c() {
      t = I("g"), n = I("circle"), s = I("circle"), i = I("circle"), c(n, "class", "a9s-polygon-midpoint-buffer svelte-12ykj76"), c(
        n,
        "cx",
        /*x*/
        e[0]
      ), c(
        n,
        "cy",
        /*y*/
        e[1]
      ), c(n, "r", o = 1.75 * /*handleRadius*/
      e[2]), c(s, "class", "a9s-polygon-midpoint-outer svelte-12ykj76"), c(
        s,
        "cx",
        /*x*/
        e[0]
      ), c(
        s,
        "cy",
        /*y*/
        e[1]
      ), c(
        s,
        "r",
        /*handleRadius*/
        e[2]
      ), c(i, "class", "a9s-polygon-midpoint-inner svelte-12ykj76"), c(
        i,
        "cx",
        /*x*/
        e[0]
      ), c(
        i,
        "cy",
        /*y*/
        e[1]
      ), c(
        i,
        "r",
        /*handleRadius*/
        e[2]
      ), c(t, "class", "a9s-polygon-midpoint svelte-12ykj76");
    },
    m(a, u) {
      R(a, t, u), G(t, n), G(t, s), G(t, i), l || (r = [
        J(
          n,
          "pointerdown",
          /*pointerdown_handler*/
          e[5]
        ),
        J(
          n,
          "pointerdown",
          /*onPointerDown*/
          e[3]
        )
      ], l = !0);
    },
    p(a, u) {
      u & /*x*/
      1 && c(
        n,
        "cx",
        /*x*/
        a[0]
      ), u & /*y*/
      2 && c(
        n,
        "cy",
        /*y*/
        a[1]
      ), u & /*handleRadius*/
      4 && o !== (o = 1.75 * /*handleRadius*/
      a[2]) && c(n, "r", o), u & /*x*/
      1 && c(
        s,
        "cx",
        /*x*/
        a[0]
      ), u & /*y*/
      2 && c(
        s,
        "cy",
        /*y*/
        a[1]
      ), u & /*handleRadius*/
      4 && c(
        s,
        "r",
        /*handleRadius*/
        a[2]
      ), u & /*x*/
      1 && c(
        i,
        "cx",
        /*x*/
        a[0]
      ), u & /*y*/
      2 && c(
        i,
        "cy",
        /*y*/
        a[1]
      ), u & /*handleRadius*/
      4 && c(
        i,
        "r",
        /*handleRadius*/
        a[2]
      );
    },
    d(a) {
      a && B(t), l = !1, Se(r);
    }
  };
}
function mi(e) {
  let t;
  return {
    c() {
      t = I("circle"), c(
        t,
        "cx",
        /*x*/
        e[0]
      ), c(
        t,
        "cy",
        /*y*/
        e[1]
      ), c(
        t,
        "r",
        /*handleRadius*/
        e[2]
      );
    },
    m(n, o) {
      R(n, t, o);
    },
    p(n, o) {
      o & /*x*/
      1 && c(
        t,
        "cx",
        /*x*/
        n[0]
      ), o & /*y*/
      2 && c(
        t,
        "cy",
        /*y*/
        n[1]
      ), o & /*handleRadius*/
      4 && c(
        t,
        "r",
        /*handleRadius*/
        n[2]
      );
    },
    d(n) {
      n && B(t);
    }
  };
}
function pi(e) {
  let t;
  function n(i, l) {
    return Le ? mi : hi;
  }
  let s = n()(e);
  return {
    c() {
      s.c(), t = ke();
    },
    m(i, l) {
      s.m(i, l), R(i, t, l);
    },
    p(i, [l]) {
      s.p(i, l);
    },
    i: $,
    o: $,
    d(i) {
      i && B(t), s.d(i);
    }
  };
}
function _i(e, t, n) {
  let o, { x: s } = t, { y: i } = t, { scale: l } = t;
  const r = (u) => {
    u.pointerType;
  };
  function a(u) {
    de.call(this, e, u);
  }
  return e.$$set = (u) => {
    "x" in u && n(0, s = u.x), "y" in u && n(1, i = u.y), "scale" in u && n(4, l = u.scale);
  }, e.$$.update = () => {
    e.$$.dirty & /*scale*/
    16 && n(2, o = 4 / l);
  }, [s, i, o, r, l, a];
}
class vo extends ye {
  constructor(t) {
    super(), _e(this, t, _i, pi, ae, { x: 0, y: 1, scale: 4 });
  }
}
function Ut(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[28] = n.point, t;
}
function pn(e, t, n) {
  const o = e.slice();
  return o[28] = t[n], o[30] = n, o;
}
function Vt(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[28] = n.point, t;
}
function Xt(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[28] = n.point, t;
}
function _n(e) {
  let t, n, o, s;
  return {
    c() {
      t = I("circle"), c(t, "cx", n = /*point*/
      e[28][0]), c(t, "cy", o = /*point*/
      e[28][1]), c(t, "r", s = nt / /*viewportScale*/
      e[3]), c(t, "class", "svelte-1h2slbm");
    },
    m(i, l) {
      R(i, t, l);
    },
    p(i, l) {
      l[0] & /*midpoints, visibleMidpoint*/
      1088 && n !== (n = /*point*/
      i[28][0]) && c(t, "cx", n), l[0] & /*midpoints, visibleMidpoint*/
      1088 && o !== (o = /*point*/
      i[28][1]) && c(t, "cy", o), l[0] & /*viewportScale*/
      8 && s !== (s = nt / /*viewportScale*/
      i[3]) && c(t, "r", s);
    },
    d(i) {
      i && B(t);
    }
  };
}
function yn(e) {
  let t, n, o, s, i, l, r, a, u, d;
  return {
    c() {
      t = I("mask"), n = I("rect"), r = I("circle"), c(n, "x", o = /*mask*/
      e[9].x), c(n, "y", s = /*mask*/
      e[9].y), c(n, "width", i = /*mask*/
      e[9].w), c(n, "height", l = /*mask*/
      e[9].h), c(n, "class", "svelte-1h2slbm"), c(r, "cx", a = /*point*/
      e[28][0]), c(r, "cy", u = /*point*/
      e[28][1]), c(r, "r", d = nt / /*viewportScale*/
      e[3]), c(r, "class", "svelte-1h2slbm"), c(t, "id", `${/*maskId*/
      e[19]}-inner`), c(t, "class", "a9s-polygon-editor-mask svelte-1h2slbm");
    },
    m(f, g) {
      R(f, t, g), G(t, n), G(t, r);
    },
    p(f, g) {
      g[0] & /*mask*/
      512 && o !== (o = /*mask*/
      f[9].x) && c(n, "x", o), g[0] & /*mask*/
      512 && s !== (s = /*mask*/
      f[9].y) && c(n, "y", s), g[0] & /*mask*/
      512 && i !== (i = /*mask*/
      f[9].w) && c(n, "width", i), g[0] & /*mask*/
      512 && l !== (l = /*mask*/
      f[9].h) && c(n, "height", l), g[0] & /*midpoints, visibleMidpoint*/
      1088 && a !== (a = /*point*/
      f[28][0]) && c(r, "cx", a), g[0] & /*midpoints, visibleMidpoint*/
      1088 && u !== (u = /*point*/
      f[28][1]) && c(r, "cy", u), g[0] & /*viewportScale*/
      8 && d !== (d = nt / /*viewportScale*/
      f[3]) && c(r, "r", d);
    },
    d(f) {
      f && B(t);
    }
  };
}
function wn(e) {
  let t, n;
  return t = new Ve({
    props: {
      class: "a9s-corner-handle",
      x: (
        /*point*/
        e[28][0]
      ),
      y: (
        /*point*/
        e[28][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      ),
      selected: (
        /*selectedCorners*/
        e[8].includes(
          /*idx*/
          e[30]
        )
      )
    }
  }), t.$on(
    "pointerenter",
    /*onEnterHandle*/
    e[11]
  ), t.$on(
    "pointerleave",
    /*onLeaveHandle*/
    e[12]
  ), t.$on(
    "pointerdown",
    /*onHandlePointerDown*/
    e[15]
  ), t.$on("pointerdown", function() {
    se(
      /*grab*/
      e[27](`HANDLE-${/*idx*/
      e[30]}`)
    ) && e[27](`HANDLE-${/*idx*/
    e[30]}`).apply(this, arguments);
  }), t.$on(
    "pointerup",
    /*onHandlePointerUp*/
    e[16](
      /*idx*/
      e[30]
    )
  ), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      e = o;
      const i = {};
      s[0] & /*geom*/
      32 && (i.x = /*point*/
      e[28][0]), s[0] & /*geom*/
      32 && (i.y = /*point*/
      e[28][1]), s[0] & /*viewportScale*/
      8 && (i.scale = /*viewportScale*/
      e[3]), s[0] & /*selectedCorners*/
      256 && (i.selected = /*selectedCorners*/
      e[8].includes(
        /*idx*/
        e[30]
      )), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function bn(e) {
  let t, n;
  return t = new vo({
    props: {
      x: (
        /*point*/
        e[28][0]
      ),
      y: (
        /*point*/
        e[28][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), t.$on("pointerdown", function() {
    se(
      /*onAddPoint*/
      e[18](
        /*visibleMidpoint*/
        e[6]
      )
    ) && e[18](
      /*visibleMidpoint*/
      e[6]
    ).apply(this, arguments);
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      e = o;
      const i = {};
      s[0] & /*midpoints, visibleMidpoint*/
      1088 && (i.x = /*point*/
      e[28][0]), s[0] & /*midpoints, visibleMidpoint*/
      1088 && (i.y = /*point*/
      e[28][1]), s[0] & /*viewportScale*/
      8 && (i.scale = /*viewportScale*/
      e[3]), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function yi(e) {
  let t, n, o, s, i, l, r, a, u, d, f, g, h, p, y, S, w, A, _, k, P, C = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && _n(Xt(e))
  ), T = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && yn(Vt(e))
  ), Y = ve(
    /*geom*/
    e[5].points
  ), D = [];
  for (let v = 0; v < Y.length; v += 1)
    D[v] = wn(pn(e, Y, v));
  const x = (v) => H(D[v], 1, 1, () => {
    D[v] = null;
  });
  let j = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && bn(Ut(e))
  );
  return {
    c() {
      t = I("defs"), n = I("mask"), o = I("rect"), a = I("polygon"), C && C.c(), T && T.c(), d = we(), f = I("polygon"), h = we(), p = I("polygon"), S = we();
      for (let v = 0; v < D.length; v += 1)
        D[v].c();
      w = we(), j && j.c(), A = ke(), c(o, "x", s = /*mask*/
      e[9].x), c(o, "y", i = /*mask*/
      e[9].y), c(o, "width", l = /*mask*/
      e[9].w), c(o, "height", r = /*mask*/
      e[9].h), c(o, "class", "svelte-1h2slbm"), c(a, "points", u = /*geom*/
      e[5].points.map(En).join(" ")), c(a, "class", "svelte-1h2slbm"), c(n, "id", `${/*maskId*/
      e[19]}-outer`), c(n, "class", "a9s-polygon-editor-mask svelte-1h2slbm"), c(f, "class", "a9s-outer"), c(f, "mask", `url(#${/*maskId*/
      e[19]}-outer)`), c(f, "points", g = /*geom*/
      e[5].points.map(vn).join(" ")), c(p, "class", "a9s-inner a9s-shape-handle"), c(p, "mask", `url(#${/*maskId*/
      e[19]}-inner)`), c(
        p,
        "style",
        /*computedStyle*/
        e[1]
      ), c(p, "points", y = /*geom*/
      e[5].points.map(An).join(" "));
    },
    m(v, E) {
      R(v, t, E), G(t, n), G(n, o), G(n, a), C && C.m(n, null), T && T.m(t, null), R(v, d, E), R(v, f, E), R(v, h, E), R(v, p, E), R(v, S, E);
      for (let m = 0; m < D.length; m += 1)
        D[m] && D[m].m(v, E);
      R(v, w, E), j && j.m(v, E), R(v, A, E), _ = !0, k || (P = [
        J(
          f,
          "pointerup",
          /*onShapePointerUp*/
          e[14]
        ),
        J(f, "pointerdown", function() {
          se(
            /*grab*/
            e[27]("SHAPE")
          ) && e[27]("SHAPE").apply(this, arguments);
        }),
        J(
          p,
          "pointermove",
          /*onPointerMove*/
          e[13]
        ),
        J(
          p,
          "pointerup",
          /*onShapePointerUp*/
          e[14]
        ),
        J(p, "pointerdown", function() {
          se(
            /*grab*/
            e[27]("SHAPE")
          ) && e[27]("SHAPE").apply(this, arguments);
        })
      ], k = !0);
    },
    p(v, E) {
      if (e = v, (!_ || E[0] & /*mask*/
      512 && s !== (s = /*mask*/
      e[9].x)) && c(o, "x", s), (!_ || E[0] & /*mask*/
      512 && i !== (i = /*mask*/
      e[9].y)) && c(o, "y", i), (!_ || E[0] & /*mask*/
      512 && l !== (l = /*mask*/
      e[9].w)) && c(o, "width", l), (!_ || E[0] & /*mask*/
      512 && r !== (r = /*mask*/
      e[9].h)) && c(o, "height", r), (!_ || E[0] & /*geom*/
      32 && u !== (u = /*geom*/
      e[5].points.map(En).join(" "))) && c(a, "points", u), /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? C ? C.p(Xt(e), E) : (C = _n(Xt(e)), C.c(), C.m(n, null)) : C && (C.d(1), C = null), /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? T ? T.p(Vt(e), E) : (T = yn(Vt(e)), T.c(), T.m(t, null)) : T && (T.d(1), T = null), (!_ || E[0] & /*geom*/
      32 && g !== (g = /*geom*/
      e[5].points.map(vn).join(" "))) && c(f, "points", g), (!_ || E[0] & /*computedStyle*/
      2) && c(
        p,
        "style",
        /*computedStyle*/
        e[1]
      ), (!_ || E[0] & /*geom*/
      32 && y !== (y = /*geom*/
      e[5].points.map(An).join(" "))) && c(p, "points", y), E[0] & /*geom, viewportScale, selectedCorners, onEnterHandle, onLeaveHandle, onHandlePointerDown, grab, onHandlePointerUp*/
      134322472) {
        Y = ve(
          /*geom*/
          e[5].points
        );
        let m;
        for (m = 0; m < Y.length; m += 1) {
          const b = pn(e, Y, m);
          D[m] ? (D[m].p(b, E), U(D[m], 1)) : (D[m] = wn(b), D[m].c(), U(D[m], 1), D[m].m(w.parentNode, w));
        }
        for (be(), m = Y.length; m < D.length; m += 1)
          x(m);
        Ee();
      }
      /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? j ? (j.p(Ut(e), E), E[0] & /*visibleMidpoint, isHandleHovered*/
      192 && U(j, 1)) : (j = bn(Ut(e)), j.c(), U(j, 1), j.m(A.parentNode, A)) : j && (be(), H(j, 1, 1, () => {
        j = null;
      }), Ee());
    },
    i(v) {
      if (!_) {
        for (let E = 0; E < Y.length; E += 1)
          U(D[E]);
        U(j), _ = !0;
      }
    },
    o(v) {
      D = D.filter(Boolean);
      for (let E = 0; E < D.length; E += 1)
        H(D[E]);
      H(j), _ = !1;
    },
    d(v) {
      v && (B(t), B(d), B(f), B(h), B(p), B(S), B(w), B(A)), C && C.d(), T && T.d(), He(D, v), j && j.d(v), k = !1, Se(P);
    }
  };
}
function wi(e) {
  let t, n;
  return t = new nn({
    props: {
      shape: (
        /*shape*/
        e[0]
      ),
      transform: (
        /*transform*/
        e[2]
      ),
      editor: (
        /*editor*/
        e[17]
      ),
      svgEl: (
        /*svgEl*/
        e[4]
      ),
      $$slots: {
        default: [
          yi,
          ({ grab: o }) => ({ 27: o }),
          ({ grab: o }) => [o ? 134217728 : 0]
        ]
      },
      $$scope: { ctx: e }
    }
  }), t.$on(
    "change",
    /*change_handler*/
    e[20]
  ), t.$on(
    "grab",
    /*grab_handler*/
    e[21]
  ), t.$on(
    "release",
    /*release_handler*/
    e[22]
  ), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*shape*/
      1 && (i.shape = /*shape*/
      o[0]), s[0] & /*transform*/
      4 && (i.transform = /*transform*/
      o[2]), s[0] & /*svgEl*/
      16 && (i.svgEl = /*svgEl*/
      o[4]), s[0] & /*midpoints, visibleMidpoint, viewportScale, isHandleHovered, geom, selectedCorners, grab, computedStyle, mask*/
      134219754 | s[1] & /*$$scope*/
      1 && (i.$$scope = { dirty: s, ctx: o }), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
const bi = 250, Ei = 1e3, vi = 12, nt = 4.5, En = (e) => e.join(","), vn = (e) => e.join(","), An = (e) => e.join(",");
function Ai(e, t, n) {
  let o, s, i;
  const l = Ye();
  let { shape: r } = t, { computedStyle: a } = t, { transform: u } = t, { viewportScale: d = 1 } = t, { svgEl: f } = t, g, h = !1, p, y = [];
  const S = () => n(7, h = !0), w = () => n(7, h = !1), A = (m) => {
    if (y.length > 0 || !s.some((q) => q.visible)) {
      n(6, g = void 0);
      return;
    }
    const [b, L] = u.elementToImage(m.offsetX, m.offsetY), M = (q) => Math.pow(q[0] - b, 2) + Math.pow(q[1] - L, 2), O = o.points.reduce((q, K) => M(K) < M(q) ? K : q), F = s.filter((q) => q.visible).reduce((q, K) => M(K.point) < M(q.point) ? K : q), V = Math.pow(Ei / d, 2);
    M(O) < V || M(F.point) < V ? n(6, g = s.indexOf(F)) : n(6, g = void 0);
  }, _ = () => {
    document.activeElement !== f && f.focus();
  }, k = () => {
    n(8, y = []), _();
  }, P = (m) => {
    n(7, h = !0), m.preventDefault(), m.stopPropagation(), p = performance.now();
  }, C = (m) => (b) => {
    if (!p || Le || performance.now() - p > bi) return;
    const L = y.includes(m);
    b.metaKey || b.ctrlKey || b.shiftKey ? L ? n(8, y = y.filter((M) => M !== m)) : n(8, y = [...y, m]) : L && y.length > 1 ? n(8, y = [m]) : L ? n(8, y = []) : n(8, y = [m]), _();
  }, T = (m, b, L) => {
    _();
    let M;
    const O = m.geometry;
    y.length > 1 ? M = O.points.map(([V, Z], q) => y.includes(q) ? [V + L[0], Z + L[1]] : [V, Z]) : b === "SHAPE" ? M = O.points.map(([V, Z]) => [V + L[0], Z + L[1]]) : M = O.points.map(([V, Z], q) => b === `HANDLE-${q}` ? [V + L[0], Z + L[1]] : [V, Z]);
    const F = fe(M);
    return { ...m, geometry: { points: M, bounds: F } };
  }, Y = (m) => async (b) => {
    b.stopPropagation();
    const L = [
      ...o.points.slice(0, m + 1),
      s[m].point,
      ...o.points.slice(m + 1)
    ], M = fe(L);
    l("change", { ...r, geometry: { points: L, bounds: M } }), await ao();
    const O = [...document.querySelectorAll(".a9s-handle")][m + 1];
    if (O != null && O.firstChild) {
      const F = new PointerEvent(
        "pointerdown",
        {
          bubbles: !0,
          cancelable: !0,
          clientX: b.clientX,
          clientY: b.clientY,
          pointerId: b.pointerId,
          pointerType: b.pointerType,
          isPrimary: b.isPrimary,
          buttons: b.buttons
        }
      );
      O.firstChild.dispatchEvent(F);
    }
  }, D = () => {
    if (o.points.length - y.length < 3) return;
    const m = o.points.filter((L, M) => !y.includes(M)), b = fe(m);
    l("change", { ...r, geometry: { points: m, bounds: b } }), n(8, y = []);
  };
  Re(() => {
    if (Le) return;
    const m = (b) => {
      (b.key === "Delete" || b.key === "Backspace") && (b.preventDefault(), D());
    };
    return f.addEventListener("pointermove", A), f.addEventListener("keydown", m), () => {
      f.removeEventListener("pointermove", A), f.removeEventListener("keydown", m);
    };
  });
  const x = `polygon-mask-${Math.random().toString(36).substring(2, 12)}`;
  function j(m) {
    de.call(this, e, m);
  }
  function v(m) {
    de.call(this, e, m);
  }
  function E(m) {
    de.call(this, e, m);
  }
  return e.$$set = (m) => {
    "shape" in m && n(0, r = m.shape), "computedStyle" in m && n(1, a = m.computedStyle), "transform" in m && n(2, u = m.transform), "viewportScale" in m && n(3, d = m.viewportScale), "svgEl" in m && n(4, f = m.svgEl);
  }, e.$$.update = () => {
    e.$$.dirty[0] & /*shape*/
    1 && n(5, o = r.geometry), e.$$.dirty[0] & /*geom, viewportScale*/
    40 && n(10, s = Le ? [] : o.points.map((m, b) => {
      const L = b === o.points.length - 1 ? o.points[0] : o.points[b + 1], M = (m[0] + L[0]) / 2, O = (m[1] + L[1]) / 2, V = Math.sqrt(Math.pow(L[0] - M, 2) + Math.pow(L[1] - O, 2)) > vi / d;
      return { point: [M, O], visible: V };
    })), e.$$.dirty[0] & /*geom, viewportScale*/
    40 && n(9, i = kt(o.bounds, nt / d));
  }, [
    r,
    a,
    u,
    d,
    f,
    o,
    g,
    h,
    y,
    i,
    s,
    S,
    w,
    A,
    k,
    P,
    C,
    T,
    Y,
    x,
    j,
    v,
    E
  ];
}
class Si extends ye {
  constructor(t) {
    super(), _e(
      this,
      t,
      Ai,
      wi,
      ae,
      {
        shape: 0,
        computedStyle: 1,
        transform: 2,
        viewportScale: 3,
        svgEl: 4
      },
      null,
      [-1, -1]
    );
  }
}
const Ao = (e, t, n) => {
  const [o, s] = e, [i, l] = t, r = Math.cos(n), a = Math.sin(n), u = o - i, d = s - l;
  return [
    i + u * r - d * a,
    l + u * a + d * r
  ];
}, ki = (e, t, n, o, s = 0) => {
  const i = [
    [e, t],
    [e + n, t],
    [e + n, t + o],
    [e, t + o]
  ], l = [e + n / 2, t + o / 2];
  return i.map((r) => Ao(r, l, s));
}, Sn = (e, t) => {
  const { x: n, y: o, w: s, h: i, rot: l = 0 } = e, r = [n + s / 2, o + i / 2];
  let a = [n + s / 2, o - t];
  return Ao(a, r, l);
}, Mi = (e, t, n) => {
  const o = Math.cos(n), s = Math.sin(n);
  return [
    e * o + t * s,
    -e * s + t * o
  ];
}, Ti = (e, t, n) => {
  const o = e[0] - n[0], s = e[1] - n[1], i = Math.atan2(s, o), l = t[0] - n[0], r = t[1] - n[1];
  return Math.atan2(r, l) - i;
}, Pi = (e, t = 10) => {
  const n = t * Math.PI / 180;
  return Math.round(e / n) * n;
};
function Li(e) {
  let t, n, o, s, i, l, r, a, u, d, f, g, h, p, y, S, w, A, _, k, P, C, T, Y, D, x, j, v, E, m, b, L, M, O, F, V, Z, q, K, ee, ge, ne, Ae, X, ue, te, he, ie, Ue, it, rt, lt, Mt, Ie, Tt, Ce, Pt, Oe, Lt, De, W, It, sn;
  return C = new Ve({
    props: {
      class: "a9s-rotation-handle",
      x: (
        /*rotationHandlePos*/
        e[7][0]
      ),
      y: (
        /*rotationHandlePos*/
        e[7][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), C.$on("pointerdown", function() {
    se(
      /*grab*/
      e[16]("ROTATION")
    ) && e[16]("ROTATION").apply(this, arguments);
  }), Ie = new Ve({
    props: {
      class: "a9s-corner-handle-topleft",
      x: (
        /*rotatedCorners*/
        e[6][0][0]
      ),
      y: (
        /*rotatedCorners*/
        e[6][0][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), Ie.$on("pointerdown", function() {
    se(
      /*grab*/
      e[16]("TOP_LEFT")
    ) && e[16]("TOP_LEFT").apply(this, arguments);
  }), Ce = new Ve({
    props: {
      class: "a9s-corner-handle-topright",
      x: (
        /*rotatedCorners*/
        e[6][1][0]
      ),
      y: (
        /*rotatedCorners*/
        e[6][1][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), Ce.$on("pointerdown", function() {
    se(
      /*grab*/
      e[16]("TOP_RIGHT")
    ) && e[16]("TOP_RIGHT").apply(this, arguments);
  }), Oe = new Ve({
    props: {
      class: "a9s-corner-handle-bottomright",
      x: (
        /*rotatedCorners*/
        e[6][2][0]
      ),
      y: (
        /*rotatedCorners*/
        e[6][2][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), Oe.$on("pointerdown", function() {
    se(
      /*grab*/
      e[16]("BOTTOM_RIGHT")
    ) && e[16]("BOTTOM_RIGHT").apply(this, arguments);
  }), De = new Ve({
    props: {
      class: "a9s-corner-handle-bottomleft",
      x: (
        /*rotatedCorners*/
        e[6][3][0]
      ),
      y: (
        /*rotatedCorners*/
        e[6][3][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), De.$on("pointerdown", function() {
    se(
      /*grab*/
      e[16]("BOTTOM_LEFT")
    ) && e[16]("BOTTOM_LEFT").apply(this, arguments);
  }), {
    c() {
      t = I("defs"), n = I("mask"), o = I("rect"), a = I("polygon"), d = we(), f = I("g"), g = I("line"), w = I("line"), ce(C.$$.fragment), T = we(), Y = I("g"), D = I("polygon"), j = I("polygon"), E = we(), m = I("line"), F = we(), V = I("line"), ge = we(), ne = I("line"), he = we(), ie = I("line"), Mt = we(), ce(Ie.$$.fragment), Tt = we(), ce(Ce.$$.fragment), Pt = we(), ce(Oe.$$.fragment), Lt = we(), ce(De.$$.fragment), c(o, "class", "rect-mask-bg svelte-1bwhzbc"), c(o, "x", s = /*mask*/
      e[5].x), c(o, "y", i = /*mask*/
      e[5].y), c(o, "width", l = /*mask*/
      e[5].w), c(o, "height", r = /*mask*/
      e[5].h), c(a, "class", "rect-mask-fg svelte-1bwhzbc"), c(a, "points", u = /*rotatedCorners*/
      e[6].map(kn).join(" ")), c(
        n,
        "id",
        /*maskId*/
        e[9]
      ), c(n, "class", "a9s-rectangle-editor-mask svelte-1bwhzbc"), c(g, "class", "a9s-rotation-handle-line-bg"), c(g, "x1", h = /*rotatedCorners*/
      e[6][0][0] + /*rotatedCorners*/
      (e[6][1][0] - /*rotatedCorners*/
      e[6][0][0]) / 2), c(g, "y1", p = /*rotatedCorners*/
      e[6][0][1] + /*rotatedCorners*/
      (e[6][1][1] - /*rotatedCorners*/
      e[6][0][1]) / 2), c(g, "x2", y = /*rotationHandlePos*/
      e[7][0]), c(g, "y2", S = /*rotationHandlePos*/
      e[7][1]), c(g, "pointer-events", "none"), c(w, "class", "a9s-rotation-handle-line-fg"), c(w, "x1", A = /*rotatedCorners*/
      e[6][0][0] + /*rotatedCorners*/
      (e[6][1][0] - /*rotatedCorners*/
      e[6][0][0]) / 2), c(w, "y1", _ = /*rotatedCorners*/
      e[6][0][1] + /*rotatedCorners*/
      (e[6][1][1] - /*rotatedCorners*/
      e[6][0][1]) / 2), c(w, "x2", k = /*rotationHandlePos*/
      e[7][0]), c(w, "y2", P = /*rotationHandlePos*/
      e[7][1]), c(w, "pointer-events", "none"), c(D, "class", "a9s-outer"), c(D, "mask", `url(#${/*maskId*/
      e[9]})`), c(D, "points", x = /*rotatedCorners*/
      e[6].map(Mn).join(" ")), c(j, "class", "a9s-inner a9s-shape-handle"), c(
        j,
        "style",
        /*computedStyle*/
        e[1]
      ), c(j, "points", v = /*rotatedCorners*/
      e[6].map(Tn).join(" ")), c(m, "class", "a9s-edge-handle a9s-edge-handle-top"), c(m, "x1", b = /*rotatedCorners*/
      e[6][0][0]), c(m, "y1", L = /*rotatedCorners*/
      e[6][0][1]), c(m, "x2", M = /*rotatedCorners*/
      e[6][1][0]), c(m, "y2", O = /*rotatedCorners*/
      e[6][1][1]), c(V, "class", "a9s-edge-handle a9s-edge-handle-right"), c(V, "x1", Z = /*rotatedCorners*/
      e[6][1][0]), c(V, "y1", q = /*rotatedCorners*/
      e[6][1][1]), c(V, "x2", K = /*rotatedCorners*/
      e[6][2][0]), c(V, "y2", ee = /*rotatedCorners*/
      e[6][2][1]), c(ne, "class", "a9s-edge-handle a9s-edge-handle-bottom"), c(ne, "x1", Ae = /*rotatedCorners*/
      e[6][2][0]), c(ne, "y1", X = /*rotatedCorners*/
      e[6][2][1]), c(ne, "x2", ue = /*rotatedCorners*/
      e[6][3][0]), c(ne, "y2", te = /*rotatedCorners*/
      e[6][3][1]), c(ie, "class", "a9s-edge-handle a9s-edge-handle-left"), c(ie, "x1", Ue = /*rotatedCorners*/
      e[6][3][0]), c(ie, "y1", it = /*rotatedCorners*/
      e[6][3][1]), c(ie, "x2", rt = /*rotatedCorners*/
      e[6][0][0]), c(ie, "y2", lt = /*rotatedCorners*/
      e[6][0][1]);
    },
    m(z, N) {
      R(z, t, N), G(t, n), G(n, o), G(n, a), R(z, d, N), R(z, f, N), G(f, g), G(f, w), re(C, f, null), R(z, T, N), R(z, Y, N), G(Y, D), G(Y, j), R(z, E, N), R(z, m, N), R(z, F, N), R(z, V, N), R(z, ge, N), R(z, ne, N), R(z, he, N), R(z, ie, N), R(z, Mt, N), re(Ie, z, N), R(z, Tt, N), re(Ce, z, N), R(z, Pt, N), re(Oe, z, N), R(z, Lt, N), re(De, z, N), W = !0, It || (sn = [
        J(D, "pointerdown", function() {
          se(
            /*grab*/
            e[16]("SHAPE")
          ) && e[16]("SHAPE").apply(this, arguments);
        }),
        J(j, "pointerdown", function() {
          se(
            /*grab*/
            e[16]("SHAPE")
          ) && e[16]("SHAPE").apply(this, arguments);
        }),
        J(m, "pointerdown", function() {
          se(
            /*grab*/
            e[16]("TOP")
          ) && e[16]("TOP").apply(this, arguments);
        }),
        J(V, "pointerdown", function() {
          se(
            /*grab*/
            e[16]("RIGHT")
          ) && e[16]("RIGHT").apply(this, arguments);
        }),
        J(ne, "pointerdown", function() {
          se(
            /*grab*/
            e[16]("BOTTOM")
          ) && e[16]("BOTTOM").apply(this, arguments);
        }),
        J(ie, "pointerdown", function() {
          se(
            /*grab*/
            e[16]("LEFT")
          ) && e[16]("LEFT").apply(this, arguments);
        })
      ], It = !0);
    },
    p(z, N) {
      e = z, (!W || N & /*mask*/
      32 && s !== (s = /*mask*/
      e[5].x)) && c(o, "x", s), (!W || N & /*mask*/
      32 && i !== (i = /*mask*/
      e[5].y)) && c(o, "y", i), (!W || N & /*mask*/
      32 && l !== (l = /*mask*/
      e[5].w)) && c(o, "width", l), (!W || N & /*mask*/
      32 && r !== (r = /*mask*/
      e[5].h)) && c(o, "height", r), (!W || N & /*rotatedCorners*/
      64 && u !== (u = /*rotatedCorners*/
      e[6].map(kn).join(" "))) && c(a, "points", u), (!W || N & /*rotatedCorners*/
      64 && h !== (h = /*rotatedCorners*/
      e[6][0][0] + /*rotatedCorners*/
      (e[6][1][0] - /*rotatedCorners*/
      e[6][0][0]) / 2)) && c(g, "x1", h), (!W || N & /*rotatedCorners*/
      64 && p !== (p = /*rotatedCorners*/
      e[6][0][1] + /*rotatedCorners*/
      (e[6][1][1] - /*rotatedCorners*/
      e[6][0][1]) / 2)) && c(g, "y1", p), (!W || N & /*rotationHandlePos*/
      128 && y !== (y = /*rotationHandlePos*/
      e[7][0])) && c(g, "x2", y), (!W || N & /*rotationHandlePos*/
      128 && S !== (S = /*rotationHandlePos*/
      e[7][1])) && c(g, "y2", S), (!W || N & /*rotatedCorners*/
      64 && A !== (A = /*rotatedCorners*/
      e[6][0][0] + /*rotatedCorners*/
      (e[6][1][0] - /*rotatedCorners*/
      e[6][0][0]) / 2)) && c(w, "x1", A), (!W || N & /*rotatedCorners*/
      64 && _ !== (_ = /*rotatedCorners*/
      e[6][0][1] + /*rotatedCorners*/
      (e[6][1][1] - /*rotatedCorners*/
      e[6][0][1]) / 2)) && c(w, "y1", _), (!W || N & /*rotationHandlePos*/
      128 && k !== (k = /*rotationHandlePos*/
      e[7][0])) && c(w, "x2", k), (!W || N & /*rotationHandlePos*/
      128 && P !== (P = /*rotationHandlePos*/
      e[7][1])) && c(w, "y2", P);
      const at = {};
      N & /*rotationHandlePos*/
      128 && (at.x = /*rotationHandlePos*/
      e[7][0]), N & /*rotationHandlePos*/
      128 && (at.y = /*rotationHandlePos*/
      e[7][1]), N & /*viewportScale*/
      8 && (at.scale = /*viewportScale*/
      e[3]), C.$set(at), (!W || N & /*rotatedCorners*/
      64 && x !== (x = /*rotatedCorners*/
      e[6].map(Mn).join(" "))) && c(D, "points", x), (!W || N & /*computedStyle*/
      2) && c(
        j,
        "style",
        /*computedStyle*/
        e[1]
      ), (!W || N & /*rotatedCorners*/
      64 && v !== (v = /*rotatedCorners*/
      e[6].map(Tn).join(" "))) && c(j, "points", v), (!W || N & /*rotatedCorners*/
      64 && b !== (b = /*rotatedCorners*/
      e[6][0][0])) && c(m, "x1", b), (!W || N & /*rotatedCorners*/
      64 && L !== (L = /*rotatedCorners*/
      e[6][0][1])) && c(m, "y1", L), (!W || N & /*rotatedCorners*/
      64 && M !== (M = /*rotatedCorners*/
      e[6][1][0])) && c(m, "x2", M), (!W || N & /*rotatedCorners*/
      64 && O !== (O = /*rotatedCorners*/
      e[6][1][1])) && c(m, "y2", O), (!W || N & /*rotatedCorners*/
      64 && Z !== (Z = /*rotatedCorners*/
      e[6][1][0])) && c(V, "x1", Z), (!W || N & /*rotatedCorners*/
      64 && q !== (q = /*rotatedCorners*/
      e[6][1][1])) && c(V, "y1", q), (!W || N & /*rotatedCorners*/
      64 && K !== (K = /*rotatedCorners*/
      e[6][2][0])) && c(V, "x2", K), (!W || N & /*rotatedCorners*/
      64 && ee !== (ee = /*rotatedCorners*/
      e[6][2][1])) && c(V, "y2", ee), (!W || N & /*rotatedCorners*/
      64 && Ae !== (Ae = /*rotatedCorners*/
      e[6][2][0])) && c(ne, "x1", Ae), (!W || N & /*rotatedCorners*/
      64 && X !== (X = /*rotatedCorners*/
      e[6][2][1])) && c(ne, "y1", X), (!W || N & /*rotatedCorners*/
      64 && ue !== (ue = /*rotatedCorners*/
      e[6][3][0])) && c(ne, "x2", ue), (!W || N & /*rotatedCorners*/
      64 && te !== (te = /*rotatedCorners*/
      e[6][3][1])) && c(ne, "y2", te), (!W || N & /*rotatedCorners*/
      64 && Ue !== (Ue = /*rotatedCorners*/
      e[6][3][0])) && c(ie, "x1", Ue), (!W || N & /*rotatedCorners*/
      64 && it !== (it = /*rotatedCorners*/
      e[6][3][1])) && c(ie, "y1", it), (!W || N & /*rotatedCorners*/
      64 && rt !== (rt = /*rotatedCorners*/
      e[6][0][0])) && c(ie, "x2", rt), (!W || N & /*rotatedCorners*/
      64 && lt !== (lt = /*rotatedCorners*/
      e[6][0][1])) && c(ie, "y2", lt);
      const ct = {};
      N & /*rotatedCorners*/
      64 && (ct.x = /*rotatedCorners*/
      e[6][0][0]), N & /*rotatedCorners*/
      64 && (ct.y = /*rotatedCorners*/
      e[6][0][1]), N & /*viewportScale*/
      8 && (ct.scale = /*viewportScale*/
      e[3]), Ie.$set(ct);
      const ut = {};
      N & /*rotatedCorners*/
      64 && (ut.x = /*rotatedCorners*/
      e[6][1][0]), N & /*rotatedCorners*/
      64 && (ut.y = /*rotatedCorners*/
      e[6][1][1]), N & /*viewportScale*/
      8 && (ut.scale = /*viewportScale*/
      e[3]), Ce.$set(ut);
      const ft = {};
      N & /*rotatedCorners*/
      64 && (ft.x = /*rotatedCorners*/
      e[6][2][0]), N & /*rotatedCorners*/
      64 && (ft.y = /*rotatedCorners*/
      e[6][2][1]), N & /*viewportScale*/
      8 && (ft.scale = /*viewportScale*/
      e[3]), Oe.$set(ft);
      const dt = {};
      N & /*rotatedCorners*/
      64 && (dt.x = /*rotatedCorners*/
      e[6][3][0]), N & /*rotatedCorners*/
      64 && (dt.y = /*rotatedCorners*/
      e[6][3][1]), N & /*viewportScale*/
      8 && (dt.scale = /*viewportScale*/
      e[3]), De.$set(dt);
    },
    i(z) {
      W || (U(C.$$.fragment, z), U(Ie.$$.fragment, z), U(Ce.$$.fragment, z), U(Oe.$$.fragment, z), U(De.$$.fragment, z), W = !0);
    },
    o(z) {
      H(C.$$.fragment, z), H(Ie.$$.fragment, z), H(Ce.$$.fragment, z), H(Oe.$$.fragment, z), H(De.$$.fragment, z), W = !1;
    },
    d(z) {
      z && (B(t), B(d), B(f), B(T), B(Y), B(E), B(m), B(F), B(V), B(ge), B(ne), B(he), B(ie), B(Mt), B(Tt), B(Pt), B(Lt)), le(C), le(Ie, z), le(Ce, z), le(Oe, z), le(De, z), It = !1, Se(sn);
    }
  };
}
function Ii(e) {
  let t, n;
  return t = new nn({
    props: {
      shape: (
        /*shape*/
        e[0]
      ),
      transform: (
        /*transform*/
        e[2]
      ),
      editor: (
        /*editor*/
        e[8]
      ),
      svgEl: (
        /*svgEl*/
        e[4]
      ),
      $$slots: {
        default: [
          Li,
          ({ grab: o }) => ({ 16: o }),
          ({ grab: o }) => o ? 65536 : 0
        ]
      },
      $$scope: { ctx: e }
    }
  }), t.$on(
    "grab",
    /*grab_handler*/
    e[12]
  ), t.$on(
    "change",
    /*change_handler*/
    e[13]
  ), t.$on(
    "release",
    /*release_handler*/
    e[14]
  ), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, [s]) {
      const i = {};
      s & /*shape*/
      1 && (i.shape = /*shape*/
      o[0]), s & /*transform*/
      4 && (i.transform = /*transform*/
      o[2]), s & /*svgEl*/
      16 && (i.svgEl = /*svgEl*/
      o[4]), s & /*$$scope, rotatedCorners, viewportScale, grab, computedStyle, rotationHandlePos, mask*/
      196842 && (i.$$scope = { dirty: s, ctx: o }), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
const kn = (e) => `${e[0]},${e[1]}`, Mn = (e) => `${e[0]},${e[1]}`, Tn = (e) => `${e[0]},${e[1]}`;
function Ci(e, t, n) {
  let o, s, i, l, r, { shape: a } = t, { computedStyle: u } = t, { transform: d } = t, { viewportScale: f = 1 } = t, { svgEl: g } = t, h = !1;
  const p = (_, k, P) => {
    let { x: C, y: T, w: Y, h: D, rot: x = 0 } = _.geometry;
    const [j, v] = P;
    if (k === "ROTATION") {
      const m = Sn(_.geometry, o), b = m[0] + j, L = m[1] + v, M = [C + Y / 2, T + D / 2];
      x += Ti([m[0], m[1]], [b, L], M), h && (x = Pi(x));
    } else if (k === "SHAPE")
      C += j, T += v;
    else {
      let m = 0, b = 0, L = Y, M = D;
      const [O, F] = x !== 0 ? Mi(j, v, x) : [j, v];
      switch (k) {
        case "TOP":
        case "TOP_LEFT":
        case "TOP_RIGHT":
          b += F;
          break;
        case "BOTTOM":
        case "BOTTOM_LEFT":
        case "BOTTOM_RIGHT":
          M += F;
          break;
      }
      switch (k) {
        case "LEFT":
        case "TOP_LEFT":
        case "BOTTOM_LEFT":
          m += O;
          break;
        case "RIGHT":
        case "TOP_RIGHT":
        case "BOTTOM_RIGHT":
          L += O;
          break;
      }
      const V = (m + L) / 2, Z = (b + M) / 2;
      Y = Math.abs(L - m), D = Math.abs(M - b);
      const q = [C + _.geometry.w / 2, T + _.geometry.h / 2], K = [
        V - _.geometry.w / 2,
        Z - _.geometry.h / 2
      ], ee = Math.cos(x), ge = Math.sin(x), ne = q[0] + K[0] * ee - K[1] * ge, Ae = q[1] + K[0] * ge + K[1] * ee;
      C = ne - Y / 2, T = Ae - D / 2;
    }
    const E = fe(i);
    return {
      ..._,
      geometry: { x: C, y: T, w: Y, h: D, rot: x, bounds: E }
    };
  };
  Re(() => {
    const _ = (P) => {
      P.key === "Shift" && (h = !0);
    }, k = (P) => {
      P.key === "Shift" && (h = !1);
    };
    return window.addEventListener("keydown", _), window.addEventListener("keyup", k), () => {
      window.removeEventListener("keydown", _), window.removeEventListener("keyup", k);
    };
  });
  const y = `rect-mask-${Math.random().toString(36).substring(2, 12)}`;
  function S(_) {
    de.call(this, e, _);
  }
  function w(_) {
    de.call(this, e, _);
  }
  function A(_) {
    de.call(this, e, _);
  }
  return e.$$set = (_) => {
    "shape" in _ && n(0, a = _.shape), "computedStyle" in _ && n(1, u = _.computedStyle), "transform" in _ && n(2, d = _.transform), "viewportScale" in _ && n(3, f = _.viewportScale), "svgEl" in _ && n(4, g = _.svgEl);
  }, e.$$.update = () => {
    e.$$.dirty & /*viewportScale*/
    8 && n(11, o = 20 / f), e.$$.dirty & /*shape*/
    1 && n(10, s = a.geometry), e.$$.dirty & /*geom*/
    1024 && n(6, i = ki(s.x, s.y, s.w, s.h, s.rot)), e.$$.dirty & /*geom, ROTATION_HANDLE_OFFSET*/
    3072 && n(7, l = Sn(s, o)), e.$$.dirty & /*geom, viewportScale*/
    1032 && n(5, r = kt(s.bounds, 5 / f));
  }, [
    a,
    u,
    d,
    f,
    g,
    r,
    i,
    l,
    p,
    y,
    s,
    o,
    S,
    w,
    A
  ];
}
class Oi extends ye {
  constructor(t) {
    super(), _e(this, t, Ci, Ii, ae, {
      shape: 0,
      computedStyle: 1,
      transform: 2,
      viewportScale: 3,
      svgEl: 4
    });
  }
}
var Pn = Object.prototype.hasOwnProperty;
function $t(e, t) {
  var n, o;
  if (e === t) return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date) return e.getTime() === t.getTime();
    if (n === RegExp) return e.toString() === t.toString();
    if (n === Array) {
      if ((o = e.length) === t.length)
        for (; o-- && $t(e[o], t[o]); ) ;
      return o === -1;
    }
    if (!n || typeof e == "object") {
      o = 0;
      for (n in e)
        if (Pn.call(e, n) && ++o && !Pn.call(t, n) || !(n in t) || !$t(e[n], t[n])) return !1;
      return Object.keys(t).length === o;
    }
  }
  return e !== e && t !== t;
}
const Di = 12, Ni = (e, t) => e.polygons.reduce((n, o, s) => {
  const i = o.rings.reduce((l, r, a) => {
    const u = r.points.map((d, f) => {
      const g = f === r.points.length - 1 ? r.points[0] : r.points[f + 1], h = (d[0] + g[0]) / 2, p = (d[1] + g[1]) / 2, S = Math.sqrt(
        Math.pow(g[0] - h, 2) + Math.pow(g[1] - p, 2)
      ) > Di / t;
      return { point: [h, p], visible: S, elementIdx: s, ringIdx: a, pointIdx: f };
    });
    return [...l, ...u];
  }, []);
  return [...n, ...i];
}, []);
function Ht(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[29] = n.point, t;
}
function Ln(e, t, n) {
  const o = e.slice();
  return o[30] = t[n], o[32] = n, o;
}
function In(e, t, n) {
  const o = e.slice();
  return o[33] = t[n], o[35] = n, o;
}
function Cn(e, t, n) {
  const o = e.slice();
  return o[29] = t[n], o[37] = n, o;
}
function Gt(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[29] = n.point, t;
}
function jt(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[29] = n.point, t;
}
function On(e) {
  let t, n, o, s;
  return {
    c() {
      t = I("circle"), c(t, "cx", n = /*point*/
      e[29][0]), c(t, "cy", o = /*point*/
      e[29][1]), c(t, "r", s = ot / /*viewportScale*/
      e[3]), c(t, "class", "svelte-1vxo6dc");
    },
    m(i, l) {
      R(i, t, l);
    },
    p(i, l) {
      l[0] & /*midpoints, visibleMidpoint*/
      1088 && n !== (n = /*point*/
      i[29][0]) && c(t, "cx", n), l[0] & /*midpoints, visibleMidpoint*/
      1088 && o !== (o = /*point*/
      i[29][1]) && c(t, "cy", o), l[0] & /*viewportScale*/
      8 && s !== (s = ot / /*viewportScale*/
      i[3]) && c(t, "r", s);
    },
    d(i) {
      i && B(t);
    }
  };
}
function Dn(e) {
  let t, n, o, s, i, l, r, a, u, d;
  return {
    c() {
      t = I("mask"), n = I("rect"), r = I("circle"), c(n, "x", o = /*mask*/
      e[9].x), c(n, "y", s = /*mask*/
      e[9].y), c(n, "width", i = /*mask*/
      e[9].w), c(n, "height", l = /*mask*/
      e[9].h), c(n, "class", "svelte-1vxo6dc"), c(r, "cx", a = /*point*/
      e[29][0]), c(r, "cy", u = /*point*/
      e[29][1]), c(r, "r", d = ot / /*viewportScale*/
      e[3]), c(r, "class", "svelte-1vxo6dc"), c(t, "id", `${/*maskId*/
      e[18]}-${/*elementIdx*/
      e[32]}-inner`), c(t, "class", "a9s-multipolygon-editor-mask svelte-1vxo6dc");
    },
    m(f, g) {
      R(f, t, g), G(t, n), G(t, r);
    },
    p(f, g) {
      g[0] & /*mask*/
      512 && o !== (o = /*mask*/
      f[9].x) && c(n, "x", o), g[0] & /*mask*/
      512 && s !== (s = /*mask*/
      f[9].y) && c(n, "y", s), g[0] & /*mask*/
      512 && i !== (i = /*mask*/
      f[9].w) && c(n, "width", i), g[0] & /*mask*/
      512 && l !== (l = /*mask*/
      f[9].h) && c(n, "height", l), g[0] & /*midpoints, visibleMidpoint*/
      1088 && a !== (a = /*point*/
      f[29][0]) && c(r, "cx", a), g[0] & /*midpoints, visibleMidpoint*/
      1088 && u !== (u = /*point*/
      f[29][1]) && c(r, "cy", u), g[0] & /*viewportScale*/
      8 && d !== (d = ot / /*viewportScale*/
      f[3]) && c(r, "r", d);
    },
    d(f) {
      f && B(t);
    }
  };
}
function Nn(e) {
  let t, n;
  function o(...s) {
    return (
      /*func*/
      e[19](
        /*elementIdx*/
        e[32],
        /*ringIdx*/
        e[35],
        /*pointIdx*/
        e[37],
        ...s
      )
    );
  }
  return t = new Ve({
    props: {
      class: "a9s-corner-handle",
      x: (
        /*point*/
        e[29][0]
      ),
      y: (
        /*point*/
        e[29][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      ),
      selected: (
        /*selectedCorners*/
        e[8].some(o)
      )
    }
  }), t.$on(
    "pointerenter",
    /*onEnterHandle*/
    e[11]
  ), t.$on(
    "pointerleave",
    /*onLeaveHandle*/
    e[12]
  ), t.$on(
    "pointerdown",
    /*onHandlePointerDown*/
    e[14]
  ), t.$on("pointerdown", function() {
    se(
      /*grab*/
      e[28](`HANDLE-${/*elementIdx*/
      e[32]}-${/*ringIdx*/
      e[35]}-${/*pointIdx*/
      e[37]}`)
    ) && e[28](`HANDLE-${/*elementIdx*/
    e[32]}-${/*ringIdx*/
    e[35]}-${/*pointIdx*/
    e[37]}`).apply(this, arguments);
  }), t.$on(
    "pointerup",
    /*onHandlePointerUp*/
    e[15](
      /*elementIdx*/
      e[32],
      /*ringIdx*/
      e[35],
      /*pointIdx*/
      e[37]
    )
  ), {
    c() {
      ce(t.$$.fragment);
    },
    m(s, i) {
      re(t, s, i), n = !0;
    },
    p(s, i) {
      e = s;
      const l = {};
      i[0] & /*geom*/
      32 && (l.x = /*point*/
      e[29][0]), i[0] & /*geom*/
      32 && (l.y = /*point*/
      e[29][1]), i[0] & /*viewportScale*/
      8 && (l.scale = /*viewportScale*/
      e[3]), i[0] & /*selectedCorners*/
      256 && (l.selected = /*selectedCorners*/
      e[8].some(o)), t.$set(l);
    },
    i(s) {
      n || (U(t.$$.fragment, s), n = !0);
    },
    o(s) {
      H(t.$$.fragment, s), n = !1;
    },
    d(s) {
      le(t, s);
    }
  };
}
function Bn(e) {
  let t, n, o = ve(
    /*ring*/
    e[33].points
  ), s = [];
  for (let l = 0; l < o.length; l += 1)
    s[l] = Nn(Cn(e, o, l));
  const i = (l) => H(s[l], 1, 1, () => {
    s[l] = null;
  });
  return {
    c() {
      for (let l = 0; l < s.length; l += 1)
        s[l].c();
      t = ke();
    },
    m(l, r) {
      for (let a = 0; a < s.length; a += 1)
        s[a] && s[a].m(l, r);
      R(l, t, r), n = !0;
    },
    p(l, r) {
      if (r[0] & /*geom, viewportScale, selectedCorners, onEnterHandle, onLeaveHandle, onHandlePointerDown, grab, onHandlePointerUp*/
      268491048) {
        o = ve(
          /*ring*/
          l[33].points
        );
        let a;
        for (a = 0; a < o.length; a += 1) {
          const u = Cn(l, o, a);
          s[a] ? (s[a].p(u, r), U(s[a], 1)) : (s[a] = Nn(u), s[a].c(), U(s[a], 1), s[a].m(t.parentNode, t));
        }
        for (be(), a = o.length; a < s.length; a += 1)
          i(a);
        Ee();
      }
    },
    i(l) {
      if (!n) {
        for (let r = 0; r < o.length; r += 1)
          U(s[r]);
        n = !0;
      }
    },
    o(l) {
      s = s.filter(Boolean);
      for (let r = 0; r < s.length; r += 1)
        H(s[r]);
      n = !1;
    },
    d(l) {
      l && B(t), He(s, l);
    }
  };
}
function Rn(e) {
  let t, n, o, s, i, l, r, a, u, d, f, g, h, p, y, S, w, A = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && On(jt(e))
  ), _ = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && Dn(Gt(e))
  ), k = ve(
    /*element*/
    e[30].rings
  ), P = [];
  for (let T = 0; T < k.length; T += 1)
    P[T] = Bn(In(e, k, T));
  const C = (T) => H(P[T], 1, 1, () => {
    P[T] = null;
  });
  return {
    c() {
      t = I("g"), n = I("defs"), o = I("mask"), s = I("rect"), u = I("path"), A && A.c(), _ && _.c(), f = I("path"), h = I("path");
      for (let T = 0; T < P.length; T += 1)
        P[T].c();
      c(s, "x", i = /*mask*/
      e[9].x), c(s, "y", l = /*mask*/
      e[9].y), c(s, "width", r = /*mask*/
      e[9].w), c(s, "height", a = /*mask*/
      e[9].h), c(s, "class", "svelte-1vxo6dc"), c(u, "d", d = Pe(
        /*element*/
        e[30]
      )), c(u, "class", "svelte-1vxo6dc"), c(o, "id", `${/*maskId*/
      e[18]}-${/*elementIdx*/
      e[32]}-outer`), c(o, "class", "a9s-multipolygon-editor-mask svelte-1vxo6dc"), c(f, "class", "a9s-outer"), c(f, "mask", `url(#${/*maskId*/
      e[18]}-${/*elementIdx*/
      e[32]}-outer)`), c(f, "fill-rule", "evenodd"), c(f, "d", g = Pe(
        /*element*/
        e[30]
      )), c(h, "class", "a9s-inner"), c(h, "mask", `url(#${/*maskId*/
      e[18]}-${/*elementIdx*/
      e[32]}-inner)`), c(
        h,
        "style",
        /*computedStyle*/
        e[1]
      ), c(h, "fill-rule", "evenodd"), c(h, "d", p = Pe(
        /*element*/
        e[30]
      ));
    },
    m(T, Y) {
      R(T, t, Y), G(t, n), G(n, o), G(o, s), G(o, u), A && A.m(o, null), _ && _.m(n, null), G(t, f), G(t, h);
      for (let D = 0; D < P.length; D += 1)
        P[D] && P[D].m(t, null);
      y = !0, S || (w = [
        J(
          f,
          "pointerup",
          /*onShapePointerUp*/
          e[13]
        ),
        J(f, "pointerdown", function() {
          se(
            /*grab*/
            e[28]("SHAPE")
          ) && e[28]("SHAPE").apply(this, arguments);
        }),
        J(
          h,
          "pointerup",
          /*onShapePointerUp*/
          e[13]
        ),
        J(h, "pointerdown", function() {
          se(
            /*grab*/
            e[28]("SHAPE")
          ) && e[28]("SHAPE").apply(this, arguments);
        })
      ], S = !0);
    },
    p(T, Y) {
      if (e = T, (!y || Y[0] & /*mask*/
      512 && i !== (i = /*mask*/
      e[9].x)) && c(s, "x", i), (!y || Y[0] & /*mask*/
      512 && l !== (l = /*mask*/
      e[9].y)) && c(s, "y", l), (!y || Y[0] & /*mask*/
      512 && r !== (r = /*mask*/
      e[9].w)) && c(s, "width", r), (!y || Y[0] & /*mask*/
      512 && a !== (a = /*mask*/
      e[9].h)) && c(s, "height", a), (!y || Y[0] & /*geom*/
      32 && d !== (d = Pe(
        /*element*/
        e[30]
      ))) && c(u, "d", d), /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? A ? A.p(jt(e), Y) : (A = On(jt(e)), A.c(), A.m(o, null)) : A && (A.d(1), A = null), /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? _ ? _.p(Gt(e), Y) : (_ = Dn(Gt(e)), _.c(), _.m(n, null)) : _ && (_.d(1), _ = null), (!y || Y[0] & /*geom*/
      32 && g !== (g = Pe(
        /*element*/
        e[30]
      ))) && c(f, "d", g), (!y || Y[0] & /*computedStyle*/
      2) && c(
        h,
        "style",
        /*computedStyle*/
        e[1]
      ), (!y || Y[0] & /*geom*/
      32 && p !== (p = Pe(
        /*element*/
        e[30]
      ))) && c(h, "d", p), Y[0] & /*geom, viewportScale, selectedCorners, onEnterHandle, onLeaveHandle, onHandlePointerDown, grab, onHandlePointerUp*/
      268491048) {
        k = ve(
          /*element*/
          e[30].rings
        );
        let D;
        for (D = 0; D < k.length; D += 1) {
          const x = In(e, k, D);
          P[D] ? (P[D].p(x, Y), U(P[D], 1)) : (P[D] = Bn(x), P[D].c(), U(P[D], 1), P[D].m(t, null));
        }
        for (be(), D = k.length; D < P.length; D += 1)
          C(D);
        Ee();
      }
    },
    i(T) {
      if (!y) {
        for (let Y = 0; Y < k.length; Y += 1)
          U(P[Y]);
        y = !0;
      }
    },
    o(T) {
      P = P.filter(Boolean);
      for (let Y = 0; Y < P.length; Y += 1)
        H(P[Y]);
      y = !1;
    },
    d(T) {
      T && B(t), A && A.d(), _ && _.d(), He(P, T), S = !1, Se(w);
    }
  };
}
function Yn(e) {
  let t, n;
  return t = new vo({
    props: {
      x: (
        /*point*/
        e[29][0]
      ),
      y: (
        /*point*/
        e[29][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), t.$on("pointerdown", function() {
    se(
      /*onAddPoint*/
      e[17](
        /*visibleMidpoint*/
        e[6]
      )
    ) && e[17](
      /*visibleMidpoint*/
      e[6]
    ).apply(this, arguments);
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      e = o;
      const i = {};
      s[0] & /*midpoints, visibleMidpoint*/
      1088 && (i.x = /*point*/
      e[29][0]), s[0] & /*midpoints, visibleMidpoint*/
      1088 && (i.y = /*point*/
      e[29][1]), s[0] & /*viewportScale*/
      8 && (i.scale = /*viewportScale*/
      e[3]), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Bi(e) {
  let t, n, o, s = ve(
    /*geom*/
    e[5].polygons
  ), i = [];
  for (let a = 0; a < s.length; a += 1)
    i[a] = Rn(Ln(e, s, a));
  const l = (a) => H(i[a], 1, 1, () => {
    i[a] = null;
  });
  let r = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && Yn(Ht(e))
  );
  return {
    c() {
      for (let a = 0; a < i.length; a += 1)
        i[a].c();
      t = we(), r && r.c(), n = ke();
    },
    m(a, u) {
      for (let d = 0; d < i.length; d += 1)
        i[d] && i[d].m(a, u);
      R(a, t, u), r && r.m(a, u), R(a, n, u), o = !0;
    },
    p(a, u) {
      if (u[0] & /*geom, viewportScale, selectedCorners, onEnterHandle, onLeaveHandle, onHandlePointerDown, grab, onHandlePointerUp, maskId, computedStyle, onShapePointerUp, midpoints, visibleMidpoint, mask, isHandleHovered*/
      268763114) {
        s = ve(
          /*geom*/
          a[5].polygons
        );
        let d;
        for (d = 0; d < s.length; d += 1) {
          const f = Ln(a, s, d);
          i[d] ? (i[d].p(f, u), U(i[d], 1)) : (i[d] = Rn(f), i[d].c(), U(i[d], 1), i[d].m(t.parentNode, t));
        }
        for (be(), d = s.length; d < i.length; d += 1)
          l(d);
        Ee();
      }
      /*visibleMidpoint*/
      a[6] !== void 0 && !/*isHandleHovered*/
      a[7] ? r ? (r.p(Ht(a), u), u[0] & /*visibleMidpoint, isHandleHovered*/
      192 && U(r, 1)) : (r = Yn(Ht(a)), r.c(), U(r, 1), r.m(n.parentNode, n)) : r && (be(), H(r, 1, 1, () => {
        r = null;
      }), Ee());
    },
    i(a) {
      if (!o) {
        for (let u = 0; u < s.length; u += 1)
          U(i[u]);
        U(r), o = !0;
      }
    },
    o(a) {
      i = i.filter(Boolean);
      for (let u = 0; u < i.length; u += 1)
        H(i[u]);
      H(r), o = !1;
    },
    d(a) {
      a && (B(t), B(n)), He(i, a), r && r.d(a);
    }
  };
}
function Ri(e) {
  let t, n;
  return t = new nn({
    props: {
      shape: (
        /*shape*/
        e[0]
      ),
      transform: (
        /*transform*/
        e[2]
      ),
      editor: (
        /*editor*/
        e[16]
      ),
      svgEl: (
        /*svgEl*/
        e[4]
      ),
      $$slots: {
        default: [
          Bi,
          ({ grab: o }) => ({ 28: o }),
          ({ grab: o }) => [o ? 268435456 : 0]
        ]
      },
      $$scope: { ctx: e }
    }
  }), t.$on(
    "change",
    /*change_handler*/
    e[20]
  ), t.$on(
    "grab",
    /*grab_handler*/
    e[21]
  ), t.$on(
    "release",
    /*release_handler*/
    e[22]
  ), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*shape*/
      1 && (i.shape = /*shape*/
      o[0]), s[0] & /*transform*/
      4 && (i.transform = /*transform*/
      o[2]), s[0] & /*svgEl*/
      16 && (i.svgEl = /*svgEl*/
      o[4]), s[0] & /*midpoints, visibleMidpoint, viewportScale, isHandleHovered, geom, selectedCorners, grab, computedStyle, mask*/
      268437482 | s[1] & /*$$scope*/
      128 && (i.$$scope = { dirty: s, ctx: o }), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
const Yi = 250, Ui = 1e3, ot = 4.5;
function Vi(e, t, n) {
  let o, s, i;
  const l = Ye();
  let { shape: r } = t, { computedStyle: a } = t, { transform: u } = t, { viewportScale: d = 1 } = t, { svgEl: f } = t, g, h = !1, p, y = [];
  const S = () => n(7, h = !0), w = () => n(7, h = !1), A = (b) => {
    if (y.length > 0 || !s.some((K) => K.visible)) {
      n(6, g = void 0);
      return;
    }
    const [L, M] = u.elementToImage(b.offsetX, b.offsetY), O = (K) => Math.pow(K[0] - L, 2) + Math.pow(K[1] - M, 2), F = Jo(o).reduce((K, ee) => O(ee) < O(K) ? ee : K), V = s.filter((K) => K.visible).reduce((K, ee) => O(ee.point) < O(K.point) ? ee : K), Z = Math.pow(Ui / d, 2);
    O(F) < Z || O(V.point) < Z ? n(6, g = s.indexOf(V)) : n(6, g = void 0);
  }, _ = () => {
    document.activeElement !== f && f.focus();
  }, k = () => {
    n(8, y = []), _();
  }, P = (b) => {
    n(7, h = !0), b.preventDefault(), b.stopPropagation(), p = performance.now();
  }, C = (b, L, M) => (O) => {
    if (!p || Le || performance.now() - p > Yi) return;
    const F = (Z) => Z.polygon === b && Z.ring === L && Z.point === M, V = y.some(F);
    O.metaKey || O.ctrlKey || O.shiftKey ? V ? n(8, y = y.filter((Z) => !F(Z))) : n(8, y = [...y, { polygon: b, ring: L, point: M }]) : V && y.length > 1 ? n(8, y = [{ polygon: b, ring: L, point: M }]) : V ? n(8, y = []) : n(8, y = [{ polygon: b, ring: L, point: M }]), _();
  }, T = (b, L, M) => {
    _();
    const O = b.geometry.polygons;
    let F;
    if (L === "SHAPE")
      F = O.map((V) => {
        const Z = V.rings.map((K, ee) => ({ points: K.points.map((ne, Ae) => [ne[0] + M[0], ne[1] + M[1]]) })), q = fe(Z[0].points);
        return { rings: Z, bounds: q };
      });
    else {
      const [V, Z, q, K] = L.split("-").map((ee) => parseInt(ee));
      F = O.map((ee, ge) => {
        if (ge === Z) {
          const ne = ee.rings.map((X, ue) => ue === q ? { points: X.points.map((he, ie) => ie === K ? [he[0] + M[0], he[1] + M[1]] : he) } : X), Ae = fe(ne[0].points);
          return { rings: ne, bounds: Ae };
        } else
          return ee;
      });
    }
    return {
      ...b,
      geometry: {
        polygons: F,
        bounds: wt(F)
      }
    };
  }, Y = (b) => async (L) => {
    L.stopPropagation();
    const M = s[b], O = o.polygons.map((V, Z) => {
      if (Z === M.elementIdx) {
        const q = V.rings.map((ee, ge) => ge === M.ringIdx ? { points: [
          ...ee.points.slice(0, M.pointIdx + 1),
          M.point,
          ...ee.points.slice(M.pointIdx + 1)
        ] } : ee), K = fe(q[0].points);
        return { rings: q, bounds: K };
      } else
        return V;
    });
    l("change", {
      ...r,
      geometry: {
        polygons: O,
        bounds: wt(O)
      }
    }), await ao();
    const F = [...document.querySelectorAll(".a9s-handle")][b + 1];
    if (F != null && F.firstChild) {
      const V = new PointerEvent(
        "pointerdown",
        {
          bubbles: !0,
          cancelable: !0,
          clientX: L.clientX,
          clientY: L.clientY,
          pointerId: L.pointerId,
          pointerType: L.pointerType,
          isPrimary: L.isPrimary,
          buttons: L.buttons
        }
      );
      F.firstChild.dispatchEvent(V);
    }
  }, D = () => {
    const b = o.polygons.map((M, O) => {
      if (y.some((V) => V.polygon === O)) {
        const V = M.rings.map((q, K) => {
          const ee = y.filter((ge) => ge.polygon === O && ge.ring === K);
          return ee.length && q.points.length - ee.length >= 3 ? { points: q.points.filter((ne, Ae) => !ee.some((X) => X.point === Ae)) } : q;
        }), Z = fe(V[0].points);
        return { rings: V, bounds: Z };
      } else
        return M;
    });
    !$t(o.polygons, b) && (l("change", {
      ...r,
      geometry: {
        polygons: b,
        bounds: wt(b)
      }
    }), n(8, y = []));
  };
  Re(() => {
    if (Le) return;
    const b = (L) => {
      (L.key === "Delete" || L.key === "Backspace") && (L.preventDefault(), D());
    };
    return f.addEventListener("pointermove", A), f.addEventListener("keydown", b), () => {
      f.removeEventListener("pointermove", A), f.removeEventListener("keydown", b);
    };
  });
  const x = `polygon-mask-${Math.random().toString(36).substring(2, 12)}`, j = (b, L, M, { polygon: O, ring: F, point: V }) => O === b && F === L && V === M;
  function v(b) {
    de.call(this, e, b);
  }
  function E(b) {
    de.call(this, e, b);
  }
  function m(b) {
    de.call(this, e, b);
  }
  return e.$$set = (b) => {
    "shape" in b && n(0, r = b.shape), "computedStyle" in b && n(1, a = b.computedStyle), "transform" in b && n(2, u = b.transform), "viewportScale" in b && n(3, d = b.viewportScale), "svgEl" in b && n(4, f = b.svgEl);
  }, e.$$.update = () => {
    e.$$.dirty[0] & /*shape*/
    1 && n(5, o = r.geometry), e.$$.dirty[0] & /*geom, viewportScale*/
    40 && n(10, s = Le ? [] : Ni(o, d)), e.$$.dirty[0] & /*geom, viewportScale*/
    40 && n(9, i = kt(o.bounds, ot / d));
  }, [
    r,
    a,
    u,
    d,
    f,
    o,
    g,
    h,
    y,
    i,
    s,
    S,
    w,
    k,
    P,
    C,
    T,
    Y,
    x,
    j,
    v,
    E,
    m
  ];
}
class Xi extends ye {
  constructor(t) {
    super(), _e(
      this,
      t,
      Vi,
      Ri,
      ae,
      {
        shape: 0,
        computedStyle: 1,
        transform: 2,
        viewportScale: 3,
        svgEl: 4
      },
      null,
      [-1, -1]
    );
  }
}
const So = /* @__PURE__ */ new Map([
  [Q.RECTANGLE, Oi],
  [Q.POLYGON, Si],
  [Q.MULTIPOLYGON, Xi]
]), Hi = (e) => So.get(e.type), Gi = (e, t) => So.set(e, t);
function ji(e, t, n) {
  let o;
  const s = Ye();
  let { annotation: i } = t, { editor: l } = t, { style: r } = t, { target: a } = t, { transform: u } = t, { viewportScale: d } = t, f;
  return Re(() => (n(6, f = new l({
    target: a,
    props: {
      shape: i.target.selector,
      computedStyle: o,
      transform: u,
      viewportScale: d,
      svgEl: a.closest("svg")
    }
  })), f.$on("change", (g) => {
    f.$$set({ shape: g.detail }), s("change", g.detail);
  }), f.$on("grab", (g) => s("grab", g.detail)), f.$on("release", (g) => s("release", g.detail)), () => {
    f.$destroy();
  })), e.$$set = (g) => {
    "annotation" in g && n(0, i = g.annotation), "editor" in g && n(1, l = g.editor), "style" in g && n(2, r = g.style), "target" in g && n(3, a = g.target), "transform" in g && n(4, u = g.transform), "viewportScale" in g && n(5, d = g.viewportScale);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    5 && n(7, o = Ge(i, r, { selected: !0, hovered: !0 })), e.$$.dirty & /*annotation, editorComponent*/
    65 && i && (f == null || f.$set({ shape: i.target.selector })), e.$$.dirty & /*editorComponent, transform*/
    80 && f && f.$set({ transform: u }), e.$$.dirty & /*editorComponent, viewportScale*/
    96 && f && f.$set({ viewportScale: d }), e.$$.dirty & /*editorComponent, computedStyle*/
    192 && f && o && f.$set({ computedStyle: o });
  }, [
    i,
    l,
    r,
    a,
    u,
    d,
    f,
    o
  ];
}
class Fi extends ye {
  constructor(t) {
    super(), _e(this, t, ji, null, ae, {
      annotation: 0,
      editor: 1,
      style: 2,
      target: 3,
      transform: 4,
      viewportScale: 5
    });
  }
}
function zi(e, t, n) {
  const o = Ye();
  let { drawingMode: s } = t, { target: i } = t, { tool: l } = t, { transform: r } = t, { viewportScale: a } = t, u;
  return Re(() => {
    const d = i.closest("svg"), f = [], g = (h, p, y) => {
      d == null || d.addEventListener(h, p, y), f.push(() => d == null ? void 0 : d.removeEventListener(h, p, y));
    };
    return n(5, u = new l({
      target: i,
      props: {
        addEventListener: g,
        drawingMode: s,
        transform: r,
        viewportScale: a
      }
    })), u.$on("create", (h) => o("create", h.detail)), () => {
      f.forEach((h) => h()), u.$destroy();
    };
  }), e.$$set = (d) => {
    "drawingMode" in d && n(0, s = d.drawingMode), "target" in d && n(1, i = d.target), "tool" in d && n(2, l = d.tool), "transform" in d && n(3, r = d.transform), "viewportScale" in d && n(4, a = d.viewportScale);
  }, e.$$.update = () => {
    e.$$.dirty & /*toolComponent, transform*/
    40 && u && u.$set({ transform: r }), e.$$.dirty & /*toolComponent, viewportScale*/
    48 && u && u.$set({ viewportScale: a });
  }, [s, i, l, r, a, u];
}
class qi extends ye {
  constructor(t) {
    super(), _e(this, t, zi, null, ae, {
      drawingMode: 0,
      target: 1,
      tool: 2,
      transform: 3,
      viewportScale: 4
    });
  }
}
function Un(e) {
  let t, n, o, s, i, l, r, a, u, d;
  return {
    c() {
      t = I("defs"), n = I("mask"), o = I("rect"), a = I("rect"), u = I("rect"), d = I("rect"), c(o, "class", "rect-mask-bg svelte-1a76qe7"), c(o, "x", s = /*x*/
      e[1] - /*buffer*/
      e[5]), c(o, "y", i = /*y*/
      e[2] - /*buffer*/
      e[5]), c(o, "width", l = /*w*/
      e[3] + 2 * /*buffer*/
      e[5]), c(o, "height", r = /*h*/
      e[4] + 2 * /*buffer*/
      e[5]), c(a, "class", "rect-mask-fg svelte-1a76qe7"), c(
        a,
        "x",
        /*x*/
        e[1]
      ), c(
        a,
        "y",
        /*y*/
        e[2]
      ), c(
        a,
        "width",
        /*w*/
        e[3]
      ), c(
        a,
        "height",
        /*h*/
        e[4]
      ), c(
        n,
        "id",
        /*maskId*/
        e[6]
      ), c(n, "class", "a9s-rubberband-rectangle-mask svelte-1a76qe7"), c(u, "class", "a9s-outer"), c(u, "mask", `url(#${/*maskId*/
      e[6]})`), c(
        u,
        "x",
        /*x*/
        e[1]
      ), c(
        u,
        "y",
        /*y*/
        e[2]
      ), c(
        u,
        "width",
        /*w*/
        e[3]
      ), c(
        u,
        "height",
        /*h*/
        e[4]
      ), c(d, "class", "a9s-inner"), c(
        d,
        "x",
        /*x*/
        e[1]
      ), c(
        d,
        "y",
        /*y*/
        e[2]
      ), c(
        d,
        "width",
        /*w*/
        e[3]
      ), c(
        d,
        "height",
        /*h*/
        e[4]
      );
    },
    m(f, g) {
      R(f, t, g), G(t, n), G(n, o), G(n, a), R(f, u, g), R(f, d, g);
    },
    p(f, g) {
      g & /*x, buffer*/
      34 && s !== (s = /*x*/
      f[1] - /*buffer*/
      f[5]) && c(o, "x", s), g & /*y, buffer*/
      36 && i !== (i = /*y*/
      f[2] - /*buffer*/
      f[5]) && c(o, "y", i), g & /*w, buffer*/
      40 && l !== (l = /*w*/
      f[3] + 2 * /*buffer*/
      f[5]) && c(o, "width", l), g & /*h, buffer*/
      48 && r !== (r = /*h*/
      f[4] + 2 * /*buffer*/
      f[5]) && c(o, "height", r), g & /*x*/
      2 && c(
        a,
        "x",
        /*x*/
        f[1]
      ), g & /*y*/
      4 && c(
        a,
        "y",
        /*y*/
        f[2]
      ), g & /*w*/
      8 && c(
        a,
        "width",
        /*w*/
        f[3]
      ), g & /*h*/
      16 && c(
        a,
        "height",
        /*h*/
        f[4]
      ), g & /*x*/
      2 && c(
        u,
        "x",
        /*x*/
        f[1]
      ), g & /*y*/
      4 && c(
        u,
        "y",
        /*y*/
        f[2]
      ), g & /*w*/
      8 && c(
        u,
        "width",
        /*w*/
        f[3]
      ), g & /*h*/
      16 && c(
        u,
        "height",
        /*h*/
        f[4]
      ), g & /*x*/
      2 && c(
        d,
        "x",
        /*x*/
        f[1]
      ), g & /*y*/
      4 && c(
        d,
        "y",
        /*y*/
        f[2]
      ), g & /*w*/
      8 && c(
        d,
        "width",
        /*w*/
        f[3]
      ), g & /*h*/
      16 && c(
        d,
        "height",
        /*h*/
        f[4]
      );
    },
    d(f) {
      f && (B(t), B(u), B(d));
    }
  };
}
function Ki(e) {
  let t, n = (
    /*origin*/
    e[0] && Un(e)
  );
  return {
    c() {
      t = I("g"), n && n.c(), c(t, "class", "a9s-annotation a9s-rubberband");
    },
    m(o, s) {
      R(o, t, s), n && n.m(t, null);
    },
    p(o, [s]) {
      /*origin*/
      o[0] ? n ? n.p(o, s) : (n = Un(o), n.c(), n.m(t, null)) : n && (n.d(1), n = null);
    },
    i: $,
    o: $,
    d(o) {
      o && B(t), n && n.d();
    }
  };
}
function Wi(e, t, n) {
  let o;
  const s = Ye();
  let { addEventListener: i } = t, { drawingMode: l } = t, { transform: r } = t, { viewportScale: a = 1 } = t, u, d, f, g, h, p, y;
  const S = (P) => {
    const C = P;
    u = performance.now(), l === "drag" && (n(0, d = r.elementToImage(C.offsetX, C.offsetY)), f = d, n(1, g = d[0]), n(2, h = d[1]), n(3, p = 1), n(4, y = 1));
  }, w = (P) => {
    const C = P;
    d && (f = r.elementToImage(C.offsetX, C.offsetY), n(1, g = Math.min(f[0], d[0])), n(2, h = Math.min(f[1], d[1])), n(3, p = Math.abs(f[0] - d[0])), n(4, y = Math.abs(f[1] - d[1])));
  }, A = (P) => {
    const C = P, T = performance.now() - u;
    if (l === "click") {
      if (T > 300) return;
      d ? _() : (n(0, d = r.elementToImage(C.offsetX, C.offsetY)), f = d, n(1, g = d[0]), n(2, h = d[1]), n(3, p = 1), n(4, y = 1));
    } else d && (T > 300 || p * y > 100 ? (C.stopPropagation(), _()) : (n(0, d = void 0), f = void 0));
  }, _ = () => {
    if (p * y > 15) {
      const P = {
        type: Q.RECTANGLE,
        geometry: {
          bounds: {
            minX: g,
            minY: h,
            maxX: g + p,
            maxY: h + y
          },
          rot: 0,
          x: g,
          y: h,
          w: p,
          h: y
        }
      };
      s("create", P);
    }
    n(0, d = void 0), f = void 0;
  };
  Re(() => {
    i("pointerdown", S), i("pointermove", w), i("pointerup", A, !0);
  });
  const k = `rect-mask-${Math.random().toString(36).substring(2, 12)}`;
  return e.$$set = (P) => {
    "addEventListener" in P && n(7, i = P.addEventListener), "drawingMode" in P && n(8, l = P.drawingMode), "transform" in P && n(9, r = P.transform), "viewportScale" in P && n(10, a = P.viewportScale);
  }, e.$$.update = () => {
    e.$$.dirty & /*viewportScale*/
    1024 && n(5, o = 2 / a);
  }, [
    d,
    g,
    h,
    p,
    y,
    o,
    k,
    i,
    l,
    r,
    a
  ];
}
class Zi extends ye {
  constructor(t) {
    super(), _e(this, t, Wi, Ki, ae, {
      addEventListener: 7,
      drawingMode: 8,
      transform: 9,
      viewportScale: 10
    });
  }
}
function Ft(e) {
  const t = e.slice(), n = (
    /*coords*/
    t[2].map((o) => o.join(",")).join(" ")
  );
  return t[19] = n, t;
}
function Vn(e) {
  let t, n, o, s, i, l, r, a, u, d, f, g, h, p, y = (
    /*isClosable*/
    e[1] && Xn(e)
  );
  return {
    c() {
      t = I("defs"), n = I("mask"), o = I("rect"), a = I("polygon"), d = I("polygon"), g = I("polygon"), y && y.c(), p = ke(), c(o, "x", s = /*mask*/
      e[3].x), c(o, "y", i = /*mask*/
      e[3].y), c(o, "width", l = /*mask*/
      e[3].w), c(o, "height", r = /*mask*/
      e[3].h), c(o, "class", "svelte-18wrg3t"), c(a, "points", u = /*str*/
      e[19]), c(a, "class", "svelte-18wrg3t"), c(
        n,
        "id",
        /*maskId*/
        e[5]
      ), c(n, "class", "a9s-rubberband-polygon-mask svelte-18wrg3t"), c(d, "class", "a9s-outer"), c(d, "mask", `url(#${/*maskId*/
      e[5]})`), c(d, "points", f = /*str*/
      e[19]), c(g, "class", "a9s-inner"), c(g, "points", h = /*str*/
      e[19]);
    },
    m(S, w) {
      R(S, t, w), G(t, n), G(n, o), G(n, a), R(S, d, w), R(S, g, w), y && y.m(S, w), R(S, p, w);
    },
    p(S, w) {
      w & /*mask*/
      8 && s !== (s = /*mask*/
      S[3].x) && c(o, "x", s), w & /*mask*/
      8 && i !== (i = /*mask*/
      S[3].y) && c(o, "y", i), w & /*mask*/
      8 && l !== (l = /*mask*/
      S[3].w) && c(o, "width", l), w & /*mask*/
      8 && r !== (r = /*mask*/
      S[3].h) && c(o, "height", r), w & /*coords*/
      4 && u !== (u = /*str*/
      S[19]) && c(a, "points", u), w & /*coords*/
      4 && f !== (f = /*str*/
      S[19]) && c(d, "points", f), w & /*coords*/
      4 && h !== (h = /*str*/
      S[19]) && c(g, "points", h), /*isClosable*/
      S[1] ? y ? y.p(S, w) : (y = Xn(S), y.c(), y.m(p.parentNode, p)) : y && (y.d(1), y = null);
    },
    d(S) {
      S && (B(t), B(d), B(g), B(p)), y && y.d(S);
    }
  };
}
function Xn(e) {
  let t, n, o;
  return {
    c() {
      t = I("circle"), c(t, "class", "a9s-handle svelte-18wrg3t"), c(t, "cx", n = /*points*/
      e[0][0][0]), c(t, "cy", o = /*points*/
      e[0][0][1]), c(
        t,
        "r",
        /*handleRadius*/
        e[4]
      );
    },
    m(s, i) {
      R(s, t, i);
    },
    p(s, i) {
      i & /*points*/
      1 && n !== (n = /*points*/
      s[0][0][0]) && c(t, "cx", n), i & /*points*/
      1 && o !== (o = /*points*/
      s[0][0][1]) && c(t, "cy", o), i & /*handleRadius*/
      16 && c(
        t,
        "r",
        /*handleRadius*/
        s[4]
      );
    },
    d(s) {
      s && B(t);
    }
  };
}
function Ji(e) {
  let t, n = (
    /*mask*/
    e[3] && Vn(Ft(e))
  );
  return {
    c() {
      t = I("g"), n && n.c(), c(t, "class", "a9s-annotation a9s-rubberband");
    },
    m(o, s) {
      R(o, t, s), n && n.m(t, null);
    },
    p(o, [s]) {
      /*mask*/
      o[3] ? n ? n.p(Ft(o), s) : (n = Vn(Ft(o)), n.c(), n.m(t, null)) : n && (n.d(1), n = null);
    },
    i: $,
    o: $,
    d(o) {
      o && B(t), n && n.d();
    }
  };
}
const Qi = 20, xi = 1500;
function $i(e, t, n) {
  let o, s, i;
  const l = Ye();
  let { addEventListener: r } = t, { drawingMode: a } = t, { transform: u } = t, { viewportScale: d = 1 } = t, f, g = [], h, p, y = !1;
  const S = (C) => {
    const T = C, { timeStamp: Y, offsetX: D, offsetY: x } = T;
    if (f = { timeStamp: Y, offsetX: D, offsetY: x }, a === "drag" && g.length === 0) {
      const j = u.elementToImage(T.offsetX, T.offsetY);
      g.push(j), n(10, h = j);
    }
  }, w = (C) => {
    const T = C;
    if (p && clearTimeout(p), g.length > 0) {
      if (n(10, h = u.elementToImage(T.offsetX, T.offsetY)), g.length > 2) {
        const Y = yt(h, g[0]) * d;
        n(1, y = Y < Qi);
      }
      T.pointerType === "touch" && (p = setTimeout(
        () => {
          _();
        },
        xi
      ));
    }
  }, A = (C) => {
    const T = C;
    if (p && clearTimeout(p), a === "click") {
      const Y = T.timeStamp - f.timeStamp, D = yt([f.offsetX, f.offsetY], [T.offsetX, T.offsetY]);
      if (Y > 300 || D > 15) return;
      if (y)
        k();
      else if (g.length === 0) {
        const x = u.elementToImage(T.offsetX, T.offsetY);
        g.push(x), n(10, h = x);
      } else
        h && g.push(h);
    } else {
      if (!h) return;
      if (g.length === 1 && yt(g[0], h) <= 4) {
        n(0, g = []), n(10, h = void 0);
        return;
      }
      T.stopImmediatePropagation(), y ? k() : g.push(h);
    }
  }, _ = () => {
    if (!h) return;
    const C = g.slice(0, -1);
    if (C.length < 3) return;
    const T = {
      type: Q.POLYGON,
      geometry: {
        bounds: fe(g),
        points: C
      }
    };
    Qt(T) > 4 && (n(0, g = []), n(10, h = void 0), l("create", T));
  }, k = () => {
    const C = {
      type: Q.POLYGON,
      geometry: {
        bounds: fe(g),
        points: [...g]
      }
    };
    n(0, g = []), n(10, h = void 0), l("create", C);
  };
  Re(() => {
    r("pointerdown", S, !0), r("pointermove", w), r("pointerup", A, !0), r("dblclick", _, !0);
  });
  const P = `polygon-mask-${Math.random().toString(36).substring(2, 12)}`;
  return e.$$set = (C) => {
    "addEventListener" in C && n(6, r = C.addEventListener), "drawingMode" in C && n(7, a = C.drawingMode), "transform" in C && n(8, u = C.transform), "viewportScale" in C && n(9, d = C.viewportScale);
  }, e.$$.update = () => {
    e.$$.dirty & /*viewportScale*/
    512 && n(4, o = 4 / d), e.$$.dirty & /*cursor, isClosable, points*/
    1027 && n(2, s = h ? y ? g : [...g, h] : []), e.$$.dirty & /*coords, viewportScale*/
    516 && n(3, i = s.length > 0 ? kt(fe(s), 2 / d) : void 0);
  }, [
    g,
    y,
    s,
    i,
    o,
    P,
    r,
    a,
    u,
    d,
    h
  ];
}
class er extends ye {
  constructor(t) {
    super(), _e(this, t, $i, Ji, ae, {
      addEventListener: 6,
      drawingMode: 7,
      transform: 8,
      viewportScale: 9
    });
  }
}
const on = /* @__PURE__ */ new Map([
  ["rectangle", { tool: Zi }],
  ["polygon", { tool: er }]
]), ko = () => [...on.keys()], Mo = (e) => on.get(e), tr = (e, t, n = {}) => on.set(e, { tool: t, opts: n });
function nr(e) {
  let t, n, o, s, i;
  return {
    c() {
      t = I("g"), n = I("ellipse"), s = I("ellipse"), c(n, "class", "a9s-outer"), c(n, "style", o = /*computedStyle*/
      e[1] ? "display:none;" : void 0), c(
        n,
        "cx",
        /*cx*/
        e[2]
      ), c(
        n,
        "cy",
        /*cy*/
        e[3]
      ), c(
        n,
        "rx",
        /*rx*/
        e[4]
      ), c(
        n,
        "ry",
        /*ry*/
        e[5]
      ), c(s, "class", "a9s-inner"), c(
        s,
        "style",
        /*computedStyle*/
        e[1]
      ), c(
        s,
        "cx",
        /*cx*/
        e[2]
      ), c(
        s,
        "cy",
        /*cy*/
        e[3]
      ), c(
        s,
        "rx",
        /*rx*/
        e[4]
      ), c(
        s,
        "ry",
        /*ry*/
        e[5]
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", i = /*annotation*/
      e[0].id);
    },
    m(l, r) {
      R(l, t, r), G(t, n), G(t, s);
    },
    p(l, [r]) {
      r & /*computedStyle*/
      2 && o !== (o = /*computedStyle*/
      l[1] ? "display:none;" : void 0) && c(n, "style", o), r & /*computedStyle*/
      2 && c(
        s,
        "style",
        /*computedStyle*/
        l[1]
      ), r & /*annotation*/
      1 && i !== (i = /*annotation*/
      l[0].id) && c(t, "data-id", i);
    },
    i: $,
    o: $,
    d(l) {
      l && B(t);
    }
  };
}
function or(e, t, n) {
  let o, { annotation: s } = t, { geom: i } = t, { style: l } = t;
  const { cx: r, cy: a, rx: u, ry: d } = i;
  return e.$$set = (f) => {
    "annotation" in f && n(0, s = f.annotation), "geom" in f && n(6, i = f.geom), "style" in f && n(7, l = f.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    129 && n(1, o = Ge(s, l));
  }, [s, o, r, a, u, d, i, l];
}
class sr extends ye {
  constructor(t) {
    super(), _e(this, t, or, nr, ae, { annotation: 0, geom: 6, style: 7 });
  }
}
function ir(e) {
  let t, n, o, s, i;
  return {
    c() {
      t = I("g"), n = I("line"), s = I("line"), c(n, "class", "a9s-outer"), c(n, "style", o = /*computedStyle*/
      e[1] ? "display:none;" : void 0), c(
        n,
        "x1",
        /*x1*/
        e[2]
      ), c(
        n,
        "y1",
        /*y1*/
        e[3]
      ), c(
        n,
        "x2",
        /*x2*/
        e[4]
      ), c(
        n,
        "y2",
        /*y2*/
        e[5]
      ), c(s, "class", "a9s-inner"), c(
        s,
        "style",
        /*computedStyle*/
        e[1]
      ), c(
        s,
        "x1",
        /*x1*/
        e[2]
      ), c(
        s,
        "y1",
        /*y1*/
        e[3]
      ), c(
        s,
        "x2",
        /*x2*/
        e[4]
      ), c(
        s,
        "y2",
        /*y2*/
        e[5]
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", i = /*annotation*/
      e[0].id);
    },
    m(l, r) {
      R(l, t, r), G(t, n), G(t, s);
    },
    p(l, [r]) {
      r & /*computedStyle*/
      2 && o !== (o = /*computedStyle*/
      l[1] ? "display:none;" : void 0) && c(n, "style", o), r & /*computedStyle*/
      2 && c(
        s,
        "style",
        /*computedStyle*/
        l[1]
      ), r & /*annotation*/
      1 && i !== (i = /*annotation*/
      l[0].id) && c(t, "data-id", i);
    },
    i: $,
    o: $,
    d(l) {
      l && B(t);
    }
  };
}
function rr(e, t, n) {
  let o, { annotation: s } = t, { geom: i } = t, { style: l } = t;
  const { points: r } = i, [[a, u], [d, f]] = r;
  return e.$$set = (g) => {
    "annotation" in g && n(0, s = g.annotation), "geom" in g && n(6, i = g.geom), "style" in g && n(7, l = g.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    129 && n(1, o = Ge(s, l));
  }, [s, o, a, u, d, f, i, l];
}
class lr extends ye {
  constructor(t) {
    super(), _e(this, t, rr, ir, ae, { annotation: 0, geom: 6, style: 7 });
  }
}
function Hn(e, t, n) {
  const o = e.slice();
  return o[5] = t[n], o;
}
function Gn(e) {
  let t, n, o;
  return {
    c() {
      t = I("path"), o = I("path"), c(t, "class", "a9s-outer"), c(t, "style", n = /*computedStyle*/
      e[1] ? "display:none;" : void 0), c(t, "fill-rule", "evenodd"), c(t, "d", Pe(
        /*polygonElement*/
        e[5]
      )), c(o, "class", "a9s-inner"), c(
        o,
        "style",
        /*computedStyle*/
        e[1]
      ), c(o, "fill-rule", "evenodd"), c(o, "d", Pe(
        /*polygonElement*/
        e[5]
      ));
    },
    m(s, i) {
      R(s, t, i), R(s, o, i);
    },
    p(s, i) {
      i & /*computedStyle*/
      2 && n !== (n = /*computedStyle*/
      s[1] ? "display:none;" : void 0) && c(t, "style", n), i & /*computedStyle*/
      2 && c(
        o,
        "style",
        /*computedStyle*/
        s[1]
      );
    },
    d(s) {
      s && (B(t), B(o));
    }
  };
}
function ar(e) {
  let t, n, o = ve(
    /*polygons*/
    e[2]
  ), s = [];
  for (let i = 0; i < o.length; i += 1)
    s[i] = Gn(Hn(e, o, i));
  return {
    c() {
      t = I("g");
      for (let i = 0; i < s.length; i += 1)
        s[i].c();
      c(t, "class", "a9s-annotation"), c(t, "data-id", n = /*annotation*/
      e[0].id);
    },
    m(i, l) {
      R(i, t, l);
      for (let r = 0; r < s.length; r += 1)
        s[r] && s[r].m(t, null);
    },
    p(i, [l]) {
      if (l & /*computedStyle, polygons, undefined*/
      6) {
        o = ve(
          /*polygons*/
          i[2]
        );
        let r;
        for (r = 0; r < o.length; r += 1) {
          const a = Hn(i, o, r);
          s[r] ? s[r].p(a, l) : (s[r] = Gn(a), s[r].c(), s[r].m(t, null));
        }
        for (; r < s.length; r += 1)
          s[r].d(1);
        s.length = o.length;
      }
      l & /*annotation*/
      1 && n !== (n = /*annotation*/
      i[0].id) && c(t, "data-id", n);
    },
    i: $,
    o: $,
    d(i) {
      i && B(t), He(s, i);
    }
  };
}
function cr(e, t, n) {
  let o, { annotation: s } = t, { geom: i } = t, { style: l } = t;
  const { polygons: r } = i;
  return e.$$set = (a) => {
    "annotation" in a && n(0, s = a.annotation), "geom" in a && n(3, i = a.geom), "style" in a && n(4, l = a.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    17 && n(1, o = Ge(s, l));
  }, [s, o, r, i, l];
}
class ur extends ye {
  constructor(t) {
    super(), _e(this, t, cr, ar, ae, { annotation: 0, geom: 3, style: 4 });
  }
}
function fr(e) {
  let t, n, o, s, i;
  return {
    c() {
      t = I("g"), n = I("polygon"), s = I("polygon"), c(n, "class", "a9s-outer"), c(n, "style", o = /*computedStyle*/
      e[1] ? "display:none;" : void 0), c(
        n,
        "points",
        /*points*/
        e[2].map(dr).join(" ")
      ), c(s, "class", "a9s-inner"), c(
        s,
        "style",
        /*computedStyle*/
        e[1]
      ), c(
        s,
        "points",
        /*points*/
        e[2].map(gr).join(" ")
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", i = /*annotation*/
      e[0].id);
    },
    m(l, r) {
      R(l, t, r), G(t, n), G(t, s);
    },
    p(l, [r]) {
      r & /*computedStyle*/
      2 && o !== (o = /*computedStyle*/
      l[1] ? "display:none;" : void 0) && c(n, "style", o), r & /*computedStyle*/
      2 && c(
        s,
        "style",
        /*computedStyle*/
        l[1]
      ), r & /*annotation*/
      1 && i !== (i = /*annotation*/
      l[0].id) && c(t, "data-id", i);
    },
    i: $,
    o: $,
    d(l) {
      l && B(t);
    }
  };
}
const dr = (e) => e.join(","), gr = (e) => e.join(",");
function hr(e, t, n) {
  let o, { annotation: s } = t, { geom: i } = t, { style: l } = t;
  const { points: r } = i;
  return e.$$set = (a) => {
    "annotation" in a && n(0, s = a.annotation), "geom" in a && n(3, i = a.geom), "style" in a && n(4, l = a.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    17 && n(1, o = Ge(s, l));
  }, [s, o, r, i, l];
}
class mr extends ye {
  constructor(t) {
    super(), _e(this, t, hr, fr, ae, { annotation: 0, geom: 3, style: 4 });
  }
}
function pr(e) {
  let t, n, o, s, i, l, r;
  return {
    c() {
      t = I("g"), n = I("path"), i = I("path"), c(n, "class", o = We(`a9s-outer ${/*cssClass*/
      e[1]}`) + " svelte-1w0132l"), c(n, "style", s = /*computedStyle*/
      e[3] ? "display:none;" : void 0), c(
        n,
        "d",
        /*d*/
        e[2]
      ), c(i, "class", l = We(`a9s-inner ${/*cssClass*/
      e[1]}`) + " svelte-1w0132l"), c(
        i,
        "style",
        /*computedStyle*/
        e[3]
      ), c(
        i,
        "d",
        /*d*/
        e[2]
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", r = /*annotation*/
      e[0].id);
    },
    m(a, u) {
      R(a, t, u), G(t, n), G(t, i);
    },
    p(a, [u]) {
      u & /*cssClass*/
      2 && o !== (o = We(`a9s-outer ${/*cssClass*/
      a[1]}`) + " svelte-1w0132l") && c(n, "class", o), u & /*computedStyle*/
      8 && s !== (s = /*computedStyle*/
      a[3] ? "display:none;" : void 0) && c(n, "style", s), u & /*d*/
      4 && c(
        n,
        "d",
        /*d*/
        a[2]
      ), u & /*cssClass*/
      2 && l !== (l = We(`a9s-inner ${/*cssClass*/
      a[1]}`) + " svelte-1w0132l") && c(i, "class", l), u & /*computedStyle*/
      8 && c(
        i,
        "style",
        /*computedStyle*/
        a[3]
      ), u & /*d*/
      4 && c(
        i,
        "d",
        /*d*/
        a[2]
      ), u & /*annotation*/
      1 && r !== (r = /*annotation*/
      a[0].id) && c(t, "data-id", r);
    },
    i: $,
    o: $,
    d(a) {
      a && B(t);
    }
  };
}
function _r(e, t, n) {
  let o, s, i, { annotation: l } = t, { geom: r } = t, { style: a } = t;
  return e.$$set = (u) => {
    "annotation" in u && n(0, l = u.annotation), "geom" in u && n(4, r = u.geom), "style" in u && n(5, a = u.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    33 && n(3, o = Ge(l, a)), e.$$.dirty & /*geom*/
    16 && n(2, s = ho(r)), e.$$.dirty & /*geom*/
    16 && n(1, i = r.closed ? "closed" : "open");
  }, [l, i, s, o, r, a];
}
class yr extends ye {
  constructor(t) {
    super(), _e(this, t, _r, pr, ae, { annotation: 0, geom: 4, style: 5 });
  }
}
function wr(e) {
  let t, n, o, s, i, l;
  return {
    c() {
      t = I("g"), n = I("g"), o = I("rect"), i = I("rect"), c(o, "class", "a9s-outer"), c(o, "style", s = /*computedStyle*/
      e[6] ? "display:none;" : void 0), c(
        o,
        "x",
        /*x*/
        e[4]
      ), c(
        o,
        "y",
        /*y*/
        e[2]
      ), c(
        o,
        "width",
        /*w*/
        e[3]
      ), c(
        o,
        "height",
        /*h*/
        e[1]
      ), c(i, "class", "a9s-inner"), c(
        i,
        "style",
        /*computedStyle*/
        e[6]
      ), c(
        i,
        "x",
        /*x*/
        e[4]
      ), c(
        i,
        "y",
        /*y*/
        e[2]
      ), c(
        i,
        "width",
        /*w*/
        e[3]
      ), c(
        i,
        "height",
        /*h*/
        e[1]
      ), c(
        n,
        "transform",
        /*rectTransform*/
        e[5]
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", l = /*annotation*/
      e[0].id);
    },
    m(r, a) {
      R(r, t, a), G(t, n), G(n, o), G(n, i);
    },
    p(r, [a]) {
      a & /*computedStyle*/
      64 && s !== (s = /*computedStyle*/
      r[6] ? "display:none;" : void 0) && c(o, "style", s), a & /*x*/
      16 && c(
        o,
        "x",
        /*x*/
        r[4]
      ), a & /*y*/
      4 && c(
        o,
        "y",
        /*y*/
        r[2]
      ), a & /*w*/
      8 && c(
        o,
        "width",
        /*w*/
        r[3]
      ), a & /*h*/
      2 && c(
        o,
        "height",
        /*h*/
        r[1]
      ), a & /*computedStyle*/
      64 && c(
        i,
        "style",
        /*computedStyle*/
        r[6]
      ), a & /*x*/
      16 && c(
        i,
        "x",
        /*x*/
        r[4]
      ), a & /*y*/
      4 && c(
        i,
        "y",
        /*y*/
        r[2]
      ), a & /*w*/
      8 && c(
        i,
        "width",
        /*w*/
        r[3]
      ), a & /*h*/
      2 && c(
        i,
        "height",
        /*h*/
        r[1]
      ), a & /*rectTransform*/
      32 && c(
        n,
        "transform",
        /*rectTransform*/
        r[5]
      ), a & /*annotation*/
      1 && l !== (l = /*annotation*/
      r[0].id) && c(t, "data-id", l);
    },
    i: $,
    o: $,
    d(r) {
      r && B(t);
    }
  };
}
function br(e, t, n) {
  let o, s, i, l, r, a, u, { annotation: d } = t, { geom: f } = t, { style: g } = t;
  return e.$$set = (h) => {
    "annotation" in h && n(0, d = h.annotation), "geom" in h && n(7, f = h.geom), "style" in h && n(8, g = h.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    257 && n(6, o = Ge(d, g)), e.$$.dirty & /*geom*/
    128 && n(4, { x: s, y: i, w: l, h: r, rot: a } = f, s, (n(2, i), n(7, f)), (n(3, l), n(7, f)), (n(1, r), n(7, f)), (n(9, a), n(7, f))), e.$$.dirty & /*rot, x, w, y, h*/
    542 && n(5, u = (a ?? 0) !== 0 ? `translate(${s + l / 2}, ${i + r / 2}) rotate(${(a ?? 0) * 180 / Math.PI}) translate(${-(s + l / 2)}, ${-(i + r / 2)})` : void 0);
  }, [d, r, i, l, s, u, o, f, g, a];
}
class Er extends ye {
  constructor(t) {
    super(), _e(this, t, br, wr, ae, { annotation: 0, geom: 7, style: 8 });
  }
}
const il = {
  elementToImage: (e, t) => [e, t]
}, vr = (e) => ({
  elementToImage: (t, n) => {
    const o = e.getBoundingClientRect(), s = e.createSVGPoint();
    s.x = t + o.x, s.y = n + o.y;
    const { x: i, y: l } = s.matrixTransform(e.getScreenCTM().inverse());
    return [i, l];
  }
}), Ar = 250, Sr = (e, t) => {
  const n = Ye();
  let o;
  return { onPointerDown: () => o = performance.now(), onPointerUp: (l) => {
    if (performance.now() - o < Ar) {
      const { x: a, y: u } = To(l, e), d = Le ? 10 : 2, f = t.getAt(a, u, void 0, d);
      f ? n("click", { originalEvent: l, annotation: f }) : n("click", { originalEvent: l });
    }
  } };
}, To = (e, t) => {
  const n = t.createSVGPoint(), o = t.getBoundingClientRect(), s = e.clientX - o.x, i = e.clientY - o.y, { left: l, top: r } = t.getBoundingClientRect();
  return n.x = s + l, n.y = i + r, n.matrixTransform(t.getScreenCTM().inverse());
};
function jn(e, t, n) {
  const o = e.slice();
  return o[39] = t[n], o;
}
function Fn(e, t, n) {
  const o = e.slice();
  return o[42] = t[n], o;
}
function zt(e) {
  const t = e.slice(), n = (
    /*annotation*/
    t[42].target.selector
  );
  return t[45] = n, t;
}
function zn(e) {
  let t = (
    /*annotation*/
    e[42]
  ), n, o, s = qn(e);
  return {
    c() {
      s.c(), n = ke();
    },
    m(i, l) {
      s.m(i, l), R(i, n, l), o = !0;
    },
    p(i, l) {
      l[0] & /*$store*/
      131072 && ae(t, t = /*annotation*/
      i[42]) ? (be(), H(s, 1, 1, $), Ee(), s = qn(i), s.c(), U(s, 1), s.m(n.parentNode, n)) : s.p(i, l);
    },
    i(i) {
      o || (U(s), o = !0);
    },
    o(i) {
      H(s), o = !1;
    },
    d(i) {
      i && B(n), s.d(i);
    }
  };
}
function kr(e) {
  let t, n;
  return t = new lr({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*$store*/
      131072 && (i.annotation = /*annotation*/
      o[42]), s[0] & /*$store*/
      131072 && (i.geom = /*selector*/
      o[45].geometry), s[0] & /*style*/
      2 && (i.style = /*style*/
      o[1]), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Mr(e) {
  let t, n;
  return t = new yr({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*$store*/
      131072 && (i.annotation = /*annotation*/
      o[42]), s[0] & /*$store*/
      131072 && (i.geom = /*selector*/
      o[45].geometry), s[0] & /*style*/
      2 && (i.style = /*style*/
      o[1]), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Tr(e) {
  let t, n;
  return t = new ur({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*$store*/
      131072 && (i.annotation = /*annotation*/
      o[42]), s[0] & /*$store*/
      131072 && (i.geom = /*selector*/
      o[45].geometry), s[0] & /*style*/
      2 && (i.style = /*style*/
      o[1]), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Pr(e) {
  let t, n;
  return t = new mr({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*$store*/
      131072 && (i.annotation = /*annotation*/
      o[42]), s[0] & /*$store*/
      131072 && (i.geom = /*selector*/
      o[45].geometry), s[0] & /*style*/
      2 && (i.style = /*style*/
      o[1]), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Lr(e) {
  let t, n;
  return t = new Er({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*$store*/
      131072 && (i.annotation = /*annotation*/
      o[42]), s[0] & /*$store*/
      131072 && (i.geom = /*selector*/
      o[45].geometry), s[0] & /*style*/
      2 && (i.style = /*style*/
      o[1]), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Ir(e) {
  var o;
  let t, n;
  return t = new sr({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        (o = e[45]) == null ? void 0 : o.geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(s, i) {
      re(t, s, i), n = !0;
    },
    p(s, i) {
      var r;
      const l = {};
      i[0] & /*$store*/
      131072 && (l.annotation = /*annotation*/
      s[42]), i[0] & /*$store*/
      131072 && (l.geom = /*selector*/
      (r = s[45]) == null ? void 0 : r.geometry), i[0] & /*style*/
      2 && (l.style = /*style*/
      s[1]), t.$set(l);
    },
    i(s) {
      n || (U(t.$$.fragment, s), n = !0);
    },
    o(s) {
      H(t.$$.fragment, s), n = !1;
    },
    d(s) {
      le(t, s);
    }
  };
}
function qn(e) {
  let t, n, o, s;
  const i = [
    Ir,
    Lr,
    Pr,
    Tr,
    Mr,
    kr
  ], l = [];
  function r(a, u) {
    var d, f, g, h, p, y;
    return (
      /*selector*/
      ((d = a[45]) == null ? void 0 : d.type) === Q.ELLIPSE ? 0 : (
        /*selector*/
        ((f = a[45]) == null ? void 0 : f.type) === Q.RECTANGLE ? 1 : (
          /*selector*/
          ((g = a[45]) == null ? void 0 : g.type) === Q.POLYGON ? 2 : (
            /*selector*/
            ((h = a[45]) == null ? void 0 : h.type) === Q.MULTIPOLYGON ? 3 : (
              /*selector*/
              ((p = a[45]) == null ? void 0 : p.type) === Q.POLYLINE ? 4 : (
                /*selector*/
                ((y = a[45]) == null ? void 0 : y.type) === Q.LINE ? 5 : -1
              )
            )
          )
        )
      )
    );
  }
  return ~(t = r(e)) && (n = l[t] = i[t](e)), {
    c() {
      n && n.c(), o = ke();
    },
    m(a, u) {
      ~t && l[t].m(a, u), R(a, o, u), s = !0;
    },
    p(a, u) {
      let d = t;
      t = r(a), t === d ? ~t && l[t].p(a, u) : (n && (be(), H(l[d], 1, 1, () => {
        l[d] = null;
      }), Ee()), ~t ? (n = l[t], n ? n.p(a, u) : (n = l[t] = i[t](a), n.c()), U(n, 1), n.m(o.parentNode, o)) : n = null);
    },
    i(a) {
      s || (U(n), s = !0);
    },
    o(a) {
      H(n), s = !1;
    },
    d(a) {
      a && B(o), ~t && l[t].d(a);
    }
  };
}
function Kn(e) {
  let t = St(
    /*annotation*/
    e[42]
  ) && !/*isEditable*/
  e[10](
    /*annotation*/
    e[42]
  ), n, o, s = t && zn(zt(e));
  return {
    c() {
      s && s.c(), n = ke();
    },
    m(i, l) {
      s && s.m(i, l), R(i, n, l), o = !0;
    },
    p(i, l) {
      l[0] & /*$store, isEditable*/
      132096 && (t = St(
        /*annotation*/
        i[42]
      ) && !/*isEditable*/
      i[10](
        /*annotation*/
        i[42]
      )), t ? s ? (s.p(zt(i), l), l[0] & /*$store, isEditable*/
      132096 && U(s, 1)) : (s = zn(zt(i)), s.c(), U(s, 1), s.m(n.parentNode, n)) : s && (be(), H(s, 1, 1, () => {
        s = null;
      }), Ee());
    },
    i(i) {
      o || (U(s), o = !0);
    },
    o(i) {
      H(s), o = !1;
    },
    d(i) {
      i && B(n), s && s.d(i);
    }
  };
}
function Wn(e) {
  let t, n, o, s;
  const i = [Or, Cr], l = [];
  function r(a, u) {
    return (
      /*editors*/
      a[6] ? 0 : (
        /*tool*/
        a[15] && /*drawingEnabled*/
        a[0] ? 1 : -1
      )
    );
  }
  return ~(t = r(e)) && (n = l[t] = i[t](e)), {
    c() {
      n && n.c(), o = ke();
    },
    m(a, u) {
      ~t && l[t].m(a, u), R(a, o, u), s = !0;
    },
    p(a, u) {
      let d = t;
      t = r(a), t === d ? ~t && l[t].p(a, u) : (n && (be(), H(l[d], 1, 1, () => {
        l[d] = null;
      }), Ee()), ~t ? (n = l[t], n ? n.p(a, u) : (n = l[t] = i[t](a), n.c()), U(n, 1), n.m(o.parentNode, o)) : n = null);
    },
    i(a) {
      s || (U(n), s = !0);
    },
    o(a) {
      H(n), s = !1;
    },
    d(a) {
      a && B(o), ~t && l[t].d(a);
    }
  };
}
function Cr(e) {
  let t = `${/*toolName*/
  e[2]}-${/*toolMountKey*/
  e[7]}`, n, o, s = Zn(e);
  return {
    c() {
      s.c(), n = ke();
    },
    m(i, l) {
      s.m(i, l), R(i, n, l), o = !0;
    },
    p(i, l) {
      l[0] & /*toolName, toolMountKey*/
      132 && ae(t, t = `${/*toolName*/
      i[2]}-${/*toolMountKey*/
      i[7]}`) ? (be(), H(s, 1, 1, $), Ee(), s = Zn(i), s.c(), U(s, 1), s.m(n.parentNode, n)) : s.p(i, l);
    },
    i(i) {
      o || (U(s), o = !0);
    },
    o(i) {
      H(s), o = !1;
    },
    d(i) {
      i && B(n), s.d(i);
    }
  };
}
function Or(e) {
  let t, n, o = ve(
    /*editors*/
    e[6]
  ), s = [];
  for (let l = 0; l < o.length; l += 1)
    s[l] = Qn(jn(e, o, l));
  const i = (l) => H(s[l], 1, 1, () => {
    s[l] = null;
  });
  return {
    c() {
      for (let l = 0; l < s.length; l += 1)
        s[l].c();
      t = ke();
    },
    m(l, r) {
      for (let a = 0; a < s.length; a += 1)
        s[a] && s[a].m(l, r);
      R(l, t, r), n = !0;
    },
    p(l, r) {
      if (r[0] & /*editors, drawingEl, style, transform, $scale, onChangeSelected*/
      8659266) {
        o = ve(
          /*editors*/
          l[6]
        );
        let a;
        for (a = 0; a < o.length; a += 1) {
          const u = jn(l, o, a);
          s[a] ? (s[a].p(u, r), U(s[a], 1)) : (s[a] = Qn(u), s[a].c(), U(s[a], 1), s[a].m(t.parentNode, t));
        }
        for (be(), a = o.length; a < s.length; a += 1)
          i(a);
        Ee();
      }
    },
    i(l) {
      if (!n) {
        for (let r = 0; r < o.length; r += 1)
          U(s[r]);
        n = !0;
      }
    },
    o(l) {
      s = s.filter(Boolean);
      for (let r = 0; r < s.length; r += 1)
        H(s[r]);
      n = !1;
    },
    d(l) {
      l && B(t), He(s, l);
    }
  };
}
function Zn(e) {
  let t, n;
  return t = new qi({
    props: {
      target: (
        /*drawingEl*/
        e[8]
      ),
      tool: (
        /*tool*/
        e[15]
      ),
      drawingMode: (
        /*drawingMode*/
        e[14]
      ),
      transform: (
        /*transform*/
        e[13]
      ),
      viewportScale: (
        /*$scale*/
        e[18]
      )
    }
  }), t.$on(
    "create",
    /*onSelectionCreated*/
    e[22]
  ), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*drawingEl*/
      256 && (i.target = /*drawingEl*/
      o[8]), s[0] & /*tool*/
      32768 && (i.tool = /*tool*/
      o[15]), s[0] & /*drawingMode*/
      16384 && (i.drawingMode = /*drawingMode*/
      o[14]), s[0] & /*transform*/
      8192 && (i.transform = /*transform*/
      o[13]), s[0] & /*$scale*/
      262144 && (i.viewportScale = /*$scale*/
      o[18]), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Jn(e) {
  let t, n;
  return t = new Fi({
    props: {
      target: (
        /*drawingEl*/
        e[8]
      ),
      editor: (
        /*editable*/
        e[39].editor
      ),
      annotation: (
        /*editable*/
        e[39].annotation
      ),
      style: (
        /*style*/
        e[1]
      ),
      transform: (
        /*transform*/
        e[13]
      ),
      viewportScale: (
        /*$scale*/
        e[18]
      )
    }
  }), t.$on("change", function() {
    se(
      /*onChangeSelected*/
      e[23](
        /*editable*/
        e[39].annotation
      )
    ) && e[23](
      /*editable*/
      e[39].annotation
    ).apply(this, arguments);
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      e = o;
      const i = {};
      s[0] & /*drawingEl*/
      256 && (i.target = /*drawingEl*/
      e[8]), s[0] & /*editors*/
      64 && (i.editor = /*editable*/
      e[39].editor), s[0] & /*editors*/
      64 && (i.annotation = /*editable*/
      e[39].annotation), s[0] & /*style*/
      2 && (i.style = /*style*/
      e[1]), s[0] & /*transform*/
      8192 && (i.transform = /*transform*/
      e[13]), s[0] & /*$scale*/
      262144 && (i.viewportScale = /*$scale*/
      e[18]), t.$set(i);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Qn(e) {
  let t = (
    /*editable*/
    e[39].annotation.id
  ), n, o, s = Jn(e);
  return {
    c() {
      s.c(), n = ke();
    },
    m(i, l) {
      s.m(i, l), R(i, n, l), o = !0;
    },
    p(i, l) {
      l[0] & /*editors*/
      64 && ae(t, t = /*editable*/
      i[39].annotation.id) ? (be(), H(s, 1, 1, $), Ee(), s = Jn(i), s.c(), U(s, 1), s.m(n.parentNode, n)) : s.p(i, l);
    },
    i(i) {
      o || (U(s), o = !0);
    },
    o(i) {
      H(s), o = !1;
    },
    d(i) {
      i && B(n), s.d(i);
    }
  };
}
function Dr(e) {
  let t, n, o, s, i, l, r = ve(
    /*$store*/
    e[17].filter(
      /*func*/
      e[34]
    )
  ), a = [];
  for (let f = 0; f < r.length; f += 1)
    a[f] = Kn(Fn(e, r, f));
  const u = (f) => H(a[f], 1, 1, () => {
    a[f] = null;
  });
  let d = (
    /*drawingEl*/
    e[8] && Wn(e)
  );
  return {
    c() {
      t = I("svg"), n = I("g");
      for (let f = 0; f < a.length; f += 1)
        a[f].c();
      o = I("g"), d && d.c(), c(o, "class", "drawing"), c(t, "role", "application"), c(t, "tabindex", 0), c(t, "class", "a9s-annotationlayer"), Te(
        t,
        "drawing",
        /*tool*/
        e[15]
      ), Te(
        t,
        "editing",
        /*editableAnnotations*/
        e[5]
      ), Te(t, "hidden", !/*visible*/
      e[3]), Te(
        t,
        "hover",
        /*$hover*/
        e[16]
      );
    },
    m(f, g) {
      R(f, t, g), G(t, n);
      for (let h = 0; h < a.length; h += 1)
        a[h] && a[h].m(n, null);
      G(t, o), d && d.m(o, null), e[35](o), e[36](t), s = !0, i || (l = [
        J(t, "pointerup", function() {
          se(
            /*onPointerUp*/
            e[11]
          ) && e[11].apply(this, arguments);
        }),
        J(t, "pointerdown", function() {
          se(
            /*onPointerDown*/
            e[12]
          ) && e[12].apply(this, arguments);
        }),
        J(
          t,
          "pointermove",
          /*onPointerMove*/
          e[24]
        )
      ], i = !0);
    },
    p(f, g) {
      if (e = f, g[0] & /*$store, style, isEditable*/
      132098) {
        r = ve(
          /*$store*/
          e[17].filter(
            /*func*/
            e[34]
          )
        );
        let h;
        for (h = 0; h < r.length; h += 1) {
          const p = Fn(e, r, h);
          a[h] ? (a[h].p(p, g), U(a[h], 1)) : (a[h] = Kn(p), a[h].c(), U(a[h], 1), a[h].m(n, null));
        }
        for (be(), h = r.length; h < a.length; h += 1)
          u(h);
        Ee();
      }
      /*drawingEl*/
      e[8] ? d ? (d.p(e, g), g[0] & /*drawingEl*/
      256 && U(d, 1)) : (d = Wn(e), d.c(), U(d, 1), d.m(o, null)) : d && (be(), H(d, 1, 1, () => {
        d = null;
      }), Ee()), (!s || g[0] & /*tool*/
      32768) && Te(
        t,
        "drawing",
        /*tool*/
        e[15]
      ), (!s || g[0] & /*editableAnnotations*/
      32) && Te(
        t,
        "editing",
        /*editableAnnotations*/
        e[5]
      ), (!s || g[0] & /*visible*/
      8) && Te(t, "hidden", !/*visible*/
      e[3]), (!s || g[0] & /*$hover*/
      65536) && Te(
        t,
        "hover",
        /*$hover*/
        e[16]
      );
    },
    i(f) {
      if (!s) {
        for (let g = 0; g < r.length; g += 1)
          U(a[g]);
        U(d), s = !0;
      }
    },
    o(f) {
      a = a.filter(Boolean);
      for (let g = 0; g < a.length; g += 1)
        H(a[g]);
      H(d), s = !1;
    },
    d(f) {
      f && B(t), He(a, f), d && d.d(), e[35](null), e[36](null), i = !1, Se(l);
    }
  };
}
function Nr(e, t, n) {
  let o, s, i, l, r, a, u, d, f, g, h, p, y = $, S = () => (y(), y = no(b, (X) => n(18, p = X)), b);
  e.$$.on_destroy.push(() => y());
  let { drawingEnabled: w } = t, { image: A } = t, { preferredDrawingMode: _ } = t, { state: k } = t, { style: P = void 0 } = t, { toolName: C = ko()[0] } = t, { user: T } = t, { visible: Y = !0 } = t, D = 0;
  const x = () => n(7, D += 1), j = () => C, v = () => w;
  let E, m, b;
  Re(() => S(n(9, b = ri(A, m))));
  const { hover: L, selection: M, store: O } = k;
  Ot(e, L, (X) => n(16, f = X)), Ot(e, M, (X) => n(33, g = X)), Ot(e, O, (X) => n(17, h = X));
  let F, V;
  const Z = (X) => {
    F && O.unobserve(F);
    const ue = X.filter(({ editable: te }) => te).map(({ id: te }) => te);
    ue.length > 0 ? (n(5, V = ue.map((te) => O.getAnnotation(te)).filter((te) => te && St(te))), F = (te) => {
      const { updated: he } = te.changes;
      n(5, V = he == null ? void 0 : he.map((ie) => ie.newValue));
    }, O.observe(F, { annotations: ue })) : n(5, V = void 0);
  }, q = (X) => {
    const ue = _o(), te = {
      id: ue,
      bodies: [],
      target: {
        annotation: ue,
        selector: X.detail,
        creator: T,
        created: /* @__PURE__ */ new Date()
      }
    };
    O.addAnnotation(te), M.setSelected(te.id);
  }, K = (X) => (ue) => {
    var Ue;
    const { target: te } = X, he = 10 * 60 * 1e3, ie = ((Ue = te.creator) == null ? void 0 : Ue.id) !== T.id || !te.created || (/* @__PURE__ */ new Date()).getTime() - te.created.getTime() > he;
    O.updateTarget({
      ...te,
      selector: ue.detail,
      created: ie ? te.created : /* @__PURE__ */ new Date(),
      updated: ie ? /* @__PURE__ */ new Date() : void 0,
      updatedBy: ie ? T : void 0
    });
  }, ee = (X) => {
    const { x: ue, y: te } = To(X, m), he = O.getAt(ue, te, void 0, 2);
    he ? f !== he.id && L.set(he.id) : L.set(void 0);
  }, ge = (X) => St(X);
  function ne(X) {
    Et[X ? "unshift" : "push"](() => {
      E = X, n(8, E);
    });
  }
  function Ae(X) {
    Et[X ? "unshift" : "push"](() => {
      m = X, n(4, m);
    });
  }
  return e.$$set = (X) => {
    "drawingEnabled" in X && n(0, w = X.drawingEnabled), "image" in X && n(25, A = X.image), "preferredDrawingMode" in X && n(26, _ = X.preferredDrawingMode), "state" in X && n(27, k = X.state), "style" in X && n(1, P = X.style), "toolName" in X && n(2, C = X.toolName), "user" in X && n(28, T = X.user), "visible" in X && n(3, Y = X.visible);
  }, e.$$.update = () => {
    e.$$.dirty[0] & /*toolName*/
    4 && n(15, { tool: o, opts: s } = Mo(C) || { tool: void 0, opts: void 0 }, o, (n(32, s), n(2, C))), e.$$.dirty[0] & /*preferredDrawingMode*/
    67108864 | e.$$.dirty[1] & /*opts*/
    2 && n(14, i = (s == null ? void 0 : s.drawingMode) || _), e.$$.dirty[0] & /*svgEl*/
    16 && n(13, l = vr(m)), e.$$.dirty[0] & /*svgEl*/
    16 && n(12, { onPointerDown: r, onPointerUp: a } = Sr(m, O), r, (n(11, a), n(4, m))), e.$$.dirty[1] & /*$selection*/
    4 && Z(g.selected), e.$$.dirty[0] & /*editableAnnotations*/
    32 && n(6, u = V ? V.map((X) => ({
      annotation: X,
      editor: Hi(X.target.selector)
    })).filter((X) => X.editor) : void 0), e.$$.dirty[0] & /*editors*/
    64 && n(10, d = (X) => u && u.some((ue) => ue.annotation.id === X.id));
  }, [
    w,
    P,
    C,
    Y,
    m,
    V,
    u,
    D,
    E,
    b,
    d,
    a,
    r,
    l,
    i,
    o,
    f,
    h,
    p,
    L,
    M,
    O,
    q,
    K,
    ee,
    A,
    _,
    k,
    T,
    x,
    j,
    v,
    s,
    g,
    ge,
    ne,
    Ae
  ];
}
class Br extends ye {
  constructor(t) {
    super(), _e(
      this,
      t,
      Nr,
      Dr,
      ae,
      {
        drawingEnabled: 0,
        image: 25,
        preferredDrawingMode: 26,
        state: 27,
        style: 1,
        toolName: 2,
        user: 28,
        visible: 3,
        cancelDrawing: 29,
        getDrawingTool: 30,
        isDrawingEnabled: 31
      },
      null,
      [-1, -1]
    );
  }
  get cancelDrawing() {
    return this.$$.ctx[29];
  }
  get getDrawingTool() {
    return this.$$.ctx[30];
  }
  get isDrawingEnabled() {
    return this.$$.ctx[31];
  }
}
function Po(e, t, n = 0, o = e.length - 1, s = Rr) {
  for (; o > n; ) {
    if (o - n > 600) {
      const a = o - n + 1, u = t - n + 1, d = Math.log(a), f = 0.5 * Math.exp(2 * d / 3), g = 0.5 * Math.sqrt(d * f * (a - f) / a) * (u - a / 2 < 0 ? -1 : 1), h = Math.max(n, Math.floor(t - u * f / a + g)), p = Math.min(o, Math.floor(t + (a - u) * f / a + g));
      Po(e, t, h, p, s);
    }
    const i = e[t];
    let l = n, r = o;
    for (Qe(e, n, t), s(e[o], i) > 0 && Qe(e, n, o); l < r; ) {
      for (Qe(e, l, r), l++, r--; s(e[l], i) < 0; ) l++;
      for (; s(e[r], i) > 0; ) r--;
    }
    s(e[n], i) === 0 ? Qe(e, n, r) : (r++, Qe(e, r, o)), r <= t && (n = r + 1), t <= r && (o = r - 1);
  }
}
function Qe(e, t, n) {
  const o = e[t];
  e[t] = e[n], e[n] = o;
}
function Rr(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
class Yr {
  constructor(t = 9) {
    this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4)), this.clear();
  }
  all() {
    return this._all(this.data, []);
  }
  search(t) {
    let n = this.data;
    const o = [];
    if (!pt(t, n)) return o;
    const s = this.toBBox, i = [];
    for (; n; ) {
      for (let l = 0; l < n.children.length; l++) {
        const r = n.children[l], a = n.leaf ? s(r) : r;
        pt(t, a) && (n.leaf ? o.push(r) : Kt(t, a) ? this._all(r, o) : i.push(r));
      }
      n = i.pop();
    }
    return o;
  }
  collides(t) {
    let n = this.data;
    if (!pt(t, n)) return !1;
    const o = [];
    for (; n; ) {
      for (let s = 0; s < n.children.length; s++) {
        const i = n.children[s], l = n.leaf ? this.toBBox(i) : i;
        if (pt(t, l)) {
          if (n.leaf || Kt(t, l)) return !0;
          o.push(i);
        }
      }
      n = o.pop();
    }
    return !1;
  }
  load(t) {
    if (!(t && t.length)) return this;
    if (t.length < this._minEntries) {
      for (let o = 0; o < t.length; o++)
        this.insert(t[o]);
      return this;
    }
    let n = this._build(t.slice(), 0, t.length - 1, 0);
    if (!this.data.children.length)
      this.data = n;
    else if (this.data.height === n.height)
      this._splitRoot(this.data, n);
    else {
      if (this.data.height < n.height) {
        const o = this.data;
        this.data = n, n = o;
      }
      this._insert(n, this.data.height - n.height - 1, !0);
    }
    return this;
  }
  insert(t) {
    return t && this._insert(t, this.data.height - 1), this;
  }
  clear() {
    return this.data = Ke([]), this;
  }
  remove(t, n) {
    if (!t) return this;
    let o = this.data;
    const s = this.toBBox(t), i = [], l = [];
    let r, a, u;
    for (; o || i.length; ) {
      if (o || (o = i.pop(), a = i[i.length - 1], r = l.pop(), u = !0), o.leaf) {
        const d = Ur(t, o.children, n);
        if (d !== -1)
          return o.children.splice(d, 1), i.push(o), this._condense(i), this;
      }
      !u && !o.leaf && Kt(o, s) ? (i.push(o), l.push(r), r = 0, a = o, o = o.children[0]) : a ? (r++, o = a.children[r], u = !1) : o = null;
    }
    return this;
  }
  toBBox(t) {
    return t;
  }
  compareMinX(t, n) {
    return t.minX - n.minX;
  }
  compareMinY(t, n) {
    return t.minY - n.minY;
  }
  toJSON() {
    return this.data;
  }
  fromJSON(t) {
    return this.data = t, this;
  }
  _all(t, n) {
    const o = [];
    for (; t; )
      t.leaf ? n.push(...t.children) : o.push(...t.children), t = o.pop();
    return n;
  }
  _build(t, n, o, s) {
    const i = o - n + 1;
    let l = this._maxEntries, r;
    if (i <= l)
      return r = Ke(t.slice(n, o + 1)), ze(r, this.toBBox), r;
    s || (s = Math.ceil(Math.log(i) / Math.log(l)), l = Math.ceil(i / Math.pow(l, s - 1))), r = Ke([]), r.leaf = !1, r.height = s;
    const a = Math.ceil(i / l), u = a * Math.ceil(Math.sqrt(l));
    xn(t, n, o, u, this.compareMinX);
    for (let d = n; d <= o; d += u) {
      const f = Math.min(d + u - 1, o);
      xn(t, d, f, a, this.compareMinY);
      for (let g = d; g <= f; g += a) {
        const h = Math.min(g + a - 1, f);
        r.children.push(this._build(t, g, h, s - 1));
      }
    }
    return ze(r, this.toBBox), r;
  }
  _chooseSubtree(t, n, o, s) {
    for (; s.push(n), !(n.leaf || s.length - 1 === o); ) {
      let i = 1 / 0, l = 1 / 0, r;
      for (let a = 0; a < n.children.length; a++) {
        const u = n.children[a], d = qt(u), f = Hr(t, u) - d;
        f < l ? (l = f, i = d < i ? d : i, r = u) : f === l && d < i && (i = d, r = u);
      }
      n = r || n.children[0];
    }
    return n;
  }
  _insert(t, n, o) {
    const s = o ? t : this.toBBox(t), i = [], l = this._chooseSubtree(s, this.data, n, i);
    for (l.children.push(t), $e(l, s); n >= 0 && i[n].children.length > this._maxEntries; )
      this._split(i, n), n--;
    this._adjustParentBBoxes(s, i, n);
  }
  // split overflowed node into two
  _split(t, n) {
    const o = t[n], s = o.children.length, i = this._minEntries;
    this._chooseSplitAxis(o, i, s);
    const l = this._chooseSplitIndex(o, i, s), r = Ke(o.children.splice(l, o.children.length - l));
    r.height = o.height, r.leaf = o.leaf, ze(o, this.toBBox), ze(r, this.toBBox), n ? t[n - 1].children.push(r) : this._splitRoot(o, r);
  }
  _splitRoot(t, n) {
    this.data = Ke([t, n]), this.data.height = t.height + 1, this.data.leaf = !1, ze(this.data, this.toBBox);
  }
  _chooseSplitIndex(t, n, o) {
    let s, i = 1 / 0, l = 1 / 0;
    for (let r = n; r <= o - n; r++) {
      const a = xe(t, 0, r, this.toBBox), u = xe(t, r, o, this.toBBox), d = Gr(a, u), f = qt(a) + qt(u);
      d < i ? (i = d, s = r, l = f < l ? f : l) : d === i && f < l && (l = f, s = r);
    }
    return s || o - n;
  }
  // sorts node children by the best axis for split
  _chooseSplitAxis(t, n, o) {
    const s = t.leaf ? this.compareMinX : Vr, i = t.leaf ? this.compareMinY : Xr, l = this._allDistMargin(t, n, o, s), r = this._allDistMargin(t, n, o, i);
    l < r && t.children.sort(s);
  }
  // total margin of all possible split distributions where each node is at least m full
  _allDistMargin(t, n, o, s) {
    t.children.sort(s);
    const i = this.toBBox, l = xe(t, 0, n, i), r = xe(t, o - n, o, i);
    let a = mt(l) + mt(r);
    for (let u = n; u < o - n; u++) {
      const d = t.children[u];
      $e(l, t.leaf ? i(d) : d), a += mt(l);
    }
    for (let u = o - n - 1; u >= n; u--) {
      const d = t.children[u];
      $e(r, t.leaf ? i(d) : d), a += mt(r);
    }
    return a;
  }
  _adjustParentBBoxes(t, n, o) {
    for (let s = o; s >= 0; s--)
      $e(n[s], t);
  }
  _condense(t) {
    for (let n = t.length - 1, o; n >= 0; n--)
      t[n].children.length === 0 ? n > 0 ? (o = t[n - 1].children, o.splice(o.indexOf(t[n]), 1)) : this.clear() : ze(t[n], this.toBBox);
  }
}
function Ur(e, t, n) {
  if (!n) return t.indexOf(e);
  for (let o = 0; o < t.length; o++)
    if (n(e, t[o])) return o;
  return -1;
}
function ze(e, t) {
  xe(e, 0, e.children.length, t, e);
}
function xe(e, t, n, o, s) {
  s || (s = Ke(null)), s.minX = 1 / 0, s.minY = 1 / 0, s.maxX = -1 / 0, s.maxY = -1 / 0;
  for (let i = t; i < n; i++) {
    const l = e.children[i];
    $e(s, e.leaf ? o(l) : l);
  }
  return s;
}
function $e(e, t) {
  return e.minX = Math.min(e.minX, t.minX), e.minY = Math.min(e.minY, t.minY), e.maxX = Math.max(e.maxX, t.maxX), e.maxY = Math.max(e.maxY, t.maxY), e;
}
function Vr(e, t) {
  return e.minX - t.minX;
}
function Xr(e, t) {
  return e.minY - t.minY;
}
function qt(e) {
  return (e.maxX - e.minX) * (e.maxY - e.minY);
}
function mt(e) {
  return e.maxX - e.minX + (e.maxY - e.minY);
}
function Hr(e, t) {
  return (Math.max(t.maxX, e.maxX) - Math.min(t.minX, e.minX)) * (Math.max(t.maxY, e.maxY) - Math.min(t.minY, e.minY));
}
function Gr(e, t) {
  const n = Math.max(e.minX, t.minX), o = Math.max(e.minY, t.minY), s = Math.min(e.maxX, t.maxX), i = Math.min(e.maxY, t.maxY);
  return Math.max(0, s - n) * Math.max(0, i - o);
}
function Kt(e, t) {
  return e.minX <= t.minX && e.minY <= t.minY && t.maxX <= e.maxX && t.maxY <= e.maxY;
}
function pt(e, t) {
  return t.minX <= e.maxX && t.minY <= e.maxY && t.maxX >= e.minX && t.maxY >= e.minY;
}
function Ke(e) {
  return {
    children: e,
    height: 1,
    leaf: !0,
    minX: 1 / 0,
    minY: 1 / 0,
    maxX: -1 / 0,
    maxY: -1 / 0
  };
}
function xn(e, t, n, o, s) {
  const i = [t, n];
  for (; i.length; ) {
    if (n = i.pop(), t = i.pop(), n - t <= o) continue;
    const l = t + Math.ceil((n - t) / o / 2) * o;
    Po(e, l, t, n, s), i.push(t, l, l, n);
  }
}
const jr = () => {
  const e = new Yr(), t = /* @__PURE__ */ new Map(), n = () => [...t.values()], o = () => {
    e.clear(), t.clear();
  }, s = (f) => {
    if (!bt(f)) return;
    const { minX: g, minY: h, maxX: p, maxY: y } = f.selector.geometry.bounds, S = { minX: g, minY: h, maxX: p, maxY: y, target: f };
    e.insert(S), t.set(f.annotation, S);
  }, i = (f) => {
    if (!bt(f)) return;
    const g = t.get(f.annotation);
    g && e.remove(g), t.delete(f.annotation);
  };
  return {
    all: n,
    clear: o,
    getAt: (f, g, h = 0) => {
      const y = e.search({
        minX: f - h,
        minY: g - h,
        maxX: f + h,
        maxY: g + h
      }).map((S) => S.target).filter(({ selector: S }) => zo(S, f, g, h));
      return y.length > 0 ? (y.sort((S, w) => Qt(S.selector) - Qt(w.selector)), y) : [];
    },
    getIntersecting: (f, g, h, p) => e.search({
      minX: f,
      minY: g,
      maxX: f + h,
      maxY: g + p
    }).map((y) => y.target),
    insert: s,
    remove: i,
    set: (f, g = !0) => {
      g && o();
      const h = f.reduce((p, y) => {
        if (bt(y)) {
          const { minX: S, minY: w, maxX: A, maxY: _ } = y.selector.geometry.bounds;
          return [...p, { minX: S, minY: w, maxX: A, maxY: _, target: y }];
        } else
          return p;
      }, []);
      h.forEach((p) => t.set(p.target.annotation, p)), e.load(h);
    },
    size: () => e.all().length,
    update: (f, g) => {
      i(f), s(g);
    }
  };
}, Fr = (e) => ({
  ...e,
  subscribe: (n) => {
    const o = (s) => n(s.state);
    return e.observe(o), n(e.all()), () => e.unobserve(o);
  }
}), zr = (e) => {
  const t = Us(), n = jr(), o = Ss(t, e.userSelectAction, e.adapter), s = As(t), i = Gs();
  return t.observe(({ changes: a }) => {
    n.set((a.created || []).map((u) => u.target), !1), (a.deleted || []).forEach((u) => n.remove(u.target)), (a.updated || []).forEach(({ oldValue: u, newValue: d }) => n.update(u.target, d.target));
  }), {
    store: {
      ...t,
      getAt: (a, u, d, f) => {
        const g = n.getAt(a, u, f);
        if (d)
          return g.map((p) => t.getAnnotation(p.annotation)).filter(Boolean).filter(d)[0];
        {
          const h = g[0];
          return h ? t.getAnnotation(h.annotation) : void 0;
        }
      },
      getIntersecting: (a, u, d, f) => n.getIntersecting(a, u, d, f).map((g) => t.getAnnotation(g.annotation)).filter(Boolean)
    },
    selection: o,
    hover: s,
    viewport: i
  };
}, qr = (e) => {
  const t = zr(e);
  return {
    ...t,
    store: Fr(t.store)
  };
}, Kr = (e) => {
  let t, n;
  if (e.nodeName === "CANVAS")
    t = e, n = t.getContext("2d", { willReadFrequently: !0 });
  else {
    const s = e;
    t = document.createElement("canvas"), t.width = s.width, t.height = s.height, n = t.getContext("2d", { willReadFrequently: !0 }), n.drawImage(s, 0, 0, s.width, s.height);
  }
  let o = 0;
  for (let s = 1; s < 10; s++)
    for (let i = 1; i < 10; i++) {
      const l = Math.round(i * t.width / 10), r = Math.round(s * t.height / 10), a = n.getImageData(l, r, 1, 1).data, u = (0.299 * a[0] + 0.587 * a[1] + 0.114 * a[2]) / 255;
      o += u;
    }
  return o / 81;
}, Wr = (e) => {
  const t = Kr(e), n = t > 0.6 ? "dark" : "light";
  return console.log(`[Annotorious] Image brightness: ${t.toFixed(1)}. Setting ${n} theme.`), n;
}, $n = (e, t, n) => t.setAttribute("data-theme", n === "auto" ? Wr(e) : n), Zr = (e, t) => ({
  ...e,
  drawingEnabled: e.drawingEnabled === void 0 ? t.drawingEnabled : e.drawingEnabled,
  drawingMode: e.drawingMode || t.drawingMode,
  userSelectAction: e.userSelectAction || t.userSelectAction,
  theme: e.theme || t.theme
}), eo = typeof navigator > "u" ? !1 : navigator.userAgent.indexOf("Mac OS X") !== -1, Jr = (e, t) => {
  const n = t || document, o = (l) => {
    const r = l;
    r.key === "z" && r.ctrlKey ? e.undo() : r.key === "y" && r.ctrlKey && e.redo();
  }, s = (l) => {
    const r = l;
    r.key === "z" && r.metaKey && (r.shiftKey ? e.redo() : e.undo());
  }, i = () => {
    eo ? n.removeEventListener("keydown", s) : n.removeEventListener("keydown", o);
  };
  return eo ? n.addEventListener("keydown", s) : n.addEventListener("keydown", o), {
    destroy: i
  };
}, rl = (e, t = {}) => {
  if (!e)
    throw "Missing argument: image";
  const n = typeof e == "string" ? document.getElementById(e) : e, o = Zr(t, {
    drawingEnabled: !0,
    drawingMode: "drag",
    userSelectAction: yo.EDIT,
    theme: "light"
  }), s = qr(o), { selection: i, store: l } = s, r = Hs(l, o.initialHistory), a = js(
    s,
    r,
    o.adapter,
    o.autoSave
  ), u = document.createElement("DIV");
  u.style.position = "relative", u.style.display = "inline-block", n.style.display = "block", n.parentNode.insertBefore(u, n), u.appendChild(n);
  const d = Jr(r);
  let f = Qs();
  $n(n, u, o.theme);
  const g = new Br({
    target: u,
    props: {
      drawingEnabled: !!o.drawingEnabled,
      image: n,
      preferredDrawingMode: o.drawingMode,
      state: s,
      style: o.style,
      user: f
    }
  });
  g.$on("click", (E) => {
    const { originalEvent: m, annotation: b } = E.detail;
    b ? i.userSelect(b.id, m) : i.isEmpty() || i.clear();
  });
  const h = zs(s, r, o.adapter), p = () => g.cancelDrawing(), y = () => {
    g.$destroy(), u.parentNode.insertBefore(n, u), u.parentNode.removeChild(u), d.destroy(), r.destroy();
  }, S = () => g.getDrawingTool(), w = () => f, A = () => g.isDrawingEnabled(), _ = (E, m, b) => tr(E, m, b), k = (E, m) => Gi(E, m), P = (E) => {
    if (!Mo(E))
      throw `No drawing tool named ${E}`;
    g.$set({ toolName: E });
  }, C = (E) => g.$set({ drawingEnabled: E }), T = (E) => g.$set({ preferredDrawingMode: E }), Y = (E) => {
    console.warn("Filter not implemented yet");
  }, D = (E) => g.$set({ style: E }), x = (E) => $n(n, u, E), j = (E) => {
    f = E, g.$set({ user: E });
  }, v = (E) => (
    // @ts-ignore
    g.$set({ visible: E })
  );
  return {
    ...h,
    cancelDrawing: p,
    destroy: y,
    getDrawingTool: S,
    getUser: w,
    isDrawingEnabled: A,
    listDrawingTools: ko,
    on: a.on,
    off: a.off,
    registerDrawingTool: _,
    registerShapeEditor: k,
    setDrawingEnabled: C,
    setDrawingMode: T,
    setDrawingTool: P,
    setFilter: Y,
    setStyle: D,
    setTheme: x,
    setUser: j,
    setVisible: v,
    element: u,
    state: s
  };
};
export {
  nn as Editor,
  Fi as EditorMount,
  Ve as Handle,
  il as IdentityTransform,
  vo as MidpointHandle,
  Si as PolygonEditor,
  Oi as RectangleEditor,
  es as RectangleUtil,
  Zi as RubberbandRectangle,
  Br as SVGAnnotationLayer,
  Q as ShapeType,
  qi as ToolMount,
  yo as UserSelectAction,
  sl as W3CImageFormat,
  Sr as addEventListeners,
  xt as approximateAsPolygon,
  wt as boundsFromMultiPolygonElements,
  fe as boundsFromPoints,
  nl as chainStyles,
  Qt as computeArea,
  vt as computePolygonArea,
  ho as computeSVGPath,
  tl as computeStyle,
  el as createBody,
  rl as createImageAnnotator,
  zr as createImageAnnotatorState,
  vr as createSVGTransform,
  qr as createSvelteImageAnnotatorState,
  ol as defaultColorProvider,
  Wr as detectTheme,
  yt as distance,
  ri as enableResponsive,
  Zr as fillDefaults,
  Jo as getAllCorners,
  Hi as getEditor,
  kt as getMaskDimensions,
  To as getSVGPoint,
  Mo as getTool,
  Jr as initKeyboardCommands,
  zo as intersects,
  ts as isFragmentSelector,
  St as isImageAnnotation,
  bt as isImageAnnotationTarget,
  eo as isMac,
  At as isPointInPolygon,
  Le as isTouch,
  ko as listDrawingTools,
  Pe as multipolygonElementToPath,
  ns as parseFragmentSelector,
  hs as parseSVGSelector,
  ni as parseW3CImageAnnotation,
  qo as pointsToPath,
  Gi as registerEditor,
  Je as registerShapeUtil,
  tr as registerTool,
  Kr as sampleBrightness,
  os as serializeFragmentSelector,
  ps as serializeSVGSelector,
  oi as serializeW3CImageAnnotation,
  $n as setTheme,
  xr as simplifyMultiPolygon,
  fo as simplifyPoints,
  $r as simplifyPolygon,
  Fr as toSvelteStore
};
//# sourceMappingURL=annotorious.es.js.map
